import React, { useState, useEffect, useRef }  from 'react';
import './NkabPro.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faChevronDown, faChevronUp, faExchangeAlt, faEye, faEyeSlash, faKey, faListAlt, faMapMarkedAlt, faMoneyBill, faPhoneAlt, faPlusCircle, faPowerOff, faSignInAlt, faSignOutAlt, faUser, faUserAlt, faUserEdit } from '@fortawesome/free-solid-svg-icons';
import ReactSwitch from 'react-switch';
import coinGecko from '../api/coinGecko';
import axios from 'axios';
import { uid } from 'uid';
import SmsFailedIcon from '@mui/icons-material/SmsFailed';
import { Alert, AppBar, Avatar, Box, Button, Card, CardActions, CardContent, Container, FormControl, FormControlLabel, FormGroup, FormLabel, Grid, IconButton, InputAdornment, ListItemIcon, Menu, MenuItem, OutlinedInput, Paper, Radio, RadioGroup, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Toolbar, Tooltip, Typography } from '@mui/material';
import { Logout, Visibility, VisibilityOff } from '@mui/icons-material';
import { Table } from 'react-bootstrap';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import UploadWidget from '../components/UploadWidget';
import NavbarOn from '../components/NavbarOn';
// import NavbarOn from '../components/NavbarOn';
import MenuIcon from '@mui/icons-material/Menu';
import LightModeIcon from '@mui/icons-material/LightMode';
import BedtimeIcon from '@mui/icons-material/Bedtime';
import Footer from '../components/Footer';
import Banner from '../components/Banner';
import NumbersStatus from '../components/NumbersStatus';
import Variations from '../components/Variations';
import SupportCommunity from '../components/SupportCommunity';



const NkabPro = (props) => {

    const transActivated         = localStorage.getItem('transActivated')
    const operatorUserInfoPhone  = localStorage.getItem('operatorUserInfoPhone')
    const userPhone              = localStorage.getItem('userPhone')
    const userEmail              = localStorage.getItem('userEmail')
    const Logged                 = localStorage.getItem('userStatus')
    const r_opsd                 = localStorage.getItem("r_opsd")
    const t_opsd                 = localStorage.getItem("t_opsd")
    const b_opsd                 = localStorage.getItem("b_opsd")
    const userID                 = localStorage.getItem('userID')
    var   _ProWallet             = localStorage.getItem('_ProWallet')
    var   _options               = localStorage.getItem("_options")
    var   isRActive              = localStorage.getItem("isRActive")
    const moneyImage             = localStorage.getItem("moneyImage")
    const moneyName              = localStorage.getItem("moneyName")
    const banqueImage            = localStorage.getItem("banqueImage")
    const banqueName             = localStorage.getItem("banqueName")
    const changeImage            = localStorage.getItem("changeImage")
    const changeName             = localStorage.getItem("changeName")
    const banqueClickedName      = localStorage.getItem("banqueClickedName")
    const userLastName           = localStorage.getItem("userLastName")
    const userName               = localStorage.getItem("userName")
    const nkab_trans_reference   = localStorage.getItem("nkab_trans_reference")
    const nkab_rge_reference     = localStorage.getItem("nkab_rge_reference")
    const nkab_trans_id          = localStorage.getItem("nkab_trans_id")
    const nkab_rge_id            = localStorage.getItem("nkab_rge_id")
    const LastStatus             = localStorage.getItem("LastStatus")
    const amount                 = localStorage.getItem("amount")
    const phone                  = localStorage.getItem("phone")
    const buy_sop                = localStorage.getItem("buy_sop")
    const trans_sop              = localStorage.getItem("trans_sop")
    const rch_sop                = localStorage.getItem("rch_sop")


    const [CodePin,                 setCodePin                  ] = useState()
    const [Montant,                 setMontant                  ] = useState(0)
    const [Currency,                setCurrency                 ] = useState(0)
    const [Adress,                  setAdress                   ] = useState()
    const [Phone,                   setPhone                    ] = useState("")
    const [AountName,               setAountName                ] = useState("")
    const [AcountCredName,          setAcountCredName           ] = useState("")
    const [ServiceBankName,         setServiceBankName          ] = useState("")
    const [RDV,                     setRDV                      ] = useState()
    const [Times,                   setTimes                    ] = useState()
    const [PassConfirmed,           setPassConfirmed            ] = useState("")
    const [PassCodeConfirmed,       setPassCodeConfirmed        ] = useState("")
    const [BankOptionClicked1,      setBankOptionClicked1       ] = useState("")
    const [BankOptionClicked2,      setBankOptionClicked2       ] = useState("")
    const [BankOptionClicked3,      setBankOptionClicked3       ] = useState("")
    const [BankOptionClicked4,      setBankOptionClicked4       ] = useState("")
    const [Options,                 setOptions                  ] = useState(`${!_options?"ACHAT":_options}`)
    const [Optionsb,                setOptionsb                 ] = useState("")
    const [CurrencyStatus,          setCurrencyStatus           ] = useState(false)
    const [ChangeStatus,            setChangeStatus             ] = useState(false)
    const [BanqueStatus,            setBanqueStatus             ] = useState(false)
    const [DangerControler,         setDangerControler          ] = useState(false)
    const [PassCode,                setPassCode                 ] = useState(false)
    const [Profil,                  setProfil                   ] = useState(false)
    const [Operations,              setOperations               ] = useState(false)
    const [passwordType,            setPasswordType             ] = useState("password")
    const [passwordInput,           setPasswordInput            ] = useState("")
    const [passwordTypeConfirm,     setPasswordTypeConfirm      ] = useState("password")
    const [passwordConfirmInput,    setPasswordConfirmInput     ] = useState("")
    const [coins,                   setCoins                    ] = useState([])
    const [coins2,                  setCoins2                   ] = useState([])
    const [Listing,                 setListing                  ] = useState(false)
    const [SeeDoc,                  setSeeDoc                   ] = useState(false)
    const [RechargeData,            setRechargeData             ] = useState([])
    const [TransData,               setTransData                ] = useState([])
    const [BuyData,                 setBuyData                  ] = useState([])
    const [PCodes,                  setPCodes                   ] = useState([])
    const [RechargeListings,        setRechargeListings         ] = useState(false)
    const [TransfertListings,       setTransfertListings        ] = useState(false)
    const [BuyListings,             setBuyListings              ] = useState(false)
    const [Wallets,                 setWallets                  ] = useState([])
    const [RechargeWallets,         setRechargeWallets          ] = useState([])
    const [BuyingWallets,           setBuyingWallets            ] = useState([])
    const [TransWallets,            setTransWallets             ] = useState([])
    const [PremiumsWallets,         setPremiumsWallets       ] = useState([])
    const [NewCodeConfirmed,        setNewCodeConfirmed         ] = useState()
    const [MyCodePin,               setMyCodePin                ] = useState([])
    const [MyCodePinID,             setMyCodePinID              ] = useState([])
    const [NetAddress,              setNetAddress               ] = useState("...")
    const [AddressCkecked,          setAddressCkecked           ] = useState(false)
    const [MySuccess,               setMySuccess                ] = useState("")
    const [Loader,                  setLoader                   ] = useState(false)
    const [SeePrice,                setSeePrice                 ] = useState(false)
    const [CurrencyChecked,         setCurrencyChecked          ] = useState([])
    const [CurrencyCheckedContent,  setCurrencyCheckedContent   ] = useState([])
    const [CurrencyCheckedSymbol,   setCurrencyCheckedSymbol    ] = useState("")
    const [CurrencyChecked2,        setCurrencyChecked2         ] = useState([])
    const [CurrencyCheckedContent2, setCurrencyCheckedContent2  ] = useState([])
    const [CurrencyCheckedSymbol2,  setCurrencyCheckedSymbol2   ] = useState("")
    const [Faq0,                    setFaq0                     ] = useState(false)
    const [Faq1,                    setFaq1                     ] = useState(false)
    const [Faq2,                    setFaq2                     ] = useState(false)
    const [Faq3,                    setFaq3                     ] = useState(false)
    const [Faq4,                    setFaq4                     ] = useState(false)
    const [Faq5,                    setFaq5                     ] = useState(false)
    const [isActive,                setActive                   ] = useState(false)
    const [GetUser,                 setGetUser                  ] = useState([])
    const [User,                    setUser                     ] = useState([])
    const [checked,                 setChecked                  ] = useState(true)
    const [CodeSecret,              setCodeSecret               ] = useState("")
    const [BuySuccess,              setBuySuccess               ] = useState(false)
    const [BuyFailed,               setBuyFailed                ] = useState(false)
    const [TransSuccess,            setTransSuccess             ] = useState(false)
    const [TransFailed,             setTransFailed              ] = useState(false)
    const [PaymentSuccess,          setPaymentSuccess           ] = useState(false)
    const [PaymentFailed,           setPaymentFailed            ] = useState(false)
    const [NKABCFA,                 setNKABCFA                  ] = useState("")
    const [NKABCONVERTED,           setNKABCONVERTED            ] = useState("")



    const [BNBProRateStop, setBNBProRateStop] = useState(false)
    const [NT_ProrateBNB, setNT_ProrateBNB] = useState([])

    const [BTCProRateStop, setBTCProRateStop] = useState(false)
    const [NT_ProrateBTC, setNT_ProrateBTC] = useState([])

    const [TRONProRateStop, setTRONProRateStop] = useState(false)
    const [NT_ProrateTRON, setNT_ProrateTRON] = useState([])

    const [USDTProRateStop, setUSDTProRateStop] = useState(false)
    const [NT_ProrateUSDT, setNT_ProrateUSDT] = useState([])

    const [LINKProRateStop, setLINKProRateStop] = useState(false)
    const [NT_ProrateLINK, setNT_ProrateLINK] = useState([])

    const [MATICProRateStop, setMATICProRateStop] = useState(false)
    const [NT_ProrateMATIC, setNT_ProrateMATIC] = useState([])

    const [DOTEProRateStop, setDOTEProRateStop] = useState(false)
    const [NT_ProrateDOTE, setNT_ProrateDOTE] = useState([])

    const [BUSDProRateStop, setBUSDProRateStop] = useState(false)
    const [NT_ProrateBUSD, setNT_ProrateBUSD] = useState([])

    const [PMProRateStop, setPMProRateStop] = useState(false)
    const [NT_ProratePM, setNT_ProratePM] = useState([])

    const [SOLProRateStop, setSOLProRateStop] = useState(false)
    const [NT_ProrateSOL, setNT_ProrateSOL] = useState([])

    const [ADAProRateStop, setADAProRateStop] = useState(false)
    const [NT_ProrateADA, setNT_ProrateADA] = useState([])

    const [ETHProRateStop, setETHProRateStop] = useState(false)
    const [NT_ProrateETH, setNT_ProrateETH] = useState([])

    const [SHIBAProRateStop, setSHIBAProRateStop] = useState(false)
    const [NT_ProrateSHIBA, setNT_ProrateSHIBA] = useState([])

    const [DOGEProRateStop, setDOGEProRateStop] = useState(false)
    const [NT_ProrateDOGE, setNT_ProrateDOGE] = useState([])

    const [LTCProRateStop, setLTCProRateStop] = useState(false)
    const [NT_ProrateLTC, setNT_ProrateLTC] = useState([])

    const [showPassword, setShowPassword] = useState(false);
    const [DetailData, setDetailData] = useState([]);
    const [RF, setRF] = useState([]);
  
    const [counter, setCounter] = useState(30);
    const [StopOperation, setStopOperation] = useState(false)

    const LineLink = true
    // const LineLink = false

    const SenderCountry = localStorage.getItem('SenderCountry')
    
    const seeMoreItemsHandler = () =>{
      setStopOperation(false)
      setCounter(counter + 10);
    }

    useEffect(()=>{
        const fetchRFData = async () => {
            if(!StopOperation){
                try {
                    const res = await axios.get('api/v1/all-p-op')
                    if(res.data.length > 0 && userID){
                      const ResFilted = res.data.filter((items) => {
                        return items.userId === Number(userID)
                      })
                            
                      if(ResFilted.length > 0 && counter === 0){
                      
                        const items = ResFilted.slice(0, 30)
                    
                        if(items.length > 0){
                          setRF(items)
                          setStopOperation(true)
                        }
                    
                      } else if(ResFilted.length > 0 && counter > 0){
                    
                        const items = ResFilted.slice(0, counter)
                    
                        if(items.length > 0){
                          setRF(items)
                          setStopOperation(true)
                        }
                      }
                    }
                } catch (error) { }
            }
        }
        fetchRFData()
  
    },[userID, counter, StopOperation])

    const _ci       = "Côte d'Ivoire"
    const _sen      = "Sénégal"
    const _burk     = "Burkina Faso"
    const _benin    = "Bénin"
    const _togo     = "Togo"
    const _mali     = "Mali"
    const _niger    = "Niger"

    const INIT = { montant: 0, converted: 0, cfa: 0, dollar: 0 }
    const [exchange, setExchange] = useState(INIT)
  
    useEffect(()=>{

        if(Logged === 'Logged'){
            if(_ProWallet === "false"){

                if(LineLink){
                  window.location.replace("https://nkab-exchange.net/sell-or-buy-crypto");
                } else {
                   window.location.replace("http://localhost:3000/sell-or-buy-crypto");
                }
            }
        }

        if(Logged === 'Logout'){

            if(LineLink){
              window.location.replace("https://nkab-exchange.net/login");
            } else {
               window.location.replace("http://localhost:3000/login");
            }
        }
  
    },[Logged, props.history, _ProWallet, LineLink])

    useEffect(() => {
        if(r_opsd === "true" || t_opsd === "true" || b_opsd === "true"){
            setActive(true)
        }
    }, [r_opsd,t_opsd,b_opsd])
  
    const handleCloser = () => {
        setLoader(false)
        localStorage.setItem("r_opsd",false)
        localStorage.setItem("t_opsd",false)
        localStorage.setItem("b_opsd",false)
        setActive(false)
        setStatus1(STATUS.STOPPED)
    };

    const STATUS = { STARTED: 'Traitement en cours...', }

    useEffect(()=>{
        if(r_opsd === "true" || t_opsd === "true" || b_opsd === "true"){
            setStatus(STATUS.STARTED)
        }
    },[r_opsd,t_opsd,b_opsd,STATUS.STARTED])

    const INITIAL_COUNT1 = 3600

    const [secondsRemaining1, setSecondsRemaining1] = useState(INITIAL_COUNT1)
    const [status1, setStatus1] = useState(STATUS.STOPPED)

    const INITIAL_COUNT = 600
  
    const [secondsRemaining, setSecondsRemaining] = useState(INITIAL_COUNT)
    const [status, setStatus] = useState(STATUS.STOPPED)
    const [statusCount, setStatusCount] = useState()
  
    const secondsToDisplay = secondsRemaining % 60
    const minutesRemaining = (secondsRemaining - secondsToDisplay) / 60

    const[last_cfa_char_nbr, setLast_cfa_char_nbr] = useState()
    const [total,setTotal] = useState()

    useEffect(()=>{
        setStatus1(STATUS.STARTED)
    },[STATUS.STARTED])
    
    useEffect(()=>{

        if(secondsRemaining1 > 0){
          setTotal(secondsRemaining1)
          const cfa_nbr = total
          if(cfa_nbr){
            const cfa_nbr_to_text = cfa_nbr.toString()
            const cfa_nbr_last_char = cfa_nbr_to_text.slice(-2)
            setLast_cfa_char_nbr(Number(cfa_nbr_last_char))
          }
        }

      },[secondsRemaining1, total])

      useEffect(() => {
        setStatusCount(twoDigits(secondsRemaining))
      }, [secondsRemaining, statusCount])

      useInterval(
          () => {
          if (secondsRemaining > 0) {
              setSecondsRemaining(secondsRemaining - 1)
          } else {
              setStatus(STATUS.STOPPED)
          }
          if (secondsRemaining1 > 0) {
              setSecondsRemaining1(secondsRemaining1 - 1)
          } else {
              setStatus1(STATUS.STOPPED)
          }
          },
  
          status === STATUS.STARTED ? 1000 : null,
  
          status1 === STATUS.STARTED ? 1000 : null,
          // passing null stops the interval
      )

      function useInterval(callback, delay) {
          const savedCallback = useRef()
  
          // Remember the latest callback.
          useEffect(() => {
          savedCallback.current = callback
          }, [callback])
  
      // Set up the interval.
      useEffect(() => {
        function tick() {
          savedCallback.current()
        }
        if (delay !== null) {
          let id = setInterval(tick, delay)
          return () => clearInterval(id)
        }
      }, [delay])
      }

    const twoDigits = (num) => String(num).padStart(2, '0')
  
    const handleCloser2 = () => { localStorage.setItem('isRActive', false)};

    const [isMenuVisible, setMenuVisibility] = useState(true);
    const [prevScrollPos, setPrevScrollPos] = useState(window.pageYOffset);

    const handleScroll = () => {
        const currentScrollPos = window.pageYOffset;
        const isVisible = prevScrollPos > currentScrollPos;
    
        setMenuVisibility(isVisible);
        setPrevScrollPos(currentScrollPos);
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
    
        return () => {
          window.removeEventListener('scroll', handleScroll);
        };
      }, [prevScrollPos]);



  const STATUS2 = {
    STARTED2: 'Traitement en cours...',
    }
  
    const INITIAL_COUNT2 = 35
    const [secondsRemaining2, setSecondsRemaining2] = useState(INITIAL_COUNT2)
    const [status2,           setStatus2          ] = useState(STATUS2.STOPPED2)

    useEffect(()=>{
        setStatus2(STATUS2.STARTED2)
        if (secondsRemaining2 === 0){
            setSecondsRemaining2(INITIAL_COUNT2)
        }
    },[secondsRemaining2, STATUS2.STARTED2, INITIAL_COUNT2])
  
    useInterval(
    () => {
    if (secondsRemaining2 > 0) {
        setSecondsRemaining2(secondsRemaining2 - 1)
    } else {
        setStatus2(STATUS2.STOPPED2)
    }
    },

    status2 === STATUS2.STARTED2 ? 1000 : null,
    // passing null stops the interval
    )


    useEffect(() => {
  
      const fetchDada12 = async () => {
        try {
          const { data } = await axios.get('/api/v1/get-users')
          setGetUser(data)
        } catch (error) { }
      }
      fetchDada12()
  
    }, [])
  
    useEffect(() => {
  
      if (GetUser && userID) {
        const userGetted = GetUser.filter((obj) => {
          return obj.ID === Number(userID)
        })
        if(userGetted.length > 0){
            setUser(userGetted[0])
        }
      }
  
    }, [GetUser, userID, User])

    const [MerchantId, setMerchantId] = useState("")
    const [MerchantIdKey, setMerchantIdKey] = useState("")
    const [PayInRate, setPayInRate] = useState([])
    const [PayOutRate, setPayOutRate] = useState([])

    const ci = "Côte d'Ivoire"
    const sen = "Sénégal"
    const burk = "Burkina Fasso"
    const benin = "Bénin"
    const togo = "Togo"
    const mali = "Mali"
    const niger = "Niger"
    const cam = "Cameroun"
    const guinee = "Guinée"


    // PAY-OUT
  
    const ciRateOUT = [{
        // orange: 0.01, //"1.00%",
        // moov: 0.01, //"1.00%",
        // mtn: 0.01, //"1.00%",
        // wave: 0.01, //"1.00%"

        orange: 0.04, //"4%",
        moov: 0.04, //"4%",
        mtn: 0.04, //"4%",
        wave: 0.04, //"4%"
    }]
  
    const senRateOUT = [{
    //   orange: 0.015, //"1.50%",
    //   freeMoney: 0.01, //"1.00%",
    //   wave: 0.02, //"2.00%"

      orange: 0.04, //"4%",
      freeMoney: 0.03, //"3.00%",
      wave: 0.045, //"4.50%"
    }]
  
    const maliRateOUT = [{
    //   orange: 0.015, //"1.50%",
    //   mobyCash: 0.015, //"1.50%",

      orange: 0.04, //"4%",
      mobyCash: 0.04, //"4%",
    }]
  
    const bfRateOUT = [{
      orange: 0.04, //"4%",
      mobyCash: 0.04, //"4%",
    }]
  
    const camRateOUT = [{
      orange: 0.04, //"4%",
      mtn: 0.04, //"4%",
    }]
  
    const guineeRateOUT = [{
      orange: 0.04, //"4%",
      mtn: 0.04, //"4%",
    }]
  
    const beninRateOUT = [{
      moov: 0.04, //"4%",
      mtn: 0.04, //"4%",
    }]
  
    const togoRateOUT = [{
      moov: 0.04, //"4%",
      tmoney: 0.04, //"4%",
    }]
  
  
  
    // PAY-IN
  
    const ciRateIN = [{
        // orange: 0.015, //"1.50%",
        // moov: 0.01, //"1%",
        // mtn: 0.02, //"2%",
        // wave: 0.01, //"1%"

        orange: 0.0225, //"2.25%",
        moov: 0.0225, //"2.25%",
        mtn: 0.0225, //"2.25%",
        wave: 0.02, //"2.0%"
    }]
  
    const senRateIN = [{
    //   orange: 0.015, //"1.50%",
    //   freeMoney: 0.015, //"1.50%",
    //   wave: 0.02, //"2.00%"

      orange: 0.025, //"2.50%",
      freeMoney: 0.025, //"2.50%",
      wave: 0.03, //"3%"
    }]
  
    const maliRateIN = [{
    //   orange: 0.02, //"2.00%",
    //   mobyCash: 0.02, //"2.00%",

      orange: 0.03, //"3%",
      mobyCash: 0.03, //"3%",
    }]
  
    const bfRateIN = [{
    //   orange: 0.025, //"2.50%",
    //   mobyCash: 0.025, //"2.50%",

      orange: 0.035, //"3.50%",
      mobyCash: 0.035, //"3.50%",
    }]
  
    const camRateIN = [{
    //   orange: 0.025, //"2.50%",
    //   mtn: 0.025, //"2.50%",

      orange: 0.035, //"3.50%",
      mtn: 0.035, //"3.50%",
    }]
  
    const guineeRateIN = [{
    //   orange: 0.0375, //"3.75%",
    //   mtn: 0.025, //"2.50%",

      orange: 0.0475, //"4.75%",
      mtn: 0.035, //"3.50%",
    }]
  
    const beninRateIN = [{
    //   moov: 0.02, //"2.00%",
    //   mtn: 0.02, //"2.00%",

      moov: 0.03, //"3.00%",
      mtn: 0.03, //"3.00%",
    }]
  
    const togoRateIN = [{
    //   moov: 0.045, //"4.50%",
    //   togocel: 0.045, //"4.50%",

      moov: 0.055, //"5.50%",
      togocel: 0.055, //"5.50%",
    }]


    useEffect(()=>{
        if(banqueName){
            if(SenderCountry === ci){

                setMerchantId("o3XPUfGPrmspx4AQoWLmr")
                setMerchantIdKey("sk_AOoWaEk0oXP1ldYEy5qdB5UnCVPu0lrl")

                if(banqueName === "Orange"){
                    setPayInRate(ciRateIN[0].orange)
                }

                if(banqueName === "mtn"){
                    setPayInRate(ciRateIN[0].mtn)
                }

                if(banqueName === "Moov"){
                    setPayInRate(ciRateIN[0].moov)
                }

                if(banqueName === "Wave"){
                    setPayInRate(ciRateIN[0].wave)
                }
            }
            if(SenderCountry === togo){

                setMerchantId("Ee9HM0SbkkPpmvpY8iJXa")
                setMerchantIdKey("sk_HSWq5h91I0E7sVSxXOACPBbMILX6Qq61")

                if(banqueName === "Moov"){
                    setPayInRate(togoRateIN[0].moov)
                }
            }
            if(SenderCountry === burk){
                setMerchantId("4eEdWoS5T2UiPkEdsO7Zt")
                setMerchantIdKey("sk_yEvF54xNdflGibQpzVMLfAl7Iu6twdfO")

                if(banqueName === "Orange"){
                    setPayInRate(bfRateIN[0].orange)
                }
            }
            if(SenderCountry === mali){
                setMerchantId("dNoKavNhtMQaNZTSCJa4s")
                setMerchantIdKey("sk_VMctIMcIRcAfPuzZxoc4r9TbStp7rNnG")

                if(banqueName === "Orange"){
                    setPayInRate(maliRateIN[0].orange)
                }
            }
            if(SenderCountry === sen){
                setMerchantId("EF0esPiIBKxkdZcSwERyw")
                setMerchantIdKey("sk_7UiOwbEogK6QEv0Blm7T3XXQv2gzOq8M")

                if(banqueName === "Orange"){
                    setPayInRate(senRateIN[0].orange)
                }

                if(banqueName === "Wave"){
                    setPayInRate(senRateIN[0].wave)
                }
            }
            if(SenderCountry === cam){
                setMerchantId("BguxmE4b9kYYCn86IUCPZ")
                setMerchantIdKey("sk_TUuDIbxLurPIKD2yPpvuMfocp2h8bTEy")

                if(banqueName === "Orange"){
                    setPayInRate(camRateIN[0].orange)
                }

                if(banqueName === "mtn"){
                    setPayInRate(camRateIN[0].mtn)
                }
            }
            if(SenderCountry === benin){
                setMerchantId("Bbqyg6WMe4MZALrTbVsKc")
                setMerchantIdKey("sk_VkKDUSWRpN7rLvQgcGvr6Rq4LHqvudth")

                if(banqueName === "mtn"){
                    setPayInRate(beninRateIN[0].mtn)
                }

                if(banqueName === "Moov"){
                    setPayInRate(beninRateIN[0].moov)
                }
            }
            if(SenderCountry === guinee){
                setMerchantId("sYSJyhGpeOXb95iO7WOlh")
                setMerchantIdKey("sk_JIO1fgAmaVb9i7wGUrYA9tQDDjYVoiiU")

                if(banqueName === "Orange"){
                    setPayInRate(guineeRateIN[0].orange)
                }

                if(banqueName === "mtn"){
                    setPayInRate(guineeRateIN[0].mtn)
                }
            }
        }
    },[
        SenderCountry,
        PayInRate,  
        banqueName,
        beninRateIN,
        bfRateIN,
        camRateIN,
        changeName,
        ciRateIN,
        guineeRateIN,
        maliRateIN,
        senRateIN,
        togoRateIN,

    ])


    useEffect(()=>{
        if(changeName){
            if(SenderCountry === ci){

                setMerchantId("o3XPUfGPrmspx4AQoWLmr")
                setMerchantIdKey("sk_AOoWaEk0oXP1ldYEy5qdB5UnCVPu0lrl")

                if(changeName === "Orange"){
                    setPayOutRate(ciRateOUT[0].orange)
                }

                if(changeName === "mtn"){
                    setPayOutRate(ciRateOUT[0].mtn)
                }

                if(changeName === "Moov"){
                    setPayOutRate(ciRateOUT[0].moov)
                }

                if(changeName === "Wave"){
                    setPayOutRate(ciRateOUT[0].wave)
                }
            }
            if(SenderCountry === togo){

                setMerchantId("Ee9HM0SbkkPpmvpY8iJXa")
                setMerchantIdKey("sk_HSWq5h91I0E7sVSxXOACPBbMILX6Qq61")

                if(changeName === "Moov"){
                    setPayOutRate(togoRateOUT[0].moov)
                }
            }
            if(SenderCountry === burk){
                setMerchantId("4eEdWoS5T2UiPkEdsO7Zt")
                setMerchantIdKey("sk_yEvF54xNdflGibQpzVMLfAl7Iu6twdfO")

                if(changeName === "Orange"){
                    setPayOutRate(bfRateOUT[0].orange)
                }
            }
            if(SenderCountry === mali){
                setMerchantId("dNoKavNhtMQaNZTSCJa4s")
                setMerchantIdKey("sk_VMctIMcIRcAfPuzZxoc4r9TbStp7rNnG")

                if(changeName === "Orange"){
                    setPayOutRate(maliRateOUT[0].orange)
                }
            }
            if(SenderCountry === sen){
                setMerchantId("EF0esPiIBKxkdZcSwERyw")
                setMerchantIdKey("sk_7UiOwbEogK6QEv0Blm7T3XXQv2gzOq8M")

                if(changeName === "Orange"){
                    setPayOutRate(senRateOUT[0].orange)
                }

                if(changeName === "Wave"){
                    setPayOutRate(senRateOUT[0].wave)
                }
            }
            if(SenderCountry === cam){
                setMerchantId("BguxmE4b9kYYCn86IUCPZ")
                setMerchantIdKey("sk_TUuDIbxLurPIKD2yPpvuMfocp2h8bTEy")

                if(changeName === "Orange"){
                    setPayOutRate(camRateOUT[0].orange)
                }

                if(changeName === "mtn"){
                    setPayOutRate(camRateOUT[0].mtn)
                }
            }
            if(SenderCountry === benin){
                setMerchantId("Bbqyg6WMe4MZALrTbVsKc")
                setMerchantIdKey("sk_VkKDUSWRpN7rLvQgcGvr6Rq4LHqvudth")

                if(changeName === "mtn"){
                    setPayOutRate(beninRateOUT[0].mtn)
                }

                if(changeName === "Moov"){
                    setPayOutRate(beninRateOUT[0].moov)
                }
            }
            if(SenderCountry === guinee){
                setMerchantId("sYSJyhGpeOXb95iO7WOlh")
                setMerchantIdKey("sk_JIO1fgAmaVb9i7wGUrYA9tQDDjYVoiiU")

                if(changeName === "Orange"){
                    setPayOutRate(guineeRateOUT[0].orange)
                }

                if(changeName === "mtn"){
                    setPayOutRate(guineeRateOUT[0].mtn)
                }
            }
        }
    },[
        SenderCountry, 
        PayOutRate, 
        changeName,
        beninRateOUT,
        bfRateOUT,
        camRateOUT,
        ciRateOUT,
        guineeRateOUT,
        maliRateOUT,
        senRateOUT,
        togoRateOUT,

    ])

    const toogleHandleChange = (val) => {
        localStorage.setItem("_ProWallet", false)
        localStorage.setItem("transActivated", true)
        setChecked(val)
        localStorage.setItem("isRActive",false)
    }
    
    const wavePaymentLink = 'https://pay.wave.com/m/M_DyjfDYDUCSym/c/ci/'

    useEffect(()=>{
      const fetchDada = async () => {
        const response = await coinGecko.get('/coins/markets', {
          params: {
            vs_currency: 'usd',
            ids:
              'bitcoin,litecoin,binancecoin,eos,ethereum,iota,ripple,stellar,tether,dogecoin,tron,binance-usd,shiba-inu,matic-network,chainlink,polkadot,cardano,solana',
          },
        })
        setCoins(response.data)
      }
      fetchDada()
      
      const fetchDada2 = async () => {

        const response = await coinGecko.get('/coins/markets', {
          params: {
            vs_currency: 'usd',
            ids:
              'bitcoin,litecoin,tether,dogecoin,tron,binance-usd',
          },
        })
        setCoins2(response.data)
      }
      fetchDada2()
    },[])

  const [BNBStop, setBNBStop] = useState(false)
  const [BSCprice, setBSCprice] = useState([])

  const [BTCStop, setBTCStop] = useState(false)
  const [BTCprice, setBTCprice] = useState([])

  const [TRONStop, setTRONStop] = useState(false)
  const [TRONprice, setTRONprice] = useState([])

  const [USDTStop, setUSDTStop] = useState(false)
  const [USDTprice, setUSDTprice] = useState([])

  const [LINKStop, setLINKStop] = useState(false)
  const [CHAINLINKprice, setCHAINLINKprice] = useState([])

  const [MATICStop, setMATICStop] = useState(false)
  const [POLYGONMATICprice, setPOLYGONMATICprice] = useState([])

  const [DOTEStop, setDOTEStop] = useState(false)
  const [POKADOTprice, setPOKADOTprice] = useState([])

  const [BUSDStop, setBUSDStop] = useState(false)
  const [BUSDprice, setBUSDprice] = useState([])

  const [SOLStop, setSOLStop] = useState(false)
  const [SOLANAprice, setSOLANAprice] = useState([])

  const [ADAStop, setADAStop] = useState(false)
  const [CARDANOprice, setCARDANOprice] = useState([])

  const [SHIBAStop, setSHIBAStop] = useState(false)
  const [SHIBAprice, setSHIBAprice] = useState([])

  const [DOGEStop, setDOGEStop] = useState(false)
  const [DOGEprice, setDOGEprice] = useState([])

  const [LTCStop, setLTCStop] = useState(false)
  const [LTCprice, setLTCprice] = useState([])

  const [PMStop, setPMStop] = useState(false)
  const [PMprice, setPMprice] = useState([])

  const [ETHStop, setETHStop] = useState(false)
  const [ETHprice, setETHprice] = useState([])


  const btcPrice            = BTCprice
  const tronPrice           = TRONprice
  const ltcPrice            = LTCprice
  const dogePrice           = DOGEprice
  const bnbPrice            = BSCprice
  const usdtPrice           = USDTprice
  const busdPrice           = BUSDprice
  const maticPrice          = POLYGONMATICprice
  const shibPrice           = SHIBAprice
  const dotPrice            = POKADOTprice
  const linkPrice           = CHAINLINKprice
  const adaPrice            = CARDANOprice
  const solPrice            = SOLANAprice
  const ethPrice            = ETHprice
  const pmPrice            = PMprice
    
  useEffect(()=>{

      const fetchData = async () => {

          if(!BTCStop){

              try {
                  const res = await axios.get('/api/nt-btc')

                  if(res.data[0].ID){
                    setBTCprice(res.data[0].btc)
                    setBTCStop(true)
                  }
              } catch (error) {
              }
          }
      }
      fetchData()

  },[BTCStop])
  
  useEffect(()=>{

      const fetchData = async () => {

          if(!TRONStop){

              try {
                  const res = await axios.get('/api/nt-tron')

                  if(res.data[0].ID){
                    setTRONprice(res.data[0].tron)
                    setTRONStop(true)
                  }
              } catch (error) {
              }
          }
      }
      fetchData()

  },[TRONStop])
  
  useEffect(()=>{

      const fetchData = async () => {

          if(!LTCStop){

              try {
                  const res = await axios.get('/api/nt-ltc')

                  if(res.data[0].ID){
                    setLTCprice(res.data[0].ltc)
                    setLTCStop(true)
                  }
              } catch (error) {
              }
          }
      }
      fetchData()

  },[LTCStop])
  
  useEffect(()=>{

      const fetchData = async () => {

          if(!USDTStop){

              try {
                  const res = await axios.get('/api/nt-usdt')

                  if(res.data[0].ID){
                    setUSDTprice(res.data[0].usdt)
                    setUSDTStop(true)
                  }
              } catch (error) {
              }
          }
      }
      fetchData()

  },[USDTStop])
  
  useEffect(()=>{

      const fetchData = async () => {

          if(!DOGEStop){

              try {
                  const res = await axios.get('/api/nt-doge')

                  if(res.data[0].ID){
                    setDOGEprice(res.data[0].doge)
                    setDOGEStop(true)
                  }
              } catch (error) {
              }
          }
      }
      fetchData()

  },[DOGEStop])
  
  useEffect(()=>{

      const fetchData = async () => {

          if(!BUSDStop){

              try {
                  const res = await axios.get('/api/nt-busd')

                  if(res.data[0].ID){
                    setBUSDprice(res.data[0].busd)
                    setBUSDStop(true)
                  }
              } catch (error) {
              }
          }
      }
      fetchData()

  },[BUSDStop])
  
  useEffect(()=>{

      const fetchData = async () => {

          if(!SHIBAStop){

              try {
                  const res = await axios.get('/api/nt-shiba')

                  if(res.data[0].ID){
                    setSHIBAprice(res.data[0].shiba)
                    setSHIBAStop(true)
                  }
              } catch (error) {
              }
          }
      }
      fetchData()

  },[SHIBAStop])
  
  useEffect(()=>{

      const fetchData = async () => {

          if(!MATICStop){

              try {
                  const res = await axios.get('/api/nt-matic')

                  if(res.data[0].ID){
                    setPOLYGONMATICprice(res.data[0].matic)
                    setMATICStop(true)
                  }
              } catch (error) {
              }
          }
      }
      fetchData()

  },[MATICStop])
  
  useEffect(()=>{

      const fetchData = async () => {

          if(!ETHStop){

              try {
                  const res = await axios.get('/api/nt-eth')

                  if(res.data[0].ID){
                    setETHprice(res.data[0].eth)
                    setETHStop(true)
                  }
              } catch (error) {
              }
          }
      }
      fetchData()

  },[ETHStop])
  
  useEffect(()=>{

      const fetchData = async () => {

          if(!LINKStop){

              try {
                  const res = await axios.get('/api/nt-link')

                  if(res.data[0].ID){
                    setCHAINLINKprice(res.data[0].link)
                    setLINKStop(true)
                  }
              } catch (error) {
              }
          }
      }
      fetchData()

  },[LINKStop])
  
  useEffect(()=>{

      const fetchData = async () => {

          if(!DOTEStop){

              try {
                  const res = await axios.get('/api/nt-dote')

                  if(res.data[0].ID){
                    setPOKADOTprice(res.data[0].dote)
                    setDOTEStop(true)
                  }
              } catch (error) {
              }
          }
      }
      fetchData()

  },[DOTEStop])
  
  useEffect(()=>{

      const fetchData = async () => {

          if(!ADAStop){

              try {
                  const res = await axios.get('/api/nt-ada')

                  if(res.data[0].ID){
                    setCARDANOprice(res.data[0].ada)
                    setADAStop(true)
                  }
              } catch (error) {
              }
          }
      }
      fetchData()

  },[ADAStop])
  
  useEffect(()=>{

      const fetchData = async () => {

          if(!SOLStop){

              try {
                  const res = await axios.get('/api/nt-sol')

                  if(res.data[0].ID){
                    setSOLANAprice(res.data[0].sol)
                    setSOLStop(true)
                  }
              } catch (error) {
              }
          }
      }
      fetchData()

  },[SOLStop])
  
  useEffect(()=>{

      const fetchData = async () => {

          if(!PMStop){

              try {
                  const res = await axios.get('/api/nt-pm')

                  if(res.data[0].ID){
                      setPMprice(res.data[0].pm)
                      setPMStop(true)
                  }
              } catch (error) {
              }
          }
      }
      fetchData()

  },[PMStop])
  
  useEffect(()=>{

      const fetchData = async () => {

          if(!BNBStop){

              try {
                  const res = await axios.get('/api/nt-bnb')

                  if(res.data[0].ID){
                    setBSCprice(res.data[0].bnb)
                    setBNBStop(true)
                  }
              } catch (error) {
              }
          }
      }
      fetchData()

  },[BNBStop])

    
    useEffect(()=>{

    const fetchData = async () => {

        if(!BTCProRateStop){

            try {
                const res = await axios.get('/api/nt-proratebtc')

                if(res.data[0].ID){
                    setNT_ProrateBTC(res.data[0].btc)
                    setBTCProRateStop(true)
                }
            } catch (error) {
            }
        }
    }
    fetchData()

    },[BTCProRateStop])
        
    useEffect(()=>{

        const fetchData = async () => {

            if(!TRONProRateStop){

                try {
                    const res = await axios.get('/api/nt-proratetron')

                    if(res.data[0].ID){
                        setNT_ProrateTRON(res.data[0].tron)
                        setTRONProRateStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[TRONProRateStop])
        
    useEffect(()=>{

        const fetchData = async () => {

            if(!LTCProRateStop){

                try {
                    const res = await axios.get('/api/nt-prorateltc')

                    if(res.data[0].ID){
                        setNT_ProrateLTC(res.data[0].ltc)
                        setLTCProRateStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[LTCProRateStop])
        
    useEffect(()=>{

        const fetchData = async () => {

            if(!USDTProRateStop){

                try {
                    const res = await axios.get('/api/nt-prorateusdt')

                    if(res.data[0].ID){
                        setNT_ProrateUSDT(res.data[0].usdt)
                        setUSDTProRateStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[USDTProRateStop])
        
    useEffect(()=>{

        const fetchData = async () => {

            if(!DOGEProRateStop){

                try {
                    const res = await axios.get('/api/nt-proratedoge')

                    if(res.data[0].ID){
                        setNT_ProrateDOGE(res.data[0].doge)
                        setDOGEProRateStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[DOGEProRateStop])
        
    useEffect(()=>{

        const fetchData = async () => {

            if(!BUSDProRateStop){

                try {
                    const res = await axios.get('/api/nt-proratebusd')

                    if(res.data[0].ID){
                        setNT_ProrateBUSD(res.data[0].busd)
                        setBUSDProRateStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[BUSDProRateStop])
        
    useEffect(()=>{

        const fetchData = async () => {

            if(!SHIBAProRateStop){

                try {
                    const res = await axios.get('/api/nt-prorateshiba')

                    if(res.data[0].ID){
                        setNT_ProrateSHIBA(res.data[0].shiba)
                        setSHIBAProRateStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[SHIBAProRateStop])
        
    useEffect(()=>{

        const fetchData = async () => {

            if(!MATICProRateStop){

                try {
                    const res = await axios.get('/api/nt-proratematic')

                    if(res.data[0].ID){
                        setNT_ProrateMATIC(res.data[0].matic)
                        setMATICProRateStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[MATICProRateStop])
        
    useEffect(()=>{

        const fetchData = async () => {

            if(!ETHProRateStop){

                try {
                    const res = await axios.get('/api/nt-prorateeth')

                    if(res.data[0].ID){
                        setNT_ProrateETH(res.data[0].eth)
                        setETHProRateStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[ETHProRateStop])
        
    useEffect(()=>{

        const fetchData = async () => {

            if(!LINKProRateStop){

                try {
                    const res = await axios.get('/api/nt-proratelink')

                    if(res.data[0].ID){
                        setNT_ProrateLINK(res.data[0].link)
                        setLINKProRateStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[LINKProRateStop])
        
    useEffect(()=>{

        const fetchData = async () => {

            if(!DOTEProRateStop){

                try {
                    const res = await axios.get('/api/nt-proratedote')

                    if(res.data[0].ID){
                        setNT_ProrateDOTE(res.data[0].dote)
                        setDOTEProRateStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[DOTEProRateStop])
        
    useEffect(()=>{

        const fetchData = async () => {

            if(!ADAProRateStop){

                try {
                    const res = await axios.get('/api/nt-prorateada')

                    if(res.data[0].ID){
                        setNT_ProrateADA(res.data[0].ada)
                        setADAProRateStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[ADAProRateStop])
        
    useEffect(()=>{

        const fetchData = async () => {

            if(!SOLProRateStop){

                try {
                    const res = await axios.get('/api/nt-proratesol')

                    if(res.data[0].ID){
                        setNT_ProrateSOL(res.data[0].sol)
                        setSOLProRateStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[SOLProRateStop])
        
    useEffect(()=>{

        const fetchData = async () => {

            if(!PMProRateStop){

                try {
                    const res = await axios.get('/api/nt-proratepm')

                    if(res.data[0].ID){
                        setNT_ProratePM(res.data[0].pm)
                        setPMProRateStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[PMProRateStop])
        
    useEffect(()=>{

        const fetchData = async () => {

            if(!BNBProRateStop){

                try {
                    const res = await axios.get('/api/nt-proratebnb')

                    if(res.data[0].ID){
                        setNT_ProrateBNB(res.data[0].bnb)
                        setBNBProRateStop(true)
                    }
                } catch (error) {
                }
            }
        }
        fetchData()

    },[BNBProRateStop])



    const btcTaux      = NT_ProrateBTC
    const usdtTaux     = NT_ProrateUSDT
    const pmTaux       = NT_ProratePM
    const bnbTaux      = NT_ProrateBNB
    const adaTaux      = NT_ProrateADA
    const dogeTaux     = NT_ProrateDOGE
    const solTaux      = NT_ProrateSOL
    const tronTaux     = NT_ProrateTRON
    const ltcTaux      = NT_ProrateLTC
    const maticTaux    = NT_ProrateMATIC
    const dotTaux      = NT_ProrateDOTE
    const shibTaux     = NT_ProrateSHIBA
    const busdTaux     = NT_ProrateBUSD
    const linkTaux     = NT_ProrateLINK

    
    const taux = moneyName === "Bitcoin"?btcTaux:moneyName === "Tether"?usdtTaux:moneyName === "Binance USD"?busdTaux:moneyName === "Perfect Money"?pmTaux:moneyName === "Litecoin"?ltcTaux:moneyName === "Binance"?bnbTaux:moneyName === "Cardano"?adaTaux:moneyName === "Polkadot"?dotTaux:moneyName === "Polygon"?maticTaux:moneyName === "Shiba"?shibTaux:moneyName === "Solana"?solTaux:moneyName === "Tron"?tronTaux:moneyName === "Chain link"?linkTaux:moneyName === "Dogecoin"?dogeTaux:600

    const translimit = 500000
    const transMin = 2500

    const buylimit = 400
    const buyMin = buylimit*taux

    const charginglimit = 16
    const chargingMin = charginglimit*taux

    const dollar = !Montant?0: banqueName === "Wave" ? Number(((Montant/taux)*1).toFixed(2))+Number((((0.1)/taux)*1).toFixed(2)):banqueName === "Virement bancaire" || banqueName === "Dépôt bancaire" ?Number((((Montant)/taux)*1).toFixed(2))+Number(((((100)/taux))*1).toFixed(2)):Number(((Montant/taux)*1).toFixed(2))

    useEffect(()=>{

        const fetchDada = async () => {

            if(secondsRemaining2 > 0){
                try {
                    const { data } = await axios.get('/api/v1/get-p-recharge')
                    setRechargeData(data)
    
                    const rchDataFilted = data.filter((obj)=>{
                        return obj.tr_Id === rch_sop
                    })
    
                    if(rchDataFilted[0].status === "successful"){
        
                        setPaymentSuccess(true)

                        if(PaymentSuccess === true){

                            localStorage.removeItem("nkab_rge_reference")
                            localStorage.removeItem("nkab_rge_id")
                            localStorage.removeItem("hub2token")
                            localStorage.removeItem("hub2id")
                            localStorage.removeItem("LastStatus")
                            localStorage.removeItem("amount")
                            localStorage.removeItem("phone")
                            localStorage.removeItem("rch_sop")
                            localStorage.removeItem("trans_sop")
                            setSeeDoc(false)
                            setLoader(false)
                            setMontant(0)
                            localStorage.removeItem("banqueImage")
                            localStorage.removeItem("banqueName")
                            localStorage.removeItem("changeImage")
                            localStorage.removeItem("changeName")
                            localStorage.removeItem("moneyImage")
                            localStorage.removeItem("moneyName")
                            localStorage.removeItem("banqueClickedName")
                            setBanqueStatus(false)
                            setBankOptionClicked1("")
                            setBankOptionClicked2("")
                            setBankOptionClicked3("")
                            setBankOptionClicked4("")
                        }
                        
                    }
    
                    if(rchDataFilted[0].status === "failed"){

                        setPaymentFailed(true)

                        if(PaymentFailed === true){
                            localStorage.removeItem("nkab_rge_reference")
                            localStorage.removeItem("nkab_rge_id")
                            localStorage.removeItem("hub2token")
                            localStorage.removeItem("hub2id")
                            localStorage.removeItem("LastStatus")
                            localStorage.removeItem("amount")
                            localStorage.removeItem("phone")
                            localStorage.removeItem("rch_sop")
                            localStorage.removeItem("trans_sop")
                            setSeeDoc(false)
                            setLoader(false)
                            setMontant(0)
                            localStorage.removeItem("banqueImage")
                            localStorage.removeItem("banqueName")
                            localStorage.removeItem("changeImage")
                            localStorage.removeItem("changeName")
                            localStorage.removeItem("moneyImage")
                            localStorage.removeItem("moneyName")
                            localStorage.removeItem("banqueClickedName")
                            setBanqueStatus(false)
                            setBankOptionClicked1("")
                            setBankOptionClicked2("")
                            setBankOptionClicked3("")
                            setBankOptionClicked4("")
                        }
    
    
                        
                    }
    
                } catch (error) {}
    
                try {
                    const { data } = await axios.get('/api/v1/get-p-trans')
                    setTransData(data)
    
                    const transDataFilted = data.filter((obj)=>{
                        return obj.tr_Id === trans_sop
                    })
    
                    if(transDataFilted[0].status === "successful"){
    
                        setTransSuccess(true)

                        if(TransSuccess === true){

                            localStorage.removeItem("nkab_rge_reference")
                            localStorage.removeItem("nkab_rge_id")
                            localStorage.removeItem("hub2token")
                            localStorage.removeItem("hub2id")
                            localStorage.removeItem("LastStatus")
                            localStorage.removeItem("amount")
                            localStorage.removeItem("phone")
                            localStorage.removeItem("rch_sop")
                            localStorage.removeItem("trans_sop")
                            setSeeDoc(false)
                            setLoader(false)
                            setMontant(0)
                            localStorage.removeItem("banqueImage")
                            localStorage.removeItem("banqueName")
                            localStorage.removeItem("changeImage")
                            localStorage.removeItem("changeName")
                            localStorage.removeItem("moneyImage")
                            localStorage.removeItem("moneyName")
                            localStorage.removeItem("banqueClickedName")
                            setBanqueStatus(false)
                            setBankOptionClicked1("")
                            setBankOptionClicked2("")
                            setBankOptionClicked3("")
                            setBankOptionClicked4("")
                        }
                        
                    }
    
                    if(transDataFilted[0].status === "failed"){

                        setTransFailed(true)

                        if(TransFailed === true){
                            localStorage.removeItem("nkab_rge_reference")
                            localStorage.removeItem("nkab_rge_id")
                            localStorage.removeItem("hub2token")
                            localStorage.removeItem("hub2id")
                            localStorage.removeItem("LastStatus")
                            localStorage.removeItem("amount")
                            localStorage.removeItem("phone")
                            localStorage.removeItem("rch_sop")
                            localStorage.removeItem("trans_sop")
                            setSeeDoc(false)
                            setLoader(false)
                            setMontant(0)
                            localStorage.removeItem("banqueImage")
                            localStorage.removeItem("banqueName")
                            localStorage.removeItem("changeImage")
                            localStorage.removeItem("changeName")
                            localStorage.removeItem("moneyImage")
                            localStorage.removeItem("moneyName")
                            localStorage.removeItem("banqueClickedName")
                            setBanqueStatus(false)
                            setBankOptionClicked1("")
                            setBankOptionClicked2("")
                            setBankOptionClicked3("")
                            setBankOptionClicked4("")
                        }
    
                    }
                } catch (error) {}
    
                try {
                    const { data } = await axios.get('/api/v1/get-p-buy')
                    setBuyData(data)
    
                    const buyDataFilted = data.filter((obj)=>{
                        return obj.tr_Id === buy_sop
                    })
    
                    if(buyDataFilted[0].status === "successful"){
    
                        setBuySuccess(true)

                        if(BuySuccess === true){

                            localStorage.removeItem("nkab_rge_reference")
                            localStorage.removeItem("nkab_rge_id")
                            localStorage.removeItem("hub2token")
                            localStorage.removeItem("hub2id")
                            localStorage.removeItem("LastStatus")
                            localStorage.removeItem("amount")
                            localStorage.removeItem("phone")
                            localStorage.removeItem("rch_sop")
                            localStorage.removeItem("buy_sop")
                            setSeeDoc(false)
                            setLoader(false)
                            setMontant(0)
                            localStorage.removeItem("banqueImage")
                            localStorage.removeItem("banqueName")
                            localStorage.removeItem("changeImage")
                            localStorage.removeItem("changeName")
                            localStorage.removeItem("moneyImage")
                            localStorage.removeItem("moneyName")
                            localStorage.removeItem("banqueClickedName")
                            setBanqueStatus(false)
                            setBankOptionClicked1("")
                            setBankOptionClicked2("")
                            setBankOptionClicked3("")
                            setBankOptionClicked4("")
                        }
                        
                    }
    
                    if(buyDataFilted[0].status === "failed"){

                        setBuyFailed(true)

                        if(BuyFailed === true){
                            localStorage.removeItem("nkab_rge_reference")
                            localStorage.removeItem("nkab_rge_id")
                            localStorage.removeItem("hub2token")
                            localStorage.removeItem("hub2id")
                            localStorage.removeItem("LastStatus")
                            localStorage.removeItem("amount")
                            localStorage.removeItem("phone")
                            localStorage.removeItem("rch_sop")
                            localStorage.removeItem("buy_sop")
                            setSeeDoc(false)
                            setLoader(false)
                            setMontant(0)
                            localStorage.removeItem("banqueImage")
                            localStorage.removeItem("banqueName")
                            localStorage.removeItem("changeImage")
                            localStorage.removeItem("changeName")
                            localStorage.removeItem("moneyImage")
                            localStorage.removeItem("moneyName")
                            localStorage.removeItem("banqueClickedName")
                            setBanqueStatus(false)
                            setBankOptionClicked1("")
                            setBankOptionClicked2("")
                            setBankOptionClicked3("")
                            setBankOptionClicked4("")
                        }
    
                    }
                } catch (error) {}
    
                try {
                    const { data } = await axios.get('/api/v1/get-p-newcp')
                    setPCodes(data)
                } catch (error) {}

            }

        }

        fetchDada()

    },[rch_sop, secondsRemaining2, trans_sop, PaymentSuccess, STATUS.STOPPED, TransFailed, TransSuccess])

    const handleChangeInput = (e) => {
      const { value } = e.target
      setCodePin(value)
    }

    useEffect(()=>{
        setNKABCONVERTED(NKABCONVERTED)
        setNKABCFA(NKABCFA)
    },[NKABCONVERTED, NKABCFA])

    const handleCurrency = (e) => {

        const { value, name } = e.target

        setCurrency(value)

        if(Currency && taux){
            if(moneyName === "Tether"){
                const val = Number(value.trim())
                const dollar = val * Number(usdtPrice)
                // const cfa = Number(((dollar * taux)).toFixed(2))
                // setNKABCFA((dollar * taux))
                const cfa = Number(((dollar * taux)+(2.5*taux)).toFixed(2))
                setNKABCFA((dollar * taux)+(2.5*taux))
                const converted = val
                setExchange({
                    [name]: val,
                    converted,
                    cfa,
                    dollar,
                })
            }
            if(moneyName === "Binance USD"){
                const val = Number(value.trim())
                const dollar = val * Number(busdPrice)
                const cfa = Number(((dollar * taux)+(1.5*taux)).toFixed(2))
                setNKABCFA((dollar * taux)+(1.5*taux))
                const converted = val
                setExchange({
                    [name]: val,
                    converted,
                    cfa,
                    dollar,
                })
            }
            if(moneyName === "Bitcoin"){
                const val = Number(value.trim())
                const dollar = val * Number(btcPrice)
                const cfa = Number(((dollar * taux)+(5*taux)).toFixed(2))
                setNKABCFA((dollar * taux)+(5*taux))
                const converted = val
                setExchange({
                    [name]: val,
                    converted,
                    cfa,
                    dollar,
                })
            }
            if(moneyName === "Perfect Money"){
                const val = Number(value.trim())
                const dollar = val * Number(1)
                const cfa = Number(((dollar * taux)+(1.5*taux)).toFixed(2))
                setNKABCFA((dollar * taux)+(1.5*taux))
                const converted = val
                setExchange({
                    [name]: val,
                    converted,
                    cfa,
                    dollar,
                })
            }
            if(moneyName === "Litecoin"){
                const val = Number(value.trim())
                const dollar = val * Number(ltcPrice)
                const cfa = Number(((dollar * taux)+(1.5*taux)).toFixed(2))
                setNKABCFA((dollar * taux)+(1.5*taux))
                const converted = val
                setExchange({
                    [name]: val,
                    converted,
                    cfa,
                    dollar,
                })
            }
            if(moneyName === "Binance"){
                const val = Number(value.trim())
                const dollar = val * Number(bnbPrice)
                const cfa = Number(((dollar * taux)+(1.5*taux)).toFixed(2))
                setNKABCFA((dollar * taux)+(1.5*taux))
                const converted = val
                setExchange({
                    [name]: val,
                    converted,
                    cfa,
                    dollar,
                })
            }
            if(moneyName === "Cardano"){
                const val = Number(value.trim())
                const dollar = val * Number(adaPrice)
                const cfa = Number(((dollar * taux)+(1.5*taux)).toFixed(2))
                setNKABCFA((dollar * taux)+(1.5*taux))
                const converted = val
                setExchange({
                    [name]: val,
                    converted,
                    cfa,
                    dollar,
                })
            }
            if(moneyName === "Polkadot"){
                const val = Number(value.trim())
                const dollar = val * Number(dotPrice)
                const cfa = Number(((dollar * taux)+(1.5*taux)).toFixed(2))
                setNKABCFA((dollar * taux)+(1.5*taux))
                const converted = val
                setExchange({
                    [name]: val,
                    converted,
                    cfa,
                    dollar,
                })
            }
            if(moneyName === "Polygon"){
                const val = Number(value.trim())
                const dollar = val * Number(maticPrice)
                const cfa = Number(((dollar * taux)+(1.5*taux)).toFixed(2))
                setNKABCFA((dollar * taux)+(1.5*taux))
                const converted = val
                setExchange({
                    [name]: val,
                    converted,
                    cfa,
                    dollar,
                })
            }
            if(moneyName === "Shiba"){
                const val = Number(value.trim())
                const dollar = val * Number(shibPrice)
                const cfa = Number(((dollar * taux)+(1.5*taux)).toFixed(2))
                setNKABCFA((dollar * taux)+(1.5*taux))
                const converted = val
                setExchange({
                    [name]: val,
                    converted,
                    cfa,
                    dollar,
                })
            }
            if(moneyName === "Solana"){
                const val = Number(value.trim())
                const dollar = val * Number(solPrice)
                const cfa = Number(((dollar * taux)+(1.5*taux)).toFixed(2))
                setNKABCFA((dollar * taux)+(1.5*taux))
                const converted = val
                setExchange({
                    [name]: val,
                    converted,
                    cfa,
                    dollar,
                })
            }
            if(moneyName === "Tron"){
                const val = Number(value.trim())
                const dollar = val * Number(tronPrice)
                const cfa = Number(((dollar * taux)+(1.5*taux)).toFixed(2))
                setNKABCFA((dollar * taux)+(1.5*taux))
                const converted = val
                setExchange({
                    [name]: val,
                    converted,
                    cfa,
                    dollar,
                })
            }
            if(moneyName === "Chain link"){
                const val = Number(value.trim())
                const dollar = val * Number(linkPrice)
                const cfa = Number(((dollar * taux)+(1.5*taux)).toFixed(2))
                setNKABCFA((dollar * taux)+(1.5*taux))
                const converted = val
                setExchange({
                    [name]: val,
                    converted,
                    cfa,
                    dollar,
                })
            }
            if(moneyName === "Dogecoin"){
                const val = Number(value.trim())
                const dollar = val * Number(dogePrice)
                const cfa = Number(((dollar * taux)+(1.5*taux)).toFixed(2))
                setNKABCFA((dollar * taux)+(1.5*taux))
                const converted = val
                setExchange({
                    [name]: val,
                    converted,
                    cfa,
                    dollar,
                })
            }
            if(moneyName === "Perfect Money"){
                const val = Number(value.trim())
                const dollar = val * Number(pmPrice)
                const cfa = Number(((dollar * taux)+(1.5*taux)).toFixed(2))
                setNKABCFA((dollar * taux)+(1.5*taux))
                const converted = val
                setExchange({
                    [name]: val,
                    converted,
                    cfa,
                    dollar,
                })
            }
            if(moneyName === "Ethereum"){
                const val = Number(value.trim())
                const dollar = val * Number(ethPrice)
                const cfa = Number(((dollar * taux)+(1.5*taux)).toFixed(2))
                setNKABCFA((dollar * taux)+(1.5*taux))
                const converted = val
                setExchange({
                    [name]: val,
                    converted,
                    cfa,
                    dollar,
                })
            }
        }
    }

    const handleMontant = (e) => {

      const { value, name } = e.target

      setMontant(value)

      if(changeName === "Orange" || changeName === "mtn" || changeName === "Moov" || changeName === "Wave" || banqueName === "Dépôt bancaire" || banqueName === "Wave" || banqueName === "Virement bancaire" || banqueName === "Cash"){

        const val = Number(value.trim())
        const cfa = Number((val).toFixed(0))

        setExchange({
            [name]: val,
            converted : 0,
            cfa : banqueName === "Wave" ? cfa+(Number(Montant)*0.1):banqueName === "Virement bancaire" || banqueName === "Dépôt bancaire" ? cfa+100 : cfa,
            dollar: 0,
        })
      }

      if(moneyName === "Tether"){
            const val = Number(value.trim())
            const dollar = val / taux
            const converted = ((dollar-(2.5)) / Number(usdtPrice))
            setNKABCONVERTED(converted)
            const cfa = Number((val).toFixed(0))

            setExchange({
                [name]: val,
                converted,
                cfa,
                dollar,
            })
      }

      if(moneyName === "Binance USD"){
            const val = Number(value.trim())
            const dollar = val / taux
            const converted = ((dollar-(1.5)) / Number(busdPrice))
            setNKABCONVERTED(converted)
            const cfa = Number((val).toFixed(0))

            setExchange({
                [name]: val,
                converted,
                cfa,
                dollar,
            })
      }

      if(moneyName === "Bitcoin"){
            const val = Number(value.trim())
            const dollar = val / taux
            const converted = ((dollar-(5)) / Number(btcPrice))
            setNKABCONVERTED(converted)
            const cfa = Number((val).toFixed(0))

            setExchange({
                [name]: val,
                converted,
                cfa,
                dollar,
            })
      }

      if(moneyName === "Perfect Money"){
            const val = Number(value.trim())
            const dollar = val / taux
            const converted = ((dollar-(1.5)) / 1)
            setNKABCONVERTED(converted)
            const cfa = Number((val).toFixed(0))

            setExchange({
                [name]: val,
                converted,
                cfa,
                dollar,
            })
      }

      if(moneyName === "Litecoin"){
            const val = Number(value.trim())
            const dollar = val / taux
            const converted = ((dollar-(1.5)) / Number(ltcPrice))
            setNKABCONVERTED(converted)
            const cfa = Number((val).toFixed(0))

            setExchange({
                [name]: val,
                converted,
                cfa,
                dollar,
            })
      }
      if(moneyName === "Binance"){
            const val = Number(value.trim())
            const dollar = val / taux
            const converted = ((dollar-(1.5)) / Number(bnbPrice))
            setNKABCONVERTED(converted)
            const cfa = Number((val).toFixed(0))

            setExchange({
                [name]: val,
                converted,
                cfa,
                dollar,
            })
      }
      if(moneyName === "Cardano"){
            const val = Number(value.trim())
            const dollar = val / taux
            const converted = ((dollar-(1.5)) / Number(adaPrice))
            setNKABCONVERTED(converted)
            const cfa = Number((val).toFixed(0))

            setExchange({
                [name]: val,
                converted,
                cfa,
                dollar,
            })
      }
      if(moneyName === "Polkadot"){
            const val = Number(value.trim())
            const dollar = val / taux
            const converted = ((dollar-(1.5)) / Number(dotPrice))
            setNKABCONVERTED(converted)
            const cfa = Number((val).toFixed(0))

            setExchange({
                [name]: val,
                converted,
                cfa,
                dollar,
            })
      }
      if(moneyName === "Polygon"){
            const val = Number(value.trim())
            const dollar = val / taux
            const converted = ((dollar-(1.5)) / Number(maticPrice))
            setNKABCONVERTED(converted)
            const cfa = Number((val).toFixed(0))

            setExchange({
                [name]: val,
                converted,
                cfa,
                dollar,
            })
      }
      if(moneyName === "Shiba"){
            const val = Number(value.trim())
            const dollar = val / taux
            const converted = ((dollar-(1.5)) / Number(shibPrice))
            setNKABCONVERTED(converted)
            const cfa = Number((val).toFixed(0))

            setExchange({
                [name]: val,
                converted,
                cfa,
                dollar,
            })
      }
      if(moneyName === "Solana"){
            const val = Number(value.trim())
            const dollar = val / taux
            const converted = ((dollar-(1.5)) / Number(solPrice))
            setNKABCONVERTED(converted)
            const cfa = Number((val).toFixed(0))

            setExchange({
                [name]: val,
                converted,
                cfa,
                dollar,
            })
      }
      if(moneyName === "Tron"){
            const val = Number(value.trim())
            const dollar = val / taux
            const converted = ((dollar-(1.5)) / Number(tronPrice))
            setNKABCONVERTED(converted)
            const cfa = Number((val).toFixed(0))

            setExchange({
                [name]: val,
                converted,
                cfa,
                dollar,
            })
      }
      if(moneyName === "Chain link"){
            const val = Number(value.trim())
            const dollar = val / taux
            const converted = ((dollar-(1.5)) / Number(linkPrice))
            setNKABCONVERTED(converted)
            const cfa = Number((val).toFixed(0))

            setExchange({
                [name]: val,
                converted,
                cfa,
                dollar,
            })
      }
      if(moneyName === "Dogecoin"){
            const val = Number(value.trim())
            const dollar = val / taux
            const converted = ((dollar-(1.5)) / Number(dogePrice))
            setNKABCONVERTED(converted)
            const cfa = Number((val).toFixed(0))

            setExchange({
                [name]: val,
                converted,
                cfa,
                dollar,
            })
      }
      if(moneyName === "Perfect Money"){
            const val = Number(value.trim())
            const dollar = val / taux
            const converted = ((dollar-(1.5)) / Number(pmPrice))
            setNKABCONVERTED(converted)
            const cfa = Number((val).toFixed(0))

            setExchange({
                [name]: val,
                converted,
                cfa,
                dollar,
            })
      }
      if(moneyName === "Ethereum"){
            const val = Number(value.trim())
            const dollar = val / taux
            const converted = ((dollar-(1.5)) / Number(ethPrice))
            setNKABCONVERTED(converted)
            const cfa = Number((val).toFixed(0))

            setExchange({
                [name]: val,
                converted,
                cfa,
                dollar,
            })
      }
    }

    const handleAdress = (e) => {
      const { value } = e.target
      setAdress(value)
    }

    const handleRDV = (e) => {
      const { value } = e.target
      setRDV(value)
    }

    const handleTime = (e) => {
      const { value } = e.target
      setTimes(value)
    }

    const handlePhone = (e) => {
      const { value } = e.target
      setPhone(value)
    }

    const handleAountName = (e) => {
      const { value } = e.target
      setAountName(value)
    }

    const handleAcountCredName = (e) => {
      const { value } = e.target
      setAcountCredName(value)
    }

    const handleServiceBankName = (e) => {
      const { value } = e.target
      setServiceBankName(value)
    }

    const handleCodeSecret = (e) => {
      const { value } = e.target
      setCodeSecret(value)
    }

    const [PremiumLength, setPremiumLength] = useState([])
    const [PremiumsData, setPremiumsData] = useState([])
    const [AllPremiums, setAllPremiums] = useState([])
    
    useEffect(()=>{

    const fetchData = async () => {
        try {

        const { data } = await axios.get('/api/premium-pack/subscribe')

        if(data.length > 0){

            const mypremiumFeilted = data.filter((obj)=>{
                return obj.userId === userID
            })

            setPremiumLength(mypremiumFeilted.length)
            setPremiumsData(mypremiumFeilted[0])
            setAllPremiums(mypremiumFeilted)
        }

        } catch (error) { }
    }
    fetchData()

    },[userID])
    
  
    useEffect(()=>{
        if(secondsRemaining2 === 0 || secondsRemaining2 === 5 || secondsRemaining2 === 10 || secondsRemaining2 === 15 || secondsRemaining2 === 20 || secondsRemaining2 === 25 || secondsRemaining2 === 30 || secondsRemaining2 === 35){
          
            if((RechargeData.length > 1 || BuyData.length > 1 || TransData.length > 1) && User.ID){
          
              ///////////////// RECHARGE ///////////////////
              if(RechargeData.length > 0){
                  const RechargeUserDatafiltered = RechargeData.filter(obj => {
                      return obj.userId === User.ID.toString();
                    });
      
                    if(RechargeUserDatafiltered.length > 0){
      
                      const RechargeDatafiltered = RechargeUserDatafiltered.filter(obj => {return obj.status === "successful";});
          
                      const RechargeDatas = (RechargeDatafiltered.reduce((total, currentItem) =>  total = total + currentItem.rbserved , 0 ));
  
                      if(RechargeDatas > 0){
                          setRechargeWallets(RechargeDatas)
                      } else {
                          setRechargeWallets(0)
                      }
      
                    }
  
              } else {
                  setRechargeWallets(0)
              }
          
              ///////////////// ACHAT ///////////////////
              const BuyUserDatafiltered = BuyData.filter(obj => {
                  return obj.userId === User.ID.toString();
                });
  
                if(BuyUserDatafiltered.length > 0){
                  
                  const BuyDatafiltered = BuyUserDatafiltered.filter(obj => {return obj.status === "successful";});
      
                  const BuyDatas = (BuyDatafiltered.reduce((total, currentItem) =>  total = total + currentItem.montant , 0 ));
  
                  if(BuyDatas > 0){
                      setBuyingWallets(BuyDatas)
                  } else {
                      setBuyingWallets(0)
                  }
  
              } else {
                  setBuyingWallets(0)
              }
          
              ///////////////// TRANSFERT ///////////////////
              const TransUserDatafiltered = TransData.filter(obj => {
                  return obj.userId === User.ID.toString();
                });
  
              if(TransUserDatafiltered.length > 0){
  
                  const TransDatafiltered = TransUserDatafiltered.filter(obj => {return obj.status === "successful";});
      
                  const TransDatas = (TransDatafiltered.reduce((total, currentItem) =>  total = total + currentItem.montant , 0 ));
  
                  if(TransDatas > 0){
                      setTransWallets(TransDatas)
                  } else {
                      setTransWallets(0)
                  }
  
              } else {
                  setTransWallets(0)
              }
          
              ///////////////// PREMIUM ///////////////////
              if(AllPremiums.length > 0){
                  const PremiumUserDatafiltered = AllPremiums.filter(obj => {
                      return obj.userId === User.ID.toString();
                    });
      
                  if(PremiumUserDatafiltered.length > 0){
          
                      const PremiumsDatas = (PremiumUserDatafiltered.reduce((total, currentItem) =>  total = total + currentItem.premiumPrice , 0 ));
      
                      if(PremiumsDatas > 0){
                          setPremiumsWallets(PremiumsDatas)
                      } else {
                          setPremiumsWallets(0)
                      }
      
                  }
              } else {
                  setPremiumsWallets(0)
              }
  
              const Total = RechargeWallets - (BuyingWallets + TransWallets + PremiumsWallets)
          
              setWallets(Total)
  
          
              ///////////////// TOTAL ///////////////////
              if(RechargeWallets === 0 && BuyingWallets === 0 && TransWallets === 0 && PremiumsWallets === 0){ setWallets(0) }
  
              if(RechargeWallets > 1 && BuyingWallets === 0 && TransWallets === 0 && PremiumsWallets === 0){
  
                  const Total = RechargeWallets
          
                  setWallets(Total)
  
              }
  
              if(RechargeWallets > 1 && BuyingWallets > 1 && TransWallets === 0 && PremiumsWallets === 0){
  
                  const Total = RechargeWallets - BuyingWallets
          
                  setWallets(Total)
          
              }
  
              if(RechargeWallets > 1 && BuyingWallets === 0 && TransWallets > 1 && PremiumsWallets === 0){
  
                  const Total = RechargeWallets - TransWallets
          
                  setWallets(Total)
          
              }
              
              if(RechargeWallets > 1 && BuyingWallets > 1 && TransWallets > 1 && PremiumsWallets === 0){
  
                  const Total = RechargeWallets - (BuyingWallets + TransWallets)
          
                  setWallets(Total)
  
              }
              
              if(RechargeWallets > 1 && BuyingWallets > 1 && TransWallets > 1 && PremiumsWallets > 1){
  
                  const Total = RechargeWallets - (BuyingWallets + TransWallets + PremiumsWallets)
          
                  setWallets(Total)
  
              }
              
              if(RechargeWallets > 1 && BuyingWallets === 0 && TransWallets === 0 && PremiumsWallets > 1){
  
                  const Total = RechargeWallets - PremiumsWallets
          
                  setWallets(Total)
  
              }
              
              if(RechargeWallets > 1 && BuyingWallets === 0 && TransWallets > 1 && PremiumsWallets > 1){
  
                  const Total = RechargeWallets - (TransWallets + PremiumsWallets)
          
                  setWallets(Total)
  
              }
              
              if(RechargeWallets > 1 && BuyingWallets > 1 && TransWallets === 0 && PremiumsWallets > 1){
  
                  const Total = RechargeWallets - (BuyingWallets +  PremiumsWallets)
          
                  setWallets(Total)
  
              }
            }
        }
  
    },[secondsRemaining2, RechargeData, BuyData, User, BuyingWallets, RechargeWallets, Wallets, TransData, TransWallets, AllPremiums, PremiumsWallets])


    const [ProUserFilted, setProUserFilted] = useState([])

    useEffect(()=>{

        const fetchData = async () => {
            try {
    
            const { data } = await axios.get('/api/nkabpro')
    
            if(data.length > 0){
    
                const proUserFilted = data.filter((obj)=>{
                    return obj.userId === userID
                })

                if(proUserFilted.length === 1){
                    setProUserFilted(proUserFilted[0])

                    const ProPrice = Wallets

                    if(ProPrice > 0 && ProUserFilted.proPrice){
                        if(ProPrice !== Number(ProUserFilted.proPrice)){

                            try {
                                
                                axios.post(`/api/update-nkabpro`,
                                {
                                    ID : ProUserFilted.ID,
                                    proPrice: ProPrice,
                                    createdAt: new Date(),
                                    updatedAt: new Date(),
                                },
                                )
                        
                            } catch (error) { }
                        }
                    }
                }
    
                if(proUserFilted.length === 0){

                    const ProPhone = userPhone
                    const ProEmail = userEmail
                    const ProPrice = Wallets
                
                    if(userID && ProEmail && ProPhone && ProPrice > 0){
                
                        axios.post('/api/create-nkabpro',
                            {
                                userId:         userID,
                                proEmail:       ProEmail,
                                proPhone:       ProPhone,
                                proPrice:       ProPrice,
                                createdAt:      new Date(),
                                updatedAt:      new Date(),
                            },
                          )
                          .then((res)=>{
                            if(res.data.msg === 'success'){
                                
                            }
                          })
                
                    }
                }
            } else if(data.length === 0){
    
                const proUserFilted = data.filter((obj)=>{
                    return obj.userId === userID
                })

                if(proUserFilted.length === 0){

                    const ProPhone = userPhone
                    const ProEmail = userEmail
                    const ProPrice = Wallets
                
                    if(userID && ProEmail && ProPhone && ProPrice > 0){
                
                        axios.post('/api/create-nkabpro',
                            {
                                userId:         userID,
                                proEmail:       ProEmail,
                                proPhone:       ProPhone,
                                proPrice:       ProPrice,
                                createdAt:      new Date(),
                                updatedAt:      new Date(),
                            },
                          )
                          .then((res)=>{
                            if(res.data.msg === 'success'){
                                
                            }
                          })
                
                    }
                }
            }
    
            } catch (error) { }
        }
        fetchData()
    
        },[userID, secondsRemaining2, Wallets, userEmail, userPhone])
  
    useEffect(()=>{
          
        if(PCodes.length > 0 && userID){
      
          ///////////////// RECHARGE ///////////////////
          const PCodesDatafiltered = PCodes.filter(obj => {return obj.userId === userID;});

          if(PCodesDatafiltered.length > 0){
            setMyCodePin(PCodesDatafiltered[0].codep)
            setMyCodePinID(PCodesDatafiltered[0].ID)
          }
        }

  },[PCodes, userID])


    useEffect(()=>{

        if((Number(Montant) || Number(Currency)) && Number(exchange.cfa) && Options){

            if(Number(exchange.cfa) && Options === "ACHAT"){ 
            
                if((Number(exchange.cfa) < buyMin)){ setDangerControler("controler_danger") }

                if((Number(exchange.cfa) > Wallets)){ setDangerControler("controler_danger") }

                if((Number(exchange.cfa) >= buyMin) && (Number(exchange.cfa) < Wallets)){ setDangerControler("controler_success") }
            }

            if(Number(exchange.cfa) && Options === "RECHARGE"){ 
            
                if((Number(exchange.cfa) < chargingMin)){ setDangerControler("controler_danger") }
        
                if((Number(exchange.cfa) >= chargingMin)){ setDangerControler("controler_success") }
            }
    
            if(Number(exchange.cfa) && Options === "TRANSFERT"){ 
            
                if((Number(exchange.cfa) < Wallets)){ setDangerControler("controler_success") }
        
                if((Number(exchange.cfa) > Wallets)){ setDangerControler("controler_danger") }
            }
    
            // if(Number(exchange.cfa) && Options === "RECHARGE"){ setRECHARGEObserved(Number(Wallets)+Number(exchange.cfa)) }
    
            // if(Number(exchange.cfa) && (Options === "ACHAT" || Options === "TRANSFERT")){ setObserved(Number(Wallets)-Number(exchange.cfa)) }
        }

        // if(!Number(exchange.cfa)){
        //     setObserved(Number(Wallets))
        //     setRECHARGEObserved(Number(Wallets))
        // }

    },[Montant, Options, Wallets, exchange.cfa, Currency, buyMin, chargingMin])

    

    function ChoixOption1(){
        setOptions("ACHAT")
        localStorage.setItem("_options", "ACHAT")

        if(LineLink){
          window.location.replace("https://nkab-exchange.net/nkab-pro");
        } else {
           window.location.replace("http://localhost:3000/nkab-pro");
        }
    }
    function ChoixOption2(){
        setOptions("TRANSFERT")
        localStorage.setItem("_options", "TRANSFERT")

        if(LineLink){
          window.location.replace("https://nkab-exchange.net/nkab-pro");
        } else {
           window.location.replace("http://localhost:3000/nkab-pro");
        }
    }
    function ChoixOption3(){
        setOptions("RECHARGE")
        localStorage.setItem("_options", "RECHARGE")

        if(LineLink){
          window.location.replace("https://nkab-exchange.net/nkab-pro");
        } else {
           window.location.replace("http://localhost:3000/nkab-pro");
        }
    }
    function ChoixOption4(){
        setOptions("PROFIL")
        localStorage.setItem("_options", "PROFIL")
        setProfil(true)
        setPassCode(false)
        setListing(false)
        setSeeDoc(false)

        if(LineLink){
          window.location.replace("https://nkab-exchange.net/nkab-pro");
        } else {
           window.location.replace("http://localhost:3000/nkab-pro");
        }
    }
    function ChoixOption5(){
        setOptions("NEWCODE")
        localStorage.setItem("_options", "NEWCODE")
        setPassCode(true)
        setListing(false)
        setProfil(false)
        setSeeDoc(false)

        if(LineLink){
          window.location.replace("https://nkab-exchange.net/nkab-pro");
        } else {
           window.location.replace("http://localhost:3000/nkab-pro");
        }
    }
    // function ChoixOption6(){
    //     setOptionsb("OPERATION")
    //     setOperations(true)

    //     if(LineLink){
    //       window.location.replace("https://nkab-exchange.net/nkab-pro");
    //     } else {
    //        window.location.replace("http://localhost:3000/nkab-pro");
    //     }
    // }
    // function ChoixOption6b(){
    //     setOptionsb("")
    //     setOperations(false)
    // }


    function ChoixOption1Mobile(){
        setOptions("ACHAT")
        localStorage.setItem("_options", "ACHAT")
        setMontant(0)
    }
    function ChoixOption2Mobile(){
        setOptions("TRANSFERT")
        localStorage.setItem("_options", "TRANSFERT")
        setMontant(0)
    }
    function ChoixOption3Mobile(){
        setOptions("RECHARGE")
        localStorage.setItem("_options", "RECHARGE")
        setMontant(0)
    }
    function ChoixOption4Mobile(){
        setOptions("PROFIL")
        localStorage.setItem("_options", "PROFIL")
        setProfil(true)
        setPassCode(false)
        setListing(false)
        setSeeDoc(false)
        setMontant(0)
    }
    function ChoixOption5Mobile(){
        setOptions("NEWCODE")
        localStorage.setItem("_options", "NEWCODE")
        setPassCode(true)
        setListing(false)
        setProfil(false)
        setSeeDoc(false)
        setMontant(0)
    }
    function ChoixOption6Mobile(){
        setOptionsb("OPERATION")
        setOperations(true)
        setMontant(0)
    }
    function ChoixOption6bMobile(){
        setOptionsb("")
        setOperations(false)
        setMontant(0)
    }



    function ChoixCurrency1(){
        setCurrencyStatus(true)
    }
    function ChoixCurrency1b(){
        setCurrencyStatus(false)
    }

    //CURRENCY
    function ChoixCurrency2a(){
        setCurrencyStatus(false)
        localStorage.setItem("moneyImage", "../../images/btc.png")
        localStorage.setItem("moneyName", "Bitcoin")
        setCurrency('')
    }
    function ChoixCurrency2b(){
        setCurrencyStatus(false)
        localStorage.setItem("moneyImage", "../../images/usdt.png")
        localStorage.setItem("moneyName", "Tether")
        setCurrency('')
    }
    function ChoixCurrency2c(){
        setCurrencyStatus(false)
        localStorage.setItem("moneyImage", "../../images/busd.png")
        localStorage.setItem("moneyName", "Binance USD")
        setCurrency('')
    }
    function ChoixCurrency2d(){
        setCurrencyStatus(false)
        localStorage.setItem("moneyImage", "../../images/pm.png")
        localStorage.setItem("moneyName", "Perfect Money")
        setCurrency('')
    }
    function ChoixCurrency2e(){
        setCurrencyStatus(false)
        localStorage.setItem("moneyImage", "../../images/ltc.png")
        localStorage.setItem("moneyName", "Litecoin")
        setCurrency('')
    }
    function ChoixCurrency2f(){
        setCurrencyStatus(false)
        localStorage.setItem("moneyImage", "../../images/bnb.png")
        localStorage.setItem("moneyName", "Binance")
        setCurrency('')
    }
    function ChoixCurrency2g(){
        setCurrencyStatus(false)
        localStorage.setItem("moneyImage", "../../images/cardano.png")
        localStorage.setItem("moneyName", "Cardano")
        setCurrency('')
    }
    function ChoixCurrency2h(){
        setCurrencyStatus(false)
        localStorage.setItem("moneyImage", "../../images/pokadot.png")
        localStorage.setItem("moneyName", "Polkadot")
        setCurrency('')
    }
    function ChoixCurrency2i(){
        setCurrencyStatus(false)
        localStorage.setItem("moneyImage", "../../images/polygonmatic.png")
        localStorage.setItem("moneyName", "Polygon")
        setCurrency('')
    }
    function ChoixCurrency2j(){
        setCurrencyStatus(false)
        localStorage.setItem("moneyImage", "../../images/shiba.png")
        localStorage.setItem("moneyName", "Shiba")
        setCurrency('')
    }
    function ChoixCurrency2k(){
        setCurrencyStatus(false)
        localStorage.setItem("moneyImage", "../../images/solana.png")
        localStorage.setItem("moneyName", "Solana")
        setCurrency('')
    }
    function ChoixCurrency2l(){
        setCurrencyStatus(false)
        localStorage.setItem("moneyImage", "../../images/tron.png")
        localStorage.setItem("moneyName", "Tron")
        setCurrency('')
    }
    function ChoixCurrency2m(){
        setCurrencyStatus(false)
        localStorage.setItem("moneyImage", "../../images/chainlink.png")
        localStorage.setItem("moneyName", "Chain link")
        setCurrency('')
    }
    function ChoixCurrency2n(){
        setCurrencyStatus(false)
        localStorage.setItem("moneyImage", "../../images/doge.png")
        localStorage.setItem("moneyName", "Dogecoin")
        setCurrency('')
    }
    function ChoixChange1(){
        setChangeStatus(true)
    }
    function ChoixChange1b(){
        setChangeStatus(false)
    }
    //CHANGES
    function ChoixChange2a(){
        setChangeStatus(false)
        localStorage.setItem("changeImage", "../../images/wave.png")
        localStorage.setItem("changeName", "Wave")
    }
    function ChoixChange2b(){
        setChangeStatus(false)
        localStorage.setItem("changeImage", "../../images/om.png")
        localStorage.setItem("changeName", "Orange")
    }
    function ChoixChange2c(){
        setChangeStatus(false)
        localStorage.setItem("changeImage", "../../images/flooz.png")
        localStorage.setItem("changeName", "Moov")
    }
    function ChoixChange2d(){
        setChangeStatus(false)
        localStorage.setItem("changeImage", "../../images/momo.png")
        localStorage.setItem("changeName", "mtn")
    }
    function ChoixBanque1(){
        setBanqueStatus(true)
    }
    function ChoixBanque1b(){
        setBanqueStatus(false)
    }
    //BanqueS
    function ChoixBanque2a(){
        setBanqueStatus(false)
        localStorage.setItem("banqueImage", "../../images/wave.png")
        localStorage.setItem("banqueName", "Wave")
    }
    function ChoixBanque2b(){
        setBanqueStatus(false)
        localStorage.setItem("banqueImage", "../../images/vbancaire.png")
        localStorage.setItem("banqueName", "Virement bancaire")
    }
    function ChoixBanque2c(){
        setBanqueStatus(false)
        localStorage.setItem("banqueImage", "../../images/dbancaire.png")
        localStorage.setItem("banqueName", "Dépôt bancaire")
    }
    function ChoixBanque2d(){
        setBanqueStatus(false)
        localStorage.setItem("banqueImage", "../../images/cash.png")
        localStorage.setItem("banqueName", "Cash")
    }
    function ChoixBanque2e(){
        setBanqueStatus(false)
        localStorage.setItem("banqueImage", "../../images/om.png")
        localStorage.setItem("banqueName", "Orange")
    }
    function ChoixBanque2f(){
        setBanqueStatus(false)
        localStorage.setItem("banqueImage", "../../images/momo.png")
        localStorage.setItem("banqueName", "mtn")
    }
    function ChoixBanque2g(){
        setBanqueStatus(false)
        localStorage.setItem("banqueImage", "../../images/flooz.png")
        localStorage.setItem("banqueName", "Moov")
    }
    function bniClicked(){
        setBankOptionClicked1("nkp_bank_option_clicked")
        localStorage.setItem("banqueClickedName", "BNI")
        setBankOptionClicked2("")
        setBankOptionClicked3("")
        setBankOptionClicked4("")
    }
    function biciciClicked(){
        localStorage.setItem("banqueClickedName", "BICICI")
        setBankOptionClicked2("nkp_bank_option_clicked")
        setBankOptionClicked1("")
        setBankOptionClicked3("")
        setBankOptionClicked4("")
    }
    function ecobClicked(){
        localStorage.setItem("banqueClickedName", "ECOBANK")
        setBankOptionClicked3("nkp_bank_option_clicked")
        setBankOptionClicked1("")
        setBankOptionClicked2("")
        setBankOptionClicked4("")
    }
    function ubaClicked(){
        setBankOptionClicked4("nkp_bank_option_clicked")
        localStorage.setItem("banqueClickedName", "UBA")
        setBankOptionClicked1("")
        setBankOptionClicked2("")
        setBankOptionClicked3("")
    }

    function logoutHandler(){

        localStorage.clear();

        localStorage.setItem("isRActive",false)

        if(_ProWallet === "true"){
          localStorage.setItem("_ProWallet", true)
          localStorage.setItem("userStatus", "Logout")

          if(LineLink){
            window.location.replace("https://nkab-exchange.net/nkab-pro");
          } else {
             window.location.replace("http://localhost:3000/nkab-pro");
          }
        }

        if(_ProWallet === "false"){
          localStorage.setItem("_ProWallet", false)
          localStorage.setItem("userStatus", "Logout")
        }
        if(transActivated === "true"){
          localStorage.setItem("transActivated", true)
        }
        if(transActivated === "false"){
          localStorage.setItem("transActivated", false)
        }

        if(LineLink){
          window.location.replace("https://nkab-exchange.net/nkab-pro");
        } else {
           window.location.replace("http://localhost:3000/nkab-pro");
        }

    }

    const handlePasswordChange =(evnt)=>{
        setPasswordInput(evnt.target.value);
    }
    const handlePasswordConfirmChange =(evnt)=>{
        setPasswordConfirmInput(evnt.target.value);
    }
    const togglePassword =()=>{
      if(passwordType==="password") { setPasswordType("text")}
      setPasswordType("password")
    }
    const togglePasswordConfirm =()=>{
      if(passwordTypeConfirm==="password") {setPasswordTypeConfirm("text")}
      setPasswordTypeConfirm("password")
    }
    const NewCodeHandler = () => {
  
        setLoader(true)
        setStatus1(STATUS.STARTED)
  
        if(userID && userEmail && userLastName && userName && passwordInput && (passwordInput === passwordConfirmInput)){
            axios.post('/api/v1/p-code-pin/generate',
                {
                  userId : userID,
                  fullName : `${userLastName} ${userName}`,
                  codep: passwordInput,
                  email : userEmail.toLowerCase(),
                  createdAt: new Date(),
                  updatedAt: new Date(),
                },
            ).then((res)=>{
              if(res){
                setPassCodeConfirmed("Code Pin correct ! Félicitation :)")
                setNewCodeConfirmed(`Félicitation! Un nouveau code est créé avec succès!`)
              }
            })
        } else if(passwordInput !== passwordConfirmInput){
            setPassCodeConfirmed("Code Pin incorrect !")
        }
  
    }
    const codeUpdatingHandler = async () => {

        setLoader(true)

        // if(passwordInput !== "" && passwordInput.length > 3 && MyCodePinID > 0){
            if(passwordInput !== "" && passwordInput.length > 3){

            axios.post(`/api/v1/p-newcp/newcp`,
                {
                  ID: Number(MyCodePinID),
                  codep: passwordInput
                },
              )
              .then((res) => {
                  if (res.data.msg === "success") {

                    if(LineLink){
                      window.location.replace("https://nkab-exchange.net/nkab-pro");
                    } else {
                       window.location.replace("http://localhost:3000/nkab-pro");
                    }
                  }
                }
              )

        }
    }


    function seeDocHandler(){
        setSeeDoc(true)
    }
    function trc20CheckHandler(){
        setNetAddress("TRC20")
        setAddressCkecked(true)
    }
    function polkadotCheckHandler(){
        setNetAddress("POLKADOT")
        setAddressCkecked(true)
    }
    function maticCheckHandler(){
        setNetAddress("MATIC")
        setAddressCkecked(true)
    }
    function cardanoCheckHandler(){
        setNetAddress("CARDANO")
        setAddressCkecked(true)
    }
    function solanaCheckHandler(){
        setNetAddress("SOLANA")
        setAddressCkecked(true)
    }
    function bep20CheckHandler(){
        setNetAddress("BEP20")
        setAddressCkecked(true)
    }


    useEffect(()=>{

        const fetchDada12 = async () => {

            if(secondsRemaining2 === 0 || secondsRemaining2 === 5 || secondsRemaining2 === 10 || secondsRemaining2 === 15 || secondsRemaining2 === 20 || secondsRemaining2 === 25 || secondsRemaining2 === 30){
                try {
    
                    if(nkab_trans_reference !== ""){
    
                        var requestOptions = {
                            method: 'GET',
                            redirect: 'follow'
                        };
            
                        axios.post(`/api/transfers-step2`, {nkab_trans_id, requestOptions, MerchantId, MerchantIdKey})
                        .then(result => {
    
                            const MyStatus = result.data.status
    
                    
                        if(_options === "TRANSFERT") {
    
                            if(MyStatus === "successful"){
    
                                setTransSuccess(true)
                            
                                if(nkab_trans_reference !== ""){
                
                                    axios.post('/api/v1/p-trans/create',
                                        {
                                            operationUId : nkab_trans_reference,
                                            userId : userID,
                                            tr_Id: nkab_trans_id,
                                            options : _options,
                                            changeName : localStorage.getItem("changeName"),
                                            changeImage : localStorage.getItem("changeImage"),
                                            montant : Number(localStorage.getItem("amount")),
                                            email : localStorage.getItem("email"),
                                            fullName : `${userLastName} ${userName}`,
                                            phone : localStorage.getItem("phone"),
                                            status: "successful",
                                            createdAt: new Date(),
                                            updatedAt: new Date(),
                                        },
                                    ).then((res)=>{ 
                                        if(res){
                                            setMySuccess("ok")
                                            axios.post('/api/v1/notification/create-notif',
                                                {
                                                    notifierId : nkab_trans_reference,
                                                    notifyImageLink : localStorage.getItem("changeName"),
                                                    notifyServicesId : nkab_trans_reference,
                                                    notifyOperatorAction : _options,
                                                    notifySenderName : "premium",
                                                    notifySenderPhone : localStorage.getItem("phone"),
                                                    notifySenderEmail : localStorage.getItem("email"),
                                                    createdAt: new Date(),
                                                    updatedAt: new Date(),
                                                },
                                            ).then((res)=>{
                                                if(res){
                                                    axios.post('/api/v1/all-p-op/create', {
                                                        operationUId : `ref_${nkab_trans_reference}`,
                                                        userId : userID,
                                                        tr_Id: nkab_trans_id,
                                                        options : Options,
                                                        moneyName : localStorage.getItem("changeName"),
                                                        moneyImage : localStorage.getItem("changeImage"),
                                                        montant :  Number(localStorage.getItem("amount")),
                                                        converted : 0,
                                                        dollar: 0,
                                                        fullName : `${userLastName} ${userName}`,
                                                        phone : Phone,
                                                        status: "successful",
                                                        taux : 0,
                                                        netAddress : "No net Address",
                                                        adress : "no Adress",
                                                        email : userEmail.toLowerCase(),
                                                        numcompte : "null",
                                                        rdv : "null",
                                                        times : "null",
                                                        createdAt: new Date(),
                                                        updatedAt: new Date(),
                                                    },
                                                ).then((res)=>{
                                                    if(res){
                                                        setStatus1(STATUS.STOPPED)
                                                        setMySuccess("terminer")
                                                        setSeeDoc(false)
                                                        setLoader(false)
                                                        setMontant(0)
                
                                                        localStorage.removeItem("banqueImage")
                                                        localStorage.removeItem("banqueName")
                                                        localStorage.removeItem("changeImage")
                                                        localStorage.removeItem("changeName")
                                                        localStorage.removeItem("moneyImage")
                                                        localStorage.removeItem("moneyName")
                                                        localStorage.removeItem("banqueClickedName")
                                                        localStorage.removeItem("nkab_trans_reference")
                                                        localStorage.removeItem("nkab_trans_id")
                
                                                        setBanqueStatus(false)
                                                        setBankOptionClicked1("")
                                                        setBankOptionClicked2("")
                                                        setBankOptionClicked3("")
                                                        setBankOptionClicked4("")
    
                                                        if(secondsRemaining2 === 5 || secondsRemaining2 === 10 || secondsRemaining2 === 15 || secondsRemaining2 === 20 || secondsRemaining2 === 25 || secondsRemaining2 === 30){
                                                            setLoader(false)
                                                            localStorage.setItem("r_opsd",false)
                                                            localStorage.setItem("t_opsd",false)
                                                            localStorage.setItem("b_opsd",false)
                                                            setActive(false)
                                                            setStatus1(STATUS.STOPPED)
                                                            if(LineLink){
                                                                window.location.replace("https://nkab-exchange.net/nkab-pro");
                                                            } else {
                                                                window.location.replace("http://localhost:3000/nkab-pro");
                                                            }
                                                        }
    
                                                    }
    
                                                })}
                                            })
                                        }
                                        
                                    })
                                }
                            }else if(MyStatus === "failed"){
                
                                setTransFailed(true)
                            
                                if(nkab_trans_reference !== ""){
                                    axios.post('/api/v1/p-trans/create',
                                        {
                                            operationUId : nkab_trans_reference,
                                            userId : userID,
                                            tr_Id: nkab_trans_id,
                                            options : _options,
                                            changeName : localStorage.getItem("changeName"),
                                            changeImage : localStorage.getItem("changeImage"),
                                            montant : Number(localStorage.getItem("amount")),
                                            email : localStorage.getItem("email"),
                                            fullName : `${userLastName} ${userName}`,
                                            phone : localStorage.getItem("phone"),
                                            status: "failed",
                                            createdAt: new Date(),
                                            updatedAt: new Date(),
                                        },
                                    ).then((res)=>{ 
                                        if(res){
                                            setMySuccess("ok")
                                            axios.post('/api/v1/notification/create-notif',
                                                {
                                                    notifierId : nkab_trans_reference,
                                                    notifyImageLink : localStorage.getItem("changeName"),
                                                    notifyServicesId : nkab_trans_reference,
                                                    notifyOperatorAction : _options,
                                                    notifySenderName : "premium",
                                                    notifySenderPhone : localStorage.getItem("phone"),
                                                    notifySenderEmail : localStorage.getItem("email"),
                                                    createdAt: new Date(),
                                                    updatedAt: new Date(),
                                                },
                                            ).then((res)=>{
                                                if(res){
                                                    axios.post('/api/v1/all-p-op/create', {
                                                        operationUId : `ref_${nkab_trans_reference}`,
                                                        userId : userID,
                                                        tr_Id: nkab_trans_id,
                                                        options : Options,
                                                        moneyName : localStorage.getItem("changeName"),
                                                        moneyImage : localStorage.getItem("changeImage"),
                                                        montant :  Number(localStorage.getItem("amount")),
                                                        converted : 0,
                                                        dollar: 0,
                                                        fullName : `${userLastName} ${userName}`,
                                                        phone : Phone,
                                                        status: "failed",
                                                        taux : 0,
                                                        netAddress : "No net Address",
                                                        adress : "no Adress",
                                                        email : userEmail.toLowerCase(),
                                                        numcompte : "null",
                                                        rdv : "null",
                                                        times : "null",
                                                        createdAt: new Date(),
                                                        updatedAt: new Date(),
                                                    },
                                                ).then((res)=>{
                                                    if(res){
                                                        setStatus1(STATUS.STOPPED)
                                                        setMySuccess("terminer")
                                                        setSeeDoc(false)
                                                        setLoader(false)
                                                        setMontant(0)
                                                        localStorage.removeItem("banqueImage")
                                                        localStorage.removeItem("banqueName")
                                                        localStorage.removeItem("changeImage")
                                                        localStorage.removeItem("changeName")
                                                        localStorage.removeItem("moneyImage")
                                                        localStorage.removeItem("moneyName")
                                                        localStorage.removeItem("banqueClickedName")
                                                        localStorage.removeItem("nkab_trans_reference")
                                                        localStorage.removeItem("nkab_trans_id")
                                                        setBanqueStatus(false)
                                                        setBankOptionClicked1("")
                                                        setBankOptionClicked2("")
                                                        setBankOptionClicked3("")
                                                        setBankOptionClicked4("")
    
                                                        if(secondsRemaining2 === 0 || secondsRemaining2 === 5 || secondsRemaining2 === 10 || secondsRemaining2 === 15 || secondsRemaining2 === 20 || secondsRemaining2 === 25 || secondsRemaining2 === 30 || secondsRemaining2 === 35){
                                                            setLoader(false)
                                                            localStorage.setItem("r_opsd",false)
                                                            localStorage.setItem("t_opsd",false)
                                                            localStorage.setItem("b_opsd",false)
                                                            setActive(false)
                                                            setStatus1(STATUS.STOPPED)
                                                            if(LineLink){
                                                                window.location.replace("https://nkab-exchange.net/nkab-pro");
                                                            } else {
                                                                window.location.replace("http://localhost:3000/nkab-pro");
                                                            }
                                                        }
                                                    }
                                                })}
                                            })
                                        }
                                        
                                    })
                                }
                            }
                        }
                            })
                        }
                } catch (error) {}
            }
        }
        fetchDada12()

    },[secondsRemaining2, nkab_trans_id, MerchantId, MerchantIdKey])


    useEffect(()=>{

        const fetchDada13 = async () => {

            if(secondsRemaining2 === 0 || secondsRemaining2 === 5 || secondsRemaining2 === 10 || secondsRemaining2 === 15 || secondsRemaining2 === 20 || secondsRemaining2 === 25 || secondsRemaining2 === 30 || secondsRemaining2 === 35){
                if(nkab_rge_reference !== ""){

                    try {
                        if(localStorage.getItem("hub2id") && localStorage.getItem("hub2token")){

                            const hub2id = localStorage.getItem("hub2id")
                            const hub2token = localStorage.getItem("hub2token")

                                var requestOptions = {
                                    method: 'GET',
                                    redirect: 'follow'
                                };
                
                                axios.post(`/api/payment-step3`, {requestOptions, MerchantId, MerchantIdKey, hub2id, hub2token})
                                .then(result => {

                                    if(result.data.payments.length > 0){
                                        localStorage.setItem("LastStatus", result.data.payments[0].status) 
                        
                                        if(_options === "RECHARGE") {
                                
                                            if(LastStatus === "successful"){
                                
                                                setPaymentSuccess(true)
                                            
                                                if(nkab_rge_reference !== ""){
                                
                                                    axios.post('/api/v1/p-recharge/create',
                                                        {
                                                            operationUId : nkab_rge_reference,
                                                            userId : userID,
                                                            tr_Id: nkab_rge_id,
                                                            options : _options,
                                                            banqueName : localStorage.getItem("banqueName"),
                                                            banqueImage : localStorage.getItem("banqueImage"),
                                                            fullName : `${userLastName} ${userName}`,
                                                            email : userEmail.toLowerCase(),
                                                            phone : phone,
                                                            rbserved : amount,
                                                            dollar: 0,
                                                            numcompte : "Pas de Compte",
                                                            rdv : "0",
                                                            status : "successful",
                                                            times : "0",
                                                            createdAt: new Date(),
                                                            updatedAt: new Date(),
                                                        },
                                                    ).then((res)=>{ 
                                                        if(res){
                                                            setMySuccess("ok")
                                                            axios.post('/api/v1/notification/create-notif',
                                                                {
                                                                    notifierId : nkab_rge_reference,
                                                                    notifyImageLink : localStorage.getItem("banqueName"),
                                                                    notifyServicesId : nkab_rge_reference,
                                                                    notifyOperatorAction : _options,
                                                                    notifySenderName : "premium",
                                                                    notifySenderPhone : phone,
                                                                    notifySenderEmail : userEmail.toLowerCase(),
                                                                    createdAt: new Date(),
                                                                    updatedAt: new Date(),
                                                                },
                                                            ).then((res)=>{
                                                                if(res){
                                                                    axios.post('/api/v1/all-p-op/create', {
                                                                        operationUId : `ref_${nkab_rge_reference}`,
                                                                        userId : userID,
                                                                        tr_Id: nkab_rge_id,
                                                                        options : _options,
                                                                        moneyName : localStorage.getItem("banqueName"),
                                                                        moneyImage : localStorage.getItem("banqueImage"),
                                                                        montant :  amount,
                                                                        converted : 0,
                                                                        dollar: 0,
                                                                        fullName : `${userLastName} ${userName}`,
                                                                        phone : phone,
                                                                        status: "successful",
                                                                        taux : 0,
                                                                        netAddress : "No Address",
                                                                        adress : "No Adress",
                                                                        email : userEmail.toLowerCase(),
                                                                        numcompte : "Pas de Compte",
                                                                        rdv : "0",
                                                                        times : "0",
                                                                        createdAt: new Date(),
                                                                        updatedAt: new Date(),
                                                                    },
                                                                ).then((res)=>{
                                                                    if(res){
                                                                        setStatus1(STATUS.STOPPED)
                                                                        localStorage.removeItem("nkab_rge_reference")
                                                                        localStorage.removeItem("nkab_rge_id")
                                                                        localStorage.removeItem("hub2token")
                                                                        localStorage.removeItem("hub2id")
                                                                        localStorage.removeItem("LastStatus")
                                                                        localStorage.removeItem("amount")
                                                                        localStorage.removeItem("phone")
                                                                        setSeeDoc(false)
                                                                        setLoader(false)
                                                                        setMontant(0)
                                                                        localStorage.removeItem("banqueImage")
                                                                        localStorage.removeItem("banqueName")
                                                                        localStorage.removeItem("changeImage")
                                                                        localStorage.removeItem("changeName")
                                                                        localStorage.removeItem("moneyImage")
                                                                        localStorage.removeItem("moneyName")
                                                                        localStorage.removeItem("banqueClickedName")
                                                                        setBanqueStatus(false)
                                                                        setBankOptionClicked1("")
                                                                        setBankOptionClicked2("")
                                                                        setBankOptionClicked3("")
                                                                        setBankOptionClicked4("")

                                                                        if(secondsRemaining2 === 0 || secondsRemaining2 === 5 || secondsRemaining2 === 10 || secondsRemaining2 === 15 || secondsRemaining2 === 20 || secondsRemaining2 === 25 || secondsRemaining2 === 30 || secondsRemaining2 === 35){
                                                                            setLoader(false)
                                                                            localStorage.setItem("r_opsd",false)
                                                                            localStorage.setItem("t_opsd",false)
                                                                            localStorage.setItem("b_opsd",false)
                                                                            setActive(false)
                                                                            setStatus1(STATUS.STOPPED)
                                                                            if(LineLink){
                                                                                window.location.replace("https://nkab-exchange.net/nkab-pro");
                                                                            } else {
                                                                                window.location.replace("http://localhost:3000/nkab-pro");
                                                                            }
                                                                        }
                                                                    }
                                                                })}
                                                            })
                                                        }
                                                        
                                                    })
                                                }
                                            }else if(LastStatus === "failed"){
                                
                                                setPaymentFailed(true)
                                            
                                                if(nkab_rge_reference !== ""){
                                
                                                    axios.post('/api/v1/p-recharge/create',
                                                        {
                                                            operationUId : nkab_rge_reference,
                                                            userId : userID,
                                                            tr_Id: nkab_rge_id,
                                                            options : _options,
                                                            banqueName : localStorage.getItem("banqueName"),
                                                            banqueImage : localStorage.getItem("banqueImage"),
                                                            fullName : `${userLastName} ${userName}`,
                                                            email : userEmail.toLowerCase(),
                                                            phone : phone,
                                                            rbserved : amount,
                                                            dollar: 0,
                                                            numcompte : "Pas de Compte",
                                                            rdv : "0",
                                                            status : "failed",
                                                            times : "0",
                                                            createdAt: new Date(),
                                                            updatedAt: new Date(),
                                                        },
                                                    ).then((res)=>{ 
                                                        if(res){
                                                            setMySuccess("ok")
                                                            axios.post('/api/v1/notification/create-notif',
                                                                {
                                                                    notifierId : nkab_rge_reference,
                                                                    notifyImageLink : localStorage.getItem("banqueName"),
                                                                    notifyServicesId : nkab_rge_reference,
                                                                    notifyOperatorAction : _options,
                                                                    notifySenderName : "premium",
                                                                    notifySenderPhone : phone,
                                                                    notifySenderEmail : userEmail.toLowerCase(),
                                                                    createdAt: new Date(),
                                                                    updatedAt: new Date(),
                                                                },
                                                            ).then((res)=>{
                                                                if(res){
                                                                    axios.post('/api/v1/all-p-op/create', {
                                                                        operationUId : `ref_${nkab_rge_reference}`,
                                                                        userId : userID,
                                                                        tr_Id: nkab_rge_id,
                                                                        options : _options,
                                                                        moneyName : localStorage.getItem("banqueName"),
                                                                        moneyImage : localStorage.getItem("banqueImage"),
                                                                        montant :  amount,
                                                                        converted : 0,
                                                                        dollar: 0,
                                                                        fullName : `${userLastName} ${userName}`,
                                                                        phone : phone,
                                                                        status: "failed",
                                                                        taux : 0,
                                                                        netAddress : "No Address",
                                                                        adress : "No Adress",
                                                                        email : userEmail.toLowerCase(),
                                                                        numcompte : "Pas de Compte",
                                                                        rdv : "0",
                                                                        times : "0",
                                                                        createdAt: new Date(),
                                                                        updatedAt: new Date(),
                                                                    },
                                                                ).then((res)=>{
                                                                    if(res){
                                                                        setStatus1(STATUS.STOPPED)
                                                                        localStorage.removeItem("nkab_rge_reference")
                                                                        localStorage.removeItem("nkab_rge_id")
                                                                        localStorage.removeItem("hub2token")
                                                                        localStorage.removeItem("hub2id")
                                                                        localStorage.removeItem("LastStatus")
                                                                        localStorage.removeItem("amount")
                                                                        localStorage.removeItem("phone")
                                                                        setSeeDoc(false)
                                                                        setLoader(false)
                                                                        setMontant(0)
                                                                        localStorage.removeItem("banqueImage")
                                                                        localStorage.removeItem("banqueName")
                                                                        localStorage.removeItem("changeImage")
                                                                        localStorage.removeItem("changeName")
                                                                        localStorage.removeItem("moneyImage")
                                                                        localStorage.removeItem("moneyName")
                                                                        localStorage.removeItem("banqueClickedName")
                                                                        setBanqueStatus(false)
                                                                        setBankOptionClicked1("")
                                                                        setBankOptionClicked2("")
                                                                        setBankOptionClicked3("")
                                                                        setBankOptionClicked4("")

                                                                        if(secondsRemaining2 === 0 || secondsRemaining2 === 5 || secondsRemaining2 === 10 || secondsRemaining2 === 15 || secondsRemaining2 === 20 || secondsRemaining2 === 25 || secondsRemaining2 === 30 || secondsRemaining2 === 35){
                                                                            setLoader(false)
                                                                            localStorage.setItem("r_opsd",false)
                                                                            localStorage.setItem("t_opsd",false)
                                                                            localStorage.setItem("b_opsd",false)
                                                                            setActive(false)
                                                                            setStatus1(STATUS.STOPPED)
                                                                            if(LineLink){
                                                                            window.location.replace("https://nkab-exchange.net/nkab-pro");
                                                                            } else {
                                                                                window.location.replace("http://localhost:3000/nkab-pro");
                                                                            }
                                                                        }
                                                                    }
                                                                })}
                                                            })
                                                        }
                                                        
                                                    })
                                                }
                                            }
                                        }
                                    }
                                })

                        }
                    } catch (error) {}

                }
            }
        }
        fetchDada13()

    },[secondsRemaining2, nkab_rge_reference, LastStatus, MerchantId, MerchantIdKey])


    const BuyHandler = () => {
        
        if(Number(CodePin) === Number(MyCodePin)){

            setLoader(true)

            setPassConfirmed("Code Pin correct ! Félicitation :)")

            const OperationUId = uid(8)
            const OperationUId2 = uid(21)
        
            if(OperationUId && userID && Options && moneyName && moneyImage && exchange.cfa && exchange.converted && exchange.dollar && NetAddress && Adress && userEmail && taux){
                axios.post('/api/v1/p-buy/create', {
                        operationUId : `ref_${OperationUId}`,
                        userId : userID,
                        tr_Id: `sop_${OperationUId2}`,
                        options : Options,
                        moneyName,
                        moneyImage,
                        montant : exchange.cfa,
                        converted : exchange.converted,
                        dollar: exchange.dollar,
                        taux,
                        netAddress : NetAddress,
                        adress : Adress,
                        email : userEmail.toLowerCase(),
                        status: "processing",
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    },
                ).then((res)=>{ 
                    if(res){
                        setMySuccess("ok")
                        axios.post('/api/v1/notification/create-notif', {
                                notifierId : `ref_${OperationUId}`,
                                notifyImageLink : moneyName,
                                notifyServicesId : `ref_${OperationUId}`,
                                notifyOperatorAction : Options,
                                notifySenderName : "premium",
                                notifySenderPhone : operatorUserInfoPhone,
                                notifySenderEmail : userEmail.toLowerCase(),
                                createdAt: new Date(),
                                updatedAt: new Date(),
                            },
                        ).then((res)=>{
                            if(res){
                                localStorage.setItem("buy_sop", `sop_${OperationUId2}`)
                                axios.post('/api/v1/all-p-op/create', {
                                    operationUId : `ref_${OperationUId}`,
                                    userId : userID,
                                    tr_Id: `sop_${OperationUId2}`,
                                    options : Options,
                                    moneyName,
                                    moneyImage,
                                    montant : exchange.cfa,
                                    converted : exchange.converted,
                                    dollar: exchange.dollar,
                                    fullName : `${userLastName} ${userName}`,
                                    phone : Phone,
                                    status: "null",
                                    taux,
                                    netAddress : NetAddress,
                                    adress : Adress,
                                    email : userEmail.toLowerCase(),
                                    numcompte : "null",
                                    rdv : "null",
                                    times : "null",
                                    createdAt: new Date(),
                                    updatedAt: new Date(),
                                },
                            ).then((res)=>{
                                if(res){
                                    setMySuccess("terminer")
                                    setSeeDoc(false)
                                    setLoader(false)
                                    setMontant(0)
                                    localStorage.removeItem("banqueImage")
                                    localStorage.removeItem("banqueName")
                                    localStorage.removeItem("changeImage")
                                    localStorage.removeItem("changeName")
                                    localStorage.removeItem("moneyImage")
                                    localStorage.removeItem("moneyName")
                                    localStorage.removeItem("banqueClickedName")
                                    setBanqueStatus(false)
                                    setBankOptionClicked1("")
                                    setBankOptionClicked2("")
                                    setBankOptionClicked3("")
                                    setBankOptionClicked4("")
                                    localStorage.setItem("b_opsd",true)
                                    localStorage.setItem("r_opsd",false)
                                    localStorage.setItem("t_opsd",false)
                                    localStorage.setItem("isRActive",true)
    
                                    if(LineLink){
                                      window.location.replace("https://nkab-exchange.net/nkab-pro");
                                    } else {
                                       window.location.replace("http://localhost:3000/nkab-pro");
                                    }
                                }
                            })
                            }
                        })
                    }
                    
                })
            }
        } else if(Number(CodePin) !== Number(MyCodePin)){
            setPassConfirmed("Code Pin incorrect !")
        }

    }

    
    const TransferHandler = () => {

        localStorage.setItem("amount", exchange.cfa)
        localStorage.setItem("options", Options)
        localStorage.setItem("changeName", changeName)
        localStorage.setItem("changeImage", changeImage)
        localStorage.setItem("converted", exchange.converted)
        localStorage.setItem("email", userEmail.toLowerCase())
        // localStorage.setItem("fullName", `${userLastName} ${userName}`)
        localStorage.setItem("phone", Phone)

        if(Number(CodePin) === Number(MyCodePin)){

            setLoader(true)
        
            setPassConfirmed("Code Pin correct ! Félicitation :)")
        
            const OperationUId = uid(8)
            const OperationUId2 = uid(21)

            if(changeName === "Wave"){
            
                if(OperationUId && Options && changeName && changeImage && Montant && userEmail && Phone){
                    axios.post('/api/v1/p-trans/create', {
                            operationUId : `ref_${OperationUId}`,
                            userId : userID,
                            tr_Id: `sop_${OperationUId2}`,
                            options : Options,
                            changeName,
                            changeImage : changeImage,
                            montant : exchange.cfa,
                            email : userEmail.toLowerCase(),
                            fullName : `${userLastName} ${userName}`,
                            phone : Phone,
                            status: "processing",
                            createdAt: new Date(),
                            updatedAt: new Date(),
                        },
                    ).then((res)=>{ 
                        if(res){
                            axios.post('/api/v1/all-p-op/create', {
                                operationUId : `ref_${OperationUId}`,
                                userId : userID,
                                tr_Id: `sop_${OperationUId2}`,
                                options : Options,
                                moneyName : changeName,
                                moneyImage : changeImage,
                                montant : exchange.cfa,
                                converted : exchange.converted,
                                dollar: exchange.dollar,
                                fullName : `${userLastName} ${userName}`,
                                phone : Phone,
                                status: "null",
                                taux : "null",
                                netAddress : NetAddress,
                                adress : "null",
                                email : userEmail.toLowerCase(),
                                numcompte : "null",
                                rdv : "null",
                                times : "null",
                                createdAt: new Date(),
                                updatedAt: new Date(),
                            },
                        ).then((res)=>{
                            if(res){
                                setMySuccess("ok")
                                axios.post('/api/v1/notification/create-notif', {
                                        notifierId : `ref_${OperationUId}`,
                                        notifyImageLink : changeImage === "../../images/flooz.png" ? "FLOOZ" : changeImage === "../../images/om.png" ? "OM" : changeImage === "../../images/momo.png" ? "MOMO" : changeImage === "../../images/wave.png" ? "WAVE" : changeImage,
                                        notifyServicesId : `ref_${OperationUId}`,
                                        notifyOperatorAction : Options,
                                        notifySenderName : "premium",
                                        notifySenderPhone : Phone,
                                        notifySenderEmail : userEmail.toLowerCase(),
                                        createdAt: new Date(),
                                        updatedAt: new Date(),
                                    },
                                ).then((res)=>{
                                    if(res){
                                        localStorage.setItem("trans_sop", `sop_${OperationUId2}`)
                                        setMySuccess("terminer")
                                        setSeeDoc(false)
                                        setLoader(false)
                                        setMontant(0)
                                        localStorage.removeItem("banqueImage")
                                        localStorage.removeItem("banqueName")
                                        localStorage.removeItem("changeImage")
                                        localStorage.removeItem("changeName")
                                        localStorage.removeItem("moneyImage")
                                        localStorage.removeItem("moneyName")
                                        localStorage.removeItem("banqueClickedName")
                                        setBanqueStatus(false)
                                        setBankOptionClicked1("")
                                        setBankOptionClicked2("")
                                        setBankOptionClicked3("")
                                        setBankOptionClicked4("")
                                        localStorage.setItem("t_opsd",true)
                                        localStorage.setItem("b_opsd",false)
                                        localStorage.setItem("r_opsd",false)
                                        localStorage.setItem("isRActive",true)
    
                                        if(LineLink){
                                            window.location.replace("https://nkab-exchange.net/nkab-pro");
                                        } else {
                                            window.location.replace("http://localhost:3000/nkab-pro");
                                        }
                                    }
                                })
                            }
                        })
                    }
                })
                }
            } else if(changeName !== "Wave"){

                var myHeaders = new Headers();
    
                myHeaders.append("merchantId",    `${MerchantId}`);
                myHeaders.append("environment",   "live");
                myHeaders.append("Content-Type",  "application/json");
                myHeaders.append("ApiKey",        `${MerchantIdKey}`);

                
            
                var raw = JSON.stringify({
                    "reference": `ref_${OperationUId}`,
                    "amount": SenderCountry === ci ? exchange.cfa - (exchange.cfa * 0.04) : 0,
                    "currency": "XOF",
                    "description": "nkab paiement",
                    "destination": {
                    "type": "mobile_money",
                    "country": `${SenderCountry === ci ? 'CI' :SenderCountry === sen ? 'SN' :SenderCountry === mali ? 'ML' :SenderCountry === togo ? 'TG' :SenderCountry === burk ? 'BF' :SenderCountry === benin ? 'BJ' :SenderCountry === cam ? 'CM' : ""}`,
                    "provider": `${changeName}`,
                    "msisdn": `${Phone}`
                    }
                });
            
                var requestOptions = {
                    method: 'POST',
                    body: raw,
                    redirect: 'follow'
                };

                axios.post(`/api/transfers`, {requestOptions, MerchantId, MerchantIdKey})
                .then(result => {
                    if(result.data.reference){
    
                        localStorage.setItem("nkab_trans_id", result.data.id)
                        localStorage.setItem("nkab_trans_reference", result.data.reference)

                        localStorage.setItem("t_opsd",true)
                        localStorage.setItem("b_opsd",false)
                        localStorage.setItem("r_opsd",false)
                        localStorage.setItem("isRActive",true)
        
                        if(LineLink){
                            window.location.replace("https://nkab-exchange.net/nkab-pro");
                        } else {
                            window.location.replace("http://localhost:3000/nkab-pro");
                        }
                    }
                })
            }

        } else if(Number(CodePin) !== Number(MyCodePin)){
            setPassConfirmed("Code Pin incorrect !")
        }

    }

    const numCompte =   
                (banqueName  === "Virement bancaire" || banqueName === "Dépôt bancaire") && banqueClickedName === "BNI"      ? "N° Compte : 009498720006": 
                (banqueName  === "Virement bancaire" || banqueName === "Dépôt bancaire") && banqueClickedName === "BICICI"   ? "N° Compte : 010663800053": (banqueName  === "Virement bancaire" || banqueName === "Dépôt bancaire") && banqueClickedName === "ECOBANK"  ? "N° Compte : 121540971001":(banqueName  === "Virement bancaire" || banqueName === "Dépôt bancaire") && banqueClickedName === "UBA"      ? "N° Compte : 108580002659": "Pas de Compte"

  
    const rdv = !RDV?"0":RDV
    const _time = !Times?"0":Times



    const RechargeHandler = () => {

        setLoader(true)

        setPassConfirmed("Code Pin correct ! Félicitation :)")
        setStatus1(STATUS.STARTED)

        const OperationUId = uid(8)
        const OperationUId2 = uid(21)

        // if(image && (banqueName  === "Virement bancaire")){
        //     // if(image && (banqueName  === "Virement bancaire" || banqueName === "Dépôt bancaire")){

        //     // console.log(userID)
        //     // console.log(..._formData)
        //     // console.log(image)

        //     // axios.post('/api/v1/bordereau-img',
        //     // { 
        //     //     userID: userID,
        //     //     file : _formData,
        //     //     image,
        //     //     createdAt: new Date(),
        //     //     updatedAt: new Date(),
        //     // })
        //     // .then((res)=>{
        //     //     console.log(res)

        //     //     // if(userID && OperationUId && _options && banqueName && userEmail && userLastName && userName && Phone && numCompte && rdv){
        //     //     //     axios.post(
        //     //     //         '/api/v1/p-recharge/create',
        //     //     //         {
        //     //     //             operationUId : `ref_${OperationUId}`,
        //     //     //             userId : userID,
        //     //     //             tr_Id: `sop_${OperationUId2}`,
        //     //     //             options : _options,
        //     //     //             banqueName,
        //     //     //             banqueImage,
        //     //     //             fullName : `${userLastName} ${userName}`,
        //     //     //             email : userEmail.toLowerCase(),
        //     //     //             phone : Phone,
        //     //     //             rbserved : Number(Montant),
        //     //     //             acountName : AountName,
        //     //     //             acountCredName : AcountCredName,
        //     //     //             serviceBankName : ServiceBankName,
        //     //     //             dollar: 0,
        //     //     //             numcompte : banqueName === "Cash" || banqueName === "Wave" ? "..." : numCompte,
        //     //     //             rdv,
        //     //     //             status : "processing",
        //     //     //             times : _time,
        //     //     //             createdAt: new Date(),
        //     //     //             updatedAt: new Date(),
        //     //     //         },
        //     //     //     ).then((res)=>{ 
        //     //     //         if(res){
        //     //     //             axios.post('/api/v1/all-p-op/create', {
        //     //     //                 operationUId : `ref_${OperationUId}`,
        //     //     //                 userId : userID,
        //     //     //                 tr_Id: `sop_${OperationUId2}`,
        //     //     //                 options : _options,
        //     //     //                 moneyName : banqueName,
        //     //     //                 moneyImage : banqueImage,
        //     //     //                 montant : Number(Montant),
        //     //     //                 converted : "null",
        //     //     //                 dollar: 0,
        //     //     //                 fullName : `${userLastName} ${userName}`,
        //     //     //                 phone : Phone,
        //     //     //                 status: "null",
        //     //     //                 taux : "null",
        //     //     //                 netAddress : NetAddress,
        //     //     //                 adress : "null",
        //     //     //                 email : userEmail.toLowerCase(),
        //     //     //                 numcompte : banqueName === "Cash" || banqueName === "Wave" ? "..." : numCompte,
        //     //     //                 rdv,
        //     //     //                 times : _time,
        //     //     //                 createdAt: new Date(),
        //     //     //                 updatedAt: new Date(),
        //     //     //             },
        //     //     //         ).then((res)=>{
        //     //     //             if(res){
        //     //     //                 axios.post(
        //     //     //                     '/api/v1/notification/create-notif',
        //     //     //                     {
        //     //     //                     notifierId : `ref_${OperationUId}`,
        //     //     //                     notifyImageLink : banqueName,
        //     //     //                     notifyServicesId : `ref_${OperationUId}`,
        //     //     //                     notifyOperatorAction : _options,
        //     //     //                     notifySenderName : "premium",
        //     //     //                     notifySenderPhone : Phone,
        //     //     //                     notifySenderEmail : userEmail.toLowerCase(),
        //     //     //                     createdAt: new Date(),
        //     //     //                     updatedAt: new Date(),
        //     //     //                     },
        //     //     //                 ).then((res)=>{
        //     //     //                     if(res && banqueName === "Wave"){
        //     //     //                         localStorage.setItem("rch_sop", `sop_${OperationUId2}`)
        //     //     //                         setSeeDoc(false)
        //     //     //                         setLoader(false)
        //     //     //                         setMontant(0)
        //     //     //                         localStorage.removeItem("banqueImage")
        //     //     //                         localStorage.removeItem("banqueName")
        //     //     //                         localStorage.removeItem("changeImage")
        //     //     //                         localStorage.removeItem("changeName")
        //     //     //                         localStorage.removeItem("moneyImage")
        //     //     //                         localStorage.removeItem("moneyName")
        //     //     //                         localStorage.removeItem("banqueClickedName")
        //     //     //                         setBanqueStatus(false)
        //     //     //                         setBankOptionClicked1("")
        //     //     //                         setBankOptionClicked2("")
        //     //     //                         setBankOptionClicked3("")
        //     //     //                         setBankOptionClicked4("")
        //     //     //                         localStorage.setItem("r_opsd", true)
        //     //     //                         localStorage.setItem("t_opsd",false)
        //     //     //                         localStorage.setItem("b_opsd",false)
        //     //     //                         localStorage.setItem("isRActive",true)
        //     //     //                         window.location.replace(`${wavePaymentLink}`)
        //     //     //                     }else if(res && banqueName !== "Wave"){
        //     //     //                         localStorage.setItem("rch_sop", `sop_${OperationUId2}`)
        //     //     //                         setSeeDoc(false)
        //     //     //                         setLoader(false)
        //     //     //                         setMontant(0)
        //     //     //                         localStorage.removeItem("banqueImage")
        //     //     //                         localStorage.removeItem("banqueName")
        //     //     //                         localStorage.removeItem("changeImage")
        //     //     //                         localStorage.removeItem("changeName")
        //     //     //                         localStorage.removeItem("moneyImage")
        //     //     //                         localStorage.removeItem("moneyName")
        //     //     //                         localStorage.removeItem("banqueClickedName")
        //     //     //                         setBanqueStatus(false)
        //     //     //                         setBankOptionClicked1("")
        //     //     //                         setBankOptionClicked2("")
        //     //     //                         setBankOptionClicked3("")
        //     //     //                         setBankOptionClicked4("")
        //     //     //                         localStorage.setItem("r_opsd", true)
        //     //     //                         localStorage.setItem("t_opsd",false)
        //     //     //                         localStorage.setItem("b_opsd",false)
        //     //     //                         localStorage.setItem("isRActive",true)
            
        //     //     //                         if(LineLink){
        //     //     //                         window.location.replace("https://nkab-exchange.net/nkab-pro");
        //     //     //                         } else {
        //     //     //                         window.location.replace("http://localhost:3000/nkab-pro");
        //     //     //                         }
        //     //     //                     }
        //     //     //                 })
        //     //     //             }
        //     //     //         })
                        
        //     //     //     }})
        //     //     // }
        //     // })
        // } else 
        if(userID && OperationUId && _options && banqueName && userEmail && userLastName && userName && Phone && numCompte && rdv){
            axios.post(
                '/api/v1/p-recharge/create',
                {
                    operationUId : `ref_${OperationUId}`,
                    userId : userID,
                    tr_Id: `sop_${OperationUId2}`,
                    options : _options,
                    banqueName,
                    banqueImage,
                    fullName : `${userLastName} ${userName}`,
                    email : userEmail.toLowerCase(),
                    phone : Phone,
                    rbserved : Number(Montant),
                    acountName : AountName,
                    acountCredName : AcountCredName,
                    serviceBankName : ServiceBankName,
                    dollar: 0,
                    numcompte : banqueName === "Cash" || banqueName === "Wave" ? "..." : numCompte,
                    rdv,
                    status : "processing",
                    times : _time,
                    createdAt: new Date(),
                    updatedAt: new Date(),
                },
            ).then((res)=>{ 
                if(res){
                    axios.post('/api/v1/all-p-op/create', {
                        operationUId : `ref_${OperationUId}`,
                        userId : userID,
                        tr_Id: `sop_${OperationUId2}`,
                        options : _options,
                        moneyName : banqueName,
                        moneyImage : banqueImage,
                        montant : Number(Montant),
                        converted : "null",
                        dollar: 0,
                        fullName : `${userLastName} ${userName}`,
                        phone : Phone,
                        status: "null",
                        taux : "null",
                        netAddress : NetAddress,
                        adress : "null",
                        email : userEmail.toLowerCase(),
                        numcompte : banqueName === "Cash" || banqueName === "Wave" ? "..." : numCompte,
                        rdv,
                        times : _time,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                    },
                ).then((res)=>{
                    if(res){
                        axios.post(
                            '/api/v1/notification/create-notif',
                            {
                              notifierId : `ref_${OperationUId}`,
                              notifyImageLink : banqueName,
                              notifyServicesId : `ref_${OperationUId}`,
                              notifyOperatorAction : _options,
                              notifySenderName : "premium",
                              notifySenderPhone : Phone,
                              notifySenderEmail : userEmail.toLowerCase(),
                              createdAt: new Date(),
                              updatedAt: new Date(),
                            },
                          ).then((res)=>{
                            if(res && banqueName === "Wave"){
                                localStorage.setItem("rch_sop", `sop_${OperationUId2}`)
                                setSeeDoc(false)
                                setLoader(false)
                                setMontant(0)
                                localStorage.removeItem("banqueImage")
                                localStorage.removeItem("banqueName")
                                localStorage.removeItem("changeImage")
                                localStorage.removeItem("changeName")
                                localStorage.removeItem("moneyImage")
                                localStorage.removeItem("moneyName")
                                localStorage.removeItem("banqueClickedName")
                                setBanqueStatus(false)
                                setBankOptionClicked1("")
                                setBankOptionClicked2("")
                                setBankOptionClicked3("")
                                setBankOptionClicked4("")
                                localStorage.setItem("r_opsd", true)
                                localStorage.setItem("t_opsd",false)
                                localStorage.setItem("b_opsd",false)
                                localStorage.setItem("isRActive",true)
                                window.location.replace(`${wavePaymentLink}`)
                            }else if(res && banqueName !== "Wave"){
                                localStorage.setItem("rch_sop", `sop_${OperationUId2}`)
                                setSeeDoc(false)
                                setLoader(false)
                                setMontant(0)
                                localStorage.removeItem("banqueImage")
                                localStorage.removeItem("banqueName")
                                localStorage.removeItem("changeImage")
                                localStorage.removeItem("changeName")
                                localStorage.removeItem("moneyImage")
                                localStorage.removeItem("moneyName")
                                localStorage.removeItem("banqueClickedName")
                                setBanqueStatus(false)
                                setBankOptionClicked1("")
                                setBankOptionClicked2("")
                                setBankOptionClicked3("")
                                setBankOptionClicked4("")
                                localStorage.setItem("r_opsd", true)
                                localStorage.setItem("t_opsd",false)
                                localStorage.setItem("b_opsd",false)
                                localStorage.setItem("isRActive",true)
    
                                if(LineLink){
                                  window.location.replace("https://nkab-exchange.net/nkab-pro");
                                } else {
                                   window.location.replace("http://localhost:3000/nkab-pro");
                                }
                            }
                          })
                    }
                })
                
            }})
        }

        

    }


    //   useEffect(()=>{

    //         if(PaymentSuccess || PaymentFailed || TransSuccess || TransFailed){
    //             localStorage.setItem("r_opsd",false)
    //             localStorage.setItem("t_opsd",false)
    //             localStorage.setItem("b_opsd",false)
    //             setActive(false)
    //             setStatus1(STATUS.STOPPED)
    //         }

    //   },[PaymentFailed, PaymentSuccess, STATUS.STOPPED, TransFailed, TransSuccess])

    //Intention de paiement 
    function RechargePaymentHandler(){

        setLoader(true)

        setPassConfirmed("Code Pin correct ! Félicitation :)")
        setStatus1(STATUS.STARTED)

        const OperationUId = uid(8)

        const montants = Number((Number(Number(Montant)+(Number(Montant)*PayInRate))*1).toFixed(0))

        localStorage.setItem("amount", Number(Montant))
        localStorage.setItem("phone", Phone)

        var raw = JSON.stringify({
          "customerReference": `ref_${OperationUId}`,
          "purchaseReference": `ref_${new Date()}`,
          "amount": montants,
          "currency": "XOF"
        });
            
        var requestOptions = {
          method: 'POST',
          body: raw,
          redirect: 'follow'
        };

        axios.post(`/api/payment`, {requestOptions, MerchantId, MerchantIdKey})
        .then(result => {

            if(result.data.id && result.data.token){

                localStorage.setItem("hub2id", result.data.id)
                localStorage.setItem("hub2token", result.data.token)

                var raw2 = JSON.stringify({
                    "token": result.data.token,
                    "paymentMethod": "mobile_money",
                    "country": `${SenderCountry === _ci ? 'CI' :SenderCountry === _sen ? 'SN' :SenderCountry === _mali ? 'ML' :SenderCountry === _togo ? 'TG' :SenderCountry === _burk ? 'BF' :SenderCountry === _benin ? 'BJ' :SenderCountry === _niger ? 'CM' : ""}`,
                    "provider": `${banqueName}`,
                    "mobileMoney": {
                        "msisdn": `${Phone}`,
                        "otp": `${CodeSecret}`
                    }
                });
            
                var requestOptions2 = {
                    method: 'POST',
                    body: raw2,
                    redirect: 'follow'
                };

                if(localStorage.getItem("hub2id") !== ""){

                    const hub2id = localStorage.getItem("hub2id")
    
                    axios.post(`/api/payment-step2`, {requestOptions2, MerchantId, MerchantIdKey, hub2id})

                    .then(result => {
                        localStorage.setItem("nkab_rge_id", result.data.id)
                        localStorage.setItem("nkab_rge_reference", result.data.customerReference)
                        localStorage.setItem("nkab_rge_token", result.data.token)
        
                        if(result.data.token){
                            localStorage.setItem("r_opsd", true)
                            localStorage.setItem("t_opsd",false)
                            localStorage.setItem("b_opsd",false)
                            localStorage.setItem("isRActive",true)
                        }
                        
                    })
                }
            }
        })
        
    }


    // function TestForRechargePaymentHandler(){

    //     setLoader(true)

    //     setPassConfirmed("Code Pin correct ! Félicitation :)")
    //     setStatus1(STATUS.STARTED)

    //     const OperationUId = uid(8)
        
    //     var myHeaders = new Headers();
    //     myHeaders.append("merchantId", `${MerchantId}`);
    //     myHeaders.append("environment", "live");
    //     myHeaders.append("Content-Type", "application/json");
    //     myHeaders.append("ApiKey", `${MerchantIdKey}`);
        
    //     var raw = JSON.stringify({
    //       "customerReference": `ref_${OperationUId}`,
    //       "purchaseReference": `ref_${new Date()}`,
    //       "amount": Number(Montant)+(Number(Montant)*PayInRate)+((Number(Montant)*PayInRate)*PayInRate),
    //       "currency": "XOF"
    //     });
        
    //     var requestOptions = {
    //       method: 'POST',
    //       headers: myHeaders,
    //       body: raw,
    //       redirect: 'follow'
    //     };

    //     // 1 Créer une intention de paiement
    //     fetch("https://api.hub2.io/payment-intents", requestOptions)
    //       .then(response => response.json())
    //       .then(response => {
            
    //         if(response.token){

    //             var raw = JSON.stringify({
    //                 "url": "https://nkab-exchange.net/nkabhook/pi",
    //                 "events": [
    //                   "payment_intent.created",
    //                   "payment_intent.processing",
    //                   "payment_intent.succeeded",
    //                   "payment_intent.action_required",
    //                   "payment_intent.payment_failed"
    //                 ],
    //                 "description": "Intention de paiement",
    //                 "metadata": {},
    //                 "status": "enabled"
    //               });
                  
    //               var requestOptions2 = {
    //                 method: 'POST',
    //                 body: raw,
    //                 redirect: 'follow'
    //               };
                  
    //               fetch("https://api.hub2.io/webhooks/", requestOptions2)
    //                 .then(response => response.json())
    //                 .then(response => {

    //                     if(response.id !== ""){
    //                         var raw = JSON.stringify({
    //                             "url": "https://nkab-exchange.net/nkabhook/pi",
    //                             "description": "Mise à jour d'intention de paiement",
    //                             "events": [
    //                               "payment_intent.created",
    //                               "payment_intent.processing",
    //                               "payment_intent.succeeded",
    //                               "payment_intent.action_required",
    //                               "payment_intent.payment_failed"
    //                             ],
    //                             "metadata": {},
    //                             "status": "enabled"
    //                           });
                              
    //                           var requestOptions3 = {
    //                             method: 'PATCH',
    //                             body: raw,
    //                             redirect: 'follow'
    //                           };
                              
    //                           fetch(`https://api.hub2.io/webhooks/${response.id}`, requestOptions3)
    //                           .then(result => result.json())
    //                           .then(result => {

    //                             if(result.id !==""){

    //                                 localStorage.setItem("hub2id", response.id)
    //                                 localStorage.setItem("hub2token", response.token)

    //                                 // setNextMessageOtp(response.nextAction.message)

    //                                 var raw4 = JSON.stringify({
    //                                     "token": response.token,
    //                                     "paymentMethod": "mobile_money",
    //                                     "country": `${SenderCountry === _ci ? 'CI' :SenderCountry === _sen ? 'SN' :SenderCountry === _mali ? 'ML' :SenderCountry === _togo ? 'TG' :SenderCountry === _burk ? 'BF' :SenderCountry === _benin ? 'BJ' :SenderCountry === _niger ? 'CM' : ""}`,
    //                                     "provider": `${banqueName}`,
    //                                     "mobileMoney": {
    //                                         "msisdn": `${Phone}`,
    //                                         "otp": `${CodeSecret}`
    //                                     }
    //                                 });
                                
    //                                 var requestOptions4 = {
    //                                     method: 'POST',
    //                                     body: raw4,
    //                                     redirect: 'follow'
    //                                 };
            
    //                                 fetch(`https://api.hub2.io/payment-intents/${response.id}/payments`, requestOptions4)
    //                                 .then(response => response.json())
    //                                 .then(result => {

    //                                     if(result.token){

    //                                         var raw = JSON.stringify({
    //                                             "url": "https://nkab-exchange.net/nkabhook/pt",
    //                                             "events": [
    //                                             "payment.created",
    //                                             "payment.pending",
    //                                             "payment.succeeded",
    //                                             "payment.action_required",
    //                                             "payment.failed"
    //                                             ],
    //                                             "description": "Création de paiement",
    //                                             "metadata": {},
    //                                             "status": "enabled"
    //                                         });
                                            
    //                                         var requestOptions = {
    //                                             method: 'POST',
    //                                             headers: myHeaders,
    //                                             body: raw,
    //                                             redirect: 'follow'
    //                                         };
                                            
    //                                         fetch("https://api.hub2.io/webhooks/", requestOptions)
    //                                         .then(response => response.json())
    //                                         .then(response => {

    //                                             if(response){

    //                                                 var raw = JSON.stringify({
    //                                                     "url": "https://nkab-exchange.net/nkabhook/pt",
    //                                                     "description": "Mise à jour de paiement",
    //                                                     "events": [
    //                                                     "payment.created",
    //                                                     "payment.pending",
    //                                                     "payment.succeeded",
    //                                                     "payment.action_required",
    //                                                     "payment.failed"
    //                                                     ],
    //                                                     "metadata": {},
    //                                                     "status": "enabled"
    //                                                 });
                                                    
    //                                                 var requestOptions = {
    //                                                     method: 'PATCH',
    //                                                     body: raw,
    //                                                     redirect: 'follow'
    //                                                 };
                                                    
    //                                                 fetch(`https://api.hub2.io/webhooks/${response.id}`, requestOptions)
    //                                                 .then(response => response.json())
    //                                                 .then(response => {

    //                                                     if(response.id !==""){

    //                                                         setMySuccess("terminer")

    //                                                         localStorage.setItem("amount", exchange.cfa)
    //                                                         localStorage.setItem("userId", userID)
    //                                                         localStorage.setItem("options", Options)
    //                                                         localStorage.setItem("banqueName", banqueName)
    //                                                         localStorage.setItem("banqueImage", banqueName === "Cash" || banqueName === "Wave" || banqueName === "Orange" || banqueName === "mtn" || banqueName === "Moov" ? banqueName : banqueClickedName)
    //                                                         localStorage.setItem("converted", exchange.converted)
    //                                                         localStorage.setItem("email", userEmail.toLowerCase())
    //                                                         localStorage.setItem("fullName", `${userLastName} ${userName}`)
    //                                                         localStorage.setItem("phone", Phone)
    //                                                         localStorage.setItem("rbserved", Number(Montant))
    //                                                         localStorage.setItem("dollar", dollar)
    //                                                         localStorage.setItem("numcompte", banqueName === "Cash" || banqueName === "Wave" || banqueName === "Orange" || banqueName === "mtn" || banqueName === "Moov" ? "..." : numCompte)
    //                                                         localStorage.setItem("rdv", rdv)
    //                                                         localStorage.setItem("times", _time)

    //                                                         localStorage.setItem("customerReference", result.customerReference)

    //                                                         localStorage.setItem("r_opsd", true)
    //                                                         localStorage.setItem("t_opsd",false)
    //                                                         localStorage.setItem("b_opsd",false)
    //                                                         localStorage.setItem("isRActive",true)

    //                                                         if(LineLink){
    //                                                         window.location.replace("https://nkab-exchange.net/nkab-pro");
    //                                                         } else {
    //                                                         window.location.replace("http://localhost:3000/nkab-pro");
    //                                                         }
    //                                                     }
    //                                                 }).catch(error => console.log('error', error));
    //                                             }
    //                                         }).catch(error => console.log('error', error));

    //                                     }
    //                                 }).catch(error => console.log('error', error));
    //                             }
    //                         }).catch(error => console.log('error', error));
    //                     }
    //                 })
    //         }
    //     }).catch(error => console.log('error', error));
  
    // }

    function RechargeListing(){
        setRechargeListings(true)
        setTransfertListings(false)
        setBuyListings(false)
    }
    function TransfertListing(){
        setTransfertListings(true)
        setBuyListings(false)
        setRechargeListings(false)
    }
    function BuyListing(){
        setBuyListings(true)
        setRechargeListings(false)
        setTransfertListings(false)
    }
    function UnRechargeListing(){
        setRechargeListings(false)
        setBuyListings(true)
    }
    function UnTransfertListing(){
        setTransfertListings(false)
        setBuyListings(true)
    }
    function UnBuyListing(){
        setBuyListings(false)
    }
    function seePriceHandler(){
        setSeePrice(true)
    }
    function unSeePriceHandler(){
        setSeePrice(false)
    }

    const avatar = "https://res.cloudinary.com/dlo6aumre/image/upload/v1660554752/avatar_j3kap7.png"
    let imgUrl = '../../images/crypto_img_pro1.jpg'

    function faqHandler0(){
        setFaq0(true)
    }

    function faqHandler0b(){
        setFaq0(false)
    }

    function faqHandler1(){
        setFaq1(true)
    }

    function faqHandler1b(){
        setFaq1(false)
    }

    function faqHandler2(){
        setFaq2(true)
    }

    function faqHandler2b(){
        setFaq2(false)
    }

    function faqHandler3(){
        setFaq3(true)
    }

    function faqHandler3b(){
        setFaq3(false)
    }

    function faqHandler4(){
        setFaq4(true)
    }

    function faqHandler4b(){
        setFaq4(false)
    }

    function faqHandler5(){
        setFaq5(true)
    }

    function faqHandler5b(){
        setFaq5(false)
    }

    var nkp_faq_title_hovered = "nkp_faq_title_hovered"

    const [NkabSearchResult, setNkabSearchResult] = useState([])


    const currencyData = [
        {
            id : 0,
            image: "../../images/btc.png",
            title: "BTC",
            content : "bitcoin"
        },
        {
            id : 1,
            image: "../../images/usdt.png",
            title: "USDT",
            content : "tether"
        },
        {
            id : 2,
            image: "../../images/busd.png",
            title: "BUSD",
            content : "binance usd"
        },
        {
            id : 3,
            image: "../../images/ltc.png",
            title: "LTC",
            content : "litecoin"
        },
        {
            id : 4,
            image: "../../images/pm.png",
            title: "PM",
            content : "perfect money"
        },
        {
            id : 5,
            image: "../../images/tron.png",
            title: "TRON",
            content : "tron"
        },
        {
            id : 6,
            image: "../../images/doge.png",
            title: "DOGE",
            content : "doge coin"
        },
        {
            id : 7,
            image: "../../images/eth.png",
            title: "ETH",
            content : "ethereum"
        },
        {
            id : 8,
            image: "../../images/chainlink.png",
            title: "LINK",
            content : "chainlink"
        },
        {
            id : 9,
            image: "../../images/solana.png",
            title: "SOL",
            content : "solana"
        },
    ]

    var handleSearchCurrency = (e) => {

        var {value} = e.target

        if(currencyData && value){
          var SearchUser = currencyData.filter((obj)=>{
            return obj.content.includes(!value?"":value)
          })
    
          setNkabSearchResult(SearchUser)
        }
      }

    const cureencyHandler = (id) => {
        setCurrencyChecked(currencyData[id].image)
        setCurrencyCheckedContent(currencyData[id].content)
        setCurrencyCheckedSymbol(currencyData[id].title)
    }

    const cureencyHandler2 = (id) => {
        setCurrencyChecked2(currencyData[id].image)
        setCurrencyCheckedContent2(currencyData[id].content)
        setCurrencyCheckedSymbol2(currencyData[id].title)
    }

    const INIT2 = { montant: 0, converted: 0, cfa: 0, dollar: 0 }
  
    const [exchange2, setExchange2] = useState(INIT2)
    const [Calculate, setCalculate] = useState("")

    const handleCurrencyCount1 = (e) => {

    const { value, name } = e.target

    setCalculate(value)

    if(CurrencyCheckedContent === "bitcoin" && CurrencyCheckedContent2 === "tether"){
        const val = !value ? 1 : Number(value.trim())
        const dollar = val * Number(btcPrice)
        const converted = 0
        const cfa = 0

        setExchange2({
            [name]: val,
            converted,
            cfa,
            dollar,
        })
    }
    }

    const handleCurrencyCount2 = (e) => {

    const { value, name } = e.target

    if(CurrencyCheckedContent2 === "tether"){
        const val = Number(value.trim())
        const dollar = val / taux
        const converted = (dollar / Number(usdtPrice))
        const cfa = Number((val).toFixed(0))

        setExchange({
            [name]: val,
            converted,
            cfa,
            dollar,
        })
    }
    }

    useEffect(()=>{
    if(Options === "RECHARGE"){
        localStorage.removeItem("moneyName")
    }
    if(Options === "TRANSFERT"){
        localStorage.removeItem("banqueName")
    }
    },[Options])

    const [Accepter, setAccepter] = useState(false)

    function handleAccepter(){
        setAccepter(true)
    }

    function handleUnAccepter(){
        setAccepter(false)
    }

    var [BuyItemAlert, setBuyItemAlert] = useState("")
    var [TransItemAlert, setTransItemAlert] = useState("")
    var [RechargeItemAlert, setRechargeItemAlert] = useState("")
    var [PhoneAlert, setPhoneAlert] = useState("")

    useEffect(()=>{

        if(Options === "ACHAT" && (Number(Currency) > 1 || Number(Montant) > 1) && !moneyImage){
            setBuyItemAlert("Vous devez choisir un opérateur et ressaisissez le montant à nouveau !")
            setTransItemAlert("")
        }

        if(Options === "ACHAT" && (Number(Currency) === 0 && Number(Montant) === 0) && moneyImage !== ""){
            setBuyItemAlert("")
            setTransItemAlert("")
        }

        if(Options === "TRANSFERT" && (Number(Montant) > 1)  && !changeImage){
            setTransItemAlert("Vous devez choisir un opérateur et ressaisissez le montant à nouveau !")
            setBuyItemAlert("")
        }

        if(Options === "TRANSFERT" && (Number(Montant) === 0)  && changeImage !== ""){
            setTransItemAlert("")
            setBuyItemAlert("")
        }

        if(Options === "RECHARGE" && (Number(Montant) > 1)  && !banqueName){
            setRechargeItemAlert("Vous devez choisir une monnaie et ressaisissez le montant à nouveau !")
        }

        if(Options === "RECHARGE" && (Number(Montant) === 0)  && banqueName !== ""){
            setRechargeItemAlert("")
        }

        if(Options === "RECHARGE" && Phone !== ""){
            setPhoneAlert("ok")
        }

        if(Options === "RECHARGE" && Phone === ""){
            setPhoneAlert("")
        }

    },[Options, Montant, Currency, moneyImage, changeImage, Phone, banqueName])

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const [BuyingListing, setBuyingListing] = useState(false)
  const [ChargingListing, setChargingListing] = useState(false)
  const [TransListing, setTransListing] = useState(false)

  const detailBying = () => {
    if(BuyData.length > 0){

        const items = BuyData.slice(0, 10)
        if(items.length > 0){
            setDetailData(items)
        }
        setBuyingListing(true)
        setChargingListing(false)
        setTransListing(false)
    }
  }

  const detailCharging = () => {
    if(RechargeData.length > 0){

        const items = RechargeData.slice(0, 10)
        if(items.length > 0){
            setDetailData(items)
        }

        setChargingListing(true)
        setBuyingListing(false)
        setTransListing(false)
    }
  }

  const detailSending = () => {
    if(TransData.length > 0){

        const items = TransData.slice(0, 10)
        if(items.length > 0){
            setDetailData(items)
        }
        
        setTransListing(true)
        setBuyingListing(false)
        setChargingListing(false)
    }
  }

  const OM      = "Orange"
  const MOMO    = "mtn"
  const MOOV    = "Moov"
  const WAVE    = "Wave"

  const om      = "../images/om.png"
  const momo    = "../images/momo.png"
  const flooz   = "../images/flooz.png"
  const wave    = "../images/wave.png"

  const NkabPackPrice1 = 10
  const NkabPackPrice2 = 60
  const NkabPackPrice3 = 120

  const [premium, setPremium] = useState(false)
  const [NkabPack1, setNkabPack1] = useState(false)
  const [NkabPack2, setNkabPack2] = useState(false)
  const [NkabPack3, setNkabPack3] = useState(false)
  const [NkabSpinner,  setNkabSpinner] = useState(false)
  const [PremiumStatus,  setPremiumStatus] = useState("")
  const [OpListe,  setOpListe] = useState(false)
  const [Msg,  setMsg] = useState("")
  const [NkabPackPrice,  setNkabPackPrice] = useState([])

  const radioHandler1 = (e) => {
    const {value} = e.target
    setPremiumStatus(value)
  }

  const radioHandler2 = (e) => {
    const {value} = e.target
    setPremiumStatus(value)
  }

  const radioHandler3 = (e) => {
    const {value} = e.target
    setPremiumStatus(value)
  }

  function premiumPack(){
    setPremium(!premium)
    setOpListe(OpListe)
  }

  function opListeHandler(){
    setOpListe(!OpListe)
    setPremium(premium)
  }

  function premiumPack2(){

    if(LineLink){
    window.location.replace("https://nkab-exchange.net/nkab-pro");
    } else {
    window.location.replace("http://localhost:3000/nkab-pro");
    }

  }

  function firstNkabPack(){
    setNkabPack1(!NkabPack1)
    setNkabPack2(false)
    setNkabPack3(false)
    setNkabSpinner(false)
    setNkabPackPrice(NkabPackPrice1)
  }

  function secondNkabPack(){
    setNkabPack1(false)
    setNkabPack2(!NkabPack2)
    setNkabPack3(false)
    setNkabSpinner(false)
    setNkabPackPrice(NkabPackPrice2)
  }

  function firsdNkabPack(){
    setNkabPack1(false)
    setNkabPack2(false)
    setNkabPack3(!NkabPack3)
    setNkabSpinner(false)
    setNkabPackPrice(NkabPackPrice3)
  }

  function finalNkabPackBack(){
    setNkabPack1(false)
    setNkabPack2(false)
    setNkabPack3(false)
    setNkabSpinner(false)
    setPremium(true)
  }

    const date = new Date();

    const NkabPackLastMinutes = `${date.getHours()}:${date.getMinutes()}`

    const NkabPackFirstDate = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`

    const NkabPackLastDate = `${date.getDate()}/${date.getMonth() + 2}/${date.getFullYear()}`

  function finalNkabPack(){

    setNkabSpinner(true)
    setNkabPack1(false)
    setNkabPack2(false)
    setNkabPack3(false)

    if(PremiumStatus && userID && NkabPackPrice && NkabPackFirstDate && NkabPackLastDate && NkabPackLastMinutes){

        axios.post('/api/create-premium-pack/subscribe',
            {
                userId:             userID,
                premiumStatus:      PremiumStatus,
                premiumPrice:       NkabPackPrice,
                premiumFirstDate:   NkabPackFirstDate,
                premiumLastDate:    NkabPackLastDate,
                premiumLastMinutes: NkabPackLastMinutes,
                premiumActive:      true,
                createdAt:          new Date(),
                updatedAt:          new Date(),
            },
          )
          .then((res)=>{
            if(res.data.msg === 'success'){
                setMsg("Votre abonnement effectué avec succès!")
            }
          })

    }

  }

  useEffect(()=>{
      if(NkabPackFirstDate === PremiumsData.premiumLastDate){

        const fetchData = async () => {
          try {
            
            axios.post(`/api/update-premium-pack/subscribe`,
              {
                ID : PremiumsData.ID,
                premiumActive: false,
                createdAt: new Date(),
                updatedAt: new Date(),
              },
            )
            .then(
              (response) => {
                if (response.data.msg === 'success') {

                  if(LineLink){
                  window.location.replace("https://nkab-exchange.net/nkab-pro");
                  } else {
                  window.location.replace("http://localhost:3000/nkab-pro");
                  }
  
                }
              },
              (error) => {
                console.log(error)
              },
            )
    
          } catch (error) { }
        }
        fetchData()

      }
  },[NkabPackFirstDate, PremiumsData, LineLink])

  function premiumDesable(){

    try {
            
        axios.post(`/api/update-premium-pack/subscribe`,
          {
            ID : PremiumsData.ID,
            premiumActive: false,
            createdAt: new Date(),
            updatedAt: new Date(),
          },
        )
        .then(
          (response) => {
            if (response.data.msg === 'success') {

              if(LineLink){
              window.location.replace("https://nkab-exchange.net/nkab-pro");
              } else {
              window.location.replace("http://localhost:3000/nkab-pro");
              }

            }
          },
          (error) => {
            console.log(error)
          },
        )

      } catch (error) { }
  }

//   const [imageUrl, setImageUrl] = useState(null);
//   const [image, setImage] = useState(null);
//   const [imagePath, setImagePath] = useState('');


//   const handleImageUrlChange = (e) => {

//         const file = e.target.files[0];
//         setImageUrl(e.target.files[0])

//         const reader = new FileReader();

//         reader.onloadend = () => {
//             setImage(reader.result);
//         };
    
//         if (file) {
//             reader.readAsDataURL(file);
//         }

//         if (file) {
//             const reader = new FileReader();
//             reader.onload = function (event) {
//                 // Récupérer le chemin local de l'image
//                 const localPath = URL.createObjectURL(file);
//                 setImagePath(localPath);
//             };
//             reader.readAsDataURL(file);
//         }
//     };

    // const handleSaveImage = async () => {

    //     const formData = new FormData();
    //     formData.append('image', imageUrl);

    //     console.log(formData)

    //     try {
    //         const response = await axios.post('/api/v1/bordereau-img', formData, {
    //             headers: {
    //             'Content-Type': 'multipart/form-data',
    //             },
    //         });

    //       console.log(response)

    //     //   if (response.status === 200) {
    //     //     alert('Image téléchargée avec succès.');
    //     //     setImage(null); // Réinitialiser l'état de l'image après le téléchargement réussi si nécessaire
    //     //   } else {
    //     //     alert('Une erreur est survenue lors du téléchargement de l\'image.');
    //     //   }

    //     } catch (error) {
    //         console.error('Erreur lors du téléchargement de l\'image:', error);
    //         // alert('Une erreur est survenue lors du téléchargement de l\'image.');
    //     }
    // };



    // const handleSaveImage = async (e) => {
    //     e.preventDefault()
    //     try {

    //         if(imageUrl){

    //             var formdata = new FormData()
    //             // console.log(file)
    //             formdata.append('file', imageUrl)

    //             console.log(imageUrl)
        
    //             const res = await axios.post('/api/v1/bordereau-img', formdata)
    //             console.log(res)

    //         }
    //     } catch (err) {}
    //   }


    // const [CLimage, setCLImage] = useState('');
    // const [loading, setLoading] = useState(false);

    // const CLOUD_NAME = 'dlo6aumre'
    // const CLOUD_API_KEY = 535486837517372
    // const CLOUD_API_SECRET = 'dIP1yh7k0t0DgJemmRpbwofGcco'

    // const uploadImage = async (e) => {
    //     setLoading(true);
    //     const file = e.target.files[0];
    //     const formData = new FormData();
    //     formData.append('file', file);
    //     formData.append('upload_preset', 'dIP1yh7k0t0DgJemmRpbwofGcco');
    //     const response = await fetch('https://api.cloudinary.com/v1_1/dlo6aumre/image/upload', {
    //     method: 'POST',
    //     body: formData
    //     });
    //     const data = await response.json();
    //     setCLImage(data.secure_url);
    //     setLoading(false);
    // };

    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [res, setRes] = useState({});
    const handleSelectFile = (e) => setFile(e.target.files[0]);

    const handleUpload = async () => {
        try {
            setLoading(true);
            const data = new FormData();
            data.append("my_file", file);
            const res = await axios.post('/api/v1/bordereau-img', data);
            setRes(res.data);
            console.log(res.data)
        } catch (error) {
            alert(error.message);
        } finally {
            setLoading(false);
        }
    };




    const [insistLogout, setInsistLogout ] = useState(false)

    useEffect(() => {
      if (insistLogout === true) {
  
        if(LineLink){
          window.location.replace("https://nkab-exchange.net/nkab-pro");
        } else {
           window.location.replace("http://localhost:3000/nkab-pro");
        }
      }
  
    }, [insistLogout])

    function handleLogout(){
  
      localStorage.clear();
  
      if(_ProWallet === "true"){
        localStorage.setItem("isRActive",false)
        localStorage.setItem("_ProWallet", true)
        localStorage.setItem("userStatus", "Logout")
  
        if(LineLink){
          window.location.replace("https://nkab-exchange.net/login");
        } else {
           window.location.replace("http://localhost:3000/login");
        }
      }
      if(_ProWallet === "false"){
        localStorage.setItem("isRActive",false)
        localStorage.setItem("_ProWallet", false)
        localStorage.setItem("userStatus", "Logout")
      }
      
      localStorage.setItem("isRActive",false)
  
      if(LineLink){
        window.location.replace("https://nkab-exchange.net/login");
      } else {
         window.location.replace("http://localhost:3000/login");
      }
    }

    function handleLoggIn(){
      setInsistLogout(true)
      if(LineLink){
        window.location.replace("https://nkab-exchange.net/login");
      } else {
         window.location.replace("http://localhost:3000/login");
      }
    }


    const [anchorElNav, setAnchorElNav] = useState(null);
    const [anchorElUser, setAnchorElUser] = useState(null);
  
    const handleOpenNavMenu = (event) => {
      setAnchorElNav(event.currentTarget);
    };

    const handleOpenUserMenu = (event) => {
      setAnchorElUser(event.currentTarget);
    };
  
    const handleCloseNavMenu = () => {
      setAnchorElNav(null);
    };
  
    const handleCloseUserMenu = () => {
      setAnchorElUser(null);
    };

    var [themeMode, setThemeMode] = useState()
    
    let ThemeMode = localStorage.getItem("ThemeMode")

    const homeHandler = () =>{
      setAnchorElNav(null);
      if(LineLink){
        window.location.replace("https://nkab-exchange.net/nkab-pro");
      } else {
         window.location.replace("http://localhost:3000/nkab-pro");
      }
    }

    function backHomeHanlder(){
  
      if(LineLink){
        window.location.replace("https://nkab-exchange.net/nkab-pro");
      } else {
         window.location.replace("http://localhost:3000/nkab-pro");
      }
    }
    
    useEffect(()=>{
      
      if(secondsRemaining2 > 0){
        setThemeMode(ThemeMode)
      }
    
    },[ThemeMode, secondsRemaining2])

    function lightMode(){
      setAnchorElNav(null);
      localStorage.setItem("ThemeMode", true)
    }
  
    function nightMode(){
      setAnchorElNav(null);
      localStorage.setItem("ThemeMode", false)
    }

    const whatsappHandler = () => {
      setAnchorElNav(null);
      window.location.replace("https://chat.whatsapp.com/B9DsCr6DeaPLeN4CWbk0R1");
    }
  
    const telegramHandler = () => {
      setAnchorElNav(null);
      window.location.replace("https://t.me/+wTl8DCgNOwI5YWI0");
    }


  return (
    <div>
        <div>
        <AppBar position="static" className={`${themeMode === "true" ? "nav-t css-1x7skt0" : "nav-l css-1x7skt0"}`}>
            <Container maxWidth="xl" className='css-1qnavfx-MuiPaper-root-MuiAppBar-root css-hip9hq-MuiPaper-root-MuiAppBar-root'>
                <Toolbar disableGutters>
                    <img src="../../images/logo2.png" className="nkp_logo nkab_logo_mobile mr-2 pointer"  alt="logo nkab" onClick={backHomeHanlder}/>
                    <Typography
                    variant="h6"
                    noWrap
                    onClick={homeHandler}
                    sx={{
                        mr: 2,
                        display: { xs: 'none', md: 'flex' },
                        fontFamily: 'monospace',
                        fontWeight: 700,
                        letterSpacing: '.3rem',
                        textDecoration: 'none',
                    }}
                    className={`${themeMode === "true" ? "color-t pointer" : "color-l pointer"}`}
                    >
                    NKAB EXCHANGE
                    </Typography>

                    <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                    <IconButton
                        size="large"
                        aria-label="account of current user"
                        aria-controls="menu-appbar"
                        aria-haspopup="true"
                        onClick={handleOpenNavMenu}
                        className={`${themeMode === "true" ? "color-t" : "color-l"}`}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Menu
                        id="menu-appbar"
                        anchorEl={anchorElNav}
                        anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                        }}
                        keepMounted
                        transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                        }}
                        open={Boolean(anchorElNav)}
                        onClose={handleCloseNavMenu}
                        sx={{
                        display: { xs: 'block', md: 'none' },
                        }}
                    >
                        <MenuItem className={`${themeMode === "true" ? "nav-t" : "nav-l"} ${Options === "RECHARGE"?"nkp_Options":"recharge-text"}`} onClick={ChoixOption3}><Typography textAlign="center" style={{color:`${themeMode === "true" ? "#90d9ff" : "#0a146e"}`}}><FontAwesomeIcon icon={faPlusCircle} /> Recharger</Typography></MenuItem>
                        <MenuItem className={`${themeMode === "true" ? "nav-t" : "nav-l"} ${Options === "ACHAT"?"nkp_Options":"buy-text"}`} onClick={ChoixOption1}><Typography textAlign="center" style={{color:`${themeMode === "true" ? "#90d9ff" : "#0a146e"}`}}><FontAwesomeIcon icon={faMoneyBill} /> Acheter</Typography></MenuItem>
                        <MenuItem className={`${themeMode === "true" ? "nav-t" : "nav-l"} ${Options === "TRANSFERT"?"nkp_Options":"transfert-text"}`} onClick={ChoixOption2}><Typography textAlign="center" style={{color:`${themeMode === "true" ? "#90d9ff" : "#0a146e"}`}}><FontAwesomeIcon icon={faExchangeAlt} /> Transférer</Typography></MenuItem>
                        <MenuItem className={`${themeMode === "true" ? "nav-t" : "nav-l"} ${Options === "NEWCODE"?"nkp_Options":"newcode-text"}`} onClick={ChoixOption5}><Typography textAlign="center" style={{color:`${themeMode === "true" ? "#90d9ff" : "#0a146e"}`}}><FontAwesomeIcon icon={faKey} /> Générer un code</Typography></MenuItem>
                        <MenuItem className={`${themeMode === "true" ? "nav-t" : "nav-l"}`} onClick={whatsappHandler}>
                        <Typography textAlign="center">
                            <span className="icoFacebook" style={{color:`${themeMode === "true" ? "#90d9ff" : "#0a146e"}`}}>
                            <img src="../../images/whatsapp-icon.png" alt="Whatsapp" width="25" />Communauté
                            </span>
                        </Typography>
                        </MenuItem>
                        <MenuItem className={`${themeMode === "true" ? "nav-t" : "nav-l"}`} onClick={telegramHandler}>
                        <Typography textAlign="center">
                            <span className="icoFacebook" style={{color:`${themeMode === "true" ? "#90d9ff" : "#0a146e"}`}}>
                            <img src="../../images/telegram-icon.png" alt="Telegram" width="25" />Communauté
                            </span>
                        </Typography>
                        </MenuItem>
                        <MenuItem className={`${themeMode === "true" ? "nav-t" : "nav-l"}`}>
                        <Typography>
                            {
                            ThemeMode === "true" ?
                            <div className="nav-item pt-2 ml-3" onClick={nightMode}>
                                <span style={{color:`${themeMode === "true" ? "#90d9ff" : "#0a146e"}`}}></span> <LightModeIcon className='pointer' style={{color:`${themeMode === "true" ? "#90d9ff" : "#0a146e"}`}} /> <span><strong style={{color:`${themeMode === "true" ? "#90d9ff" : "#0a146e"}`}}> Thème</strong></span>
                            </div>:
                            <div className="nav-item pt-2 ml-3" onClick={lightMode}>
                                <span style={{color:`${themeMode === "true" ? "#90d9ff" : "#0a146e"}`}}></span> <BedtimeIcon className='pointer'  style={{color:`${themeMode === "true" ? "#90d9ff" : "#0a146e"}`}} /> <span><strong style={{color:`${themeMode === "true" ? "#90d9ff" : "#0a146e"}`}}> Thème</strong></span>
                            </div>
                            }
                        </Typography>
                        </MenuItem>
                    </Menu>
                    </Box>
                    <Typography
                    variant="h5"
                    noWrap
                    onClick={homeHandler}
                    sx={{
                        mr: 2,
                        display: { xs: 'flex', md: 'none' },
                        flexGrow: 1,
                        fontFamily: 'monospace',
                        fontWeight: 700,
                        letterSpacing: '.2rem',
                        textDecoration: 'none',
                    }}
                    className={`${themeMode === "true" ? "color-t pointer" : "color-l pointer"}`}
                    >
                    NKAB EXCHANGE
                    </Typography >
                    <Box variant="h5" sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex'} }}></Box>
                    <Box variant="h5" sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex'} }}>
                    <Button onClick={ChoixOption3} sx={{ my: 2, color: `${themeMode === "true" ? "#90d9ff" : "#0a146e"}`, display: 'block', fontWeight: 700, letterSpacing: '.1rem' }}><FontAwesomeIcon icon={faPlusCircle} /> <span style={{fontSize:"14px"}}>Recharger</span></Button>
                    <Button onClick={ChoixOption1} sx={{ my: 2, color: `${themeMode === "true" ? "#90d9ff" : "#0a146e"}`, display: 'block', fontWeight: 700, letterSpacing: '.1rem' }}><FontAwesomeIcon icon={faMoneyBill} /><span style={{fontSize:"14px"}}>Acheter</span></Button>
                    <Button onClick={ChoixOption2} sx={{ my: 2, color: `${themeMode === "true" ? "#90d9ff" : "#0a146e"}`, display: 'block', fontWeight: 700, letterSpacing: '.1rem' }}><FontAwesomeIcon icon={faExchangeAlt} /> <span style={{fontSize:"14px"}}>Transférer</span></Button>
                    <Button onClick={ChoixOption5} sx={{ my: 2, color: `${themeMode === "true" ? "#90d9ff" : "#0a146e"}`, display: 'block', fontWeight: 700, letterSpacing: '.1rem' }}><FontAwesomeIcon icon={faKey} /> <span style={{fontSize:"14px"}}>Générer un code</span></Button>
                    </Box>
                    <Box variant="h5" sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex'} }}>
                        <Button onClick={whatsappHandler} sx={{ my: 2, color: 'white', display: 'block', letterSpacing: '.1rem' }}>
                        <img src="../../images/whatsapp-icon.png" alt="Whatsapp" width="35" />
                        </Button>
                        <Button onClick={telegramHandler} sx={{ my: 2, color: 'white', display: 'block', letterSpacing: '.1rem' }}>
                        <img src="../../images/telegram-icon.png" alt="Telegram" width="35" />
                        </Button>
                        <Button onClick={handleCloseNavMenu} sx={{ my: 2, color: `${themeMode === "true" ? "#90d9ff" : "#0a146e"}`, display: 'block', fontWeight: 700, letterSpacing: '.1rem' }}>
                        {
                            Logged === 'Logged' ?
                            <div className='text-center nkab-deconnect deconnect-bg pointer' onClick={handleLogout}>
                                <span><strong className='community-title icoFacebook' style={{color:`${themeMode === "true" ? "#90d9ff" : "#0a146e"}`}}> Déconnexion </strong></span>
                            </div> :
                            <div className='text-center nkab-deconnect connect-bg pointer' onClick={handleLoggIn}>
                            <span><strong className='community-title icoFacebook' style={{color:`${themeMode === "true" ? "#90d9ff" : "#0a146e"}`}}> Connexion </strong></span>
                            </div>
                        }</Button>
                        <Button sx={{ my: 2, color: 'white', display: 'block', fontWeight: 700, letterSpacing: '.1rem' }}>
                        {
                            ThemeMode === "true" ?
                            <div onClick={nightMode}>
                            <span style={{color:`${themeMode === "true" ? "#90d9ff" : ""}`}}></span> <LightModeIcon className='pointer' style={{color:`${themeMode === "true" ? "#90d9ff" : ""}`}} /> <span><strong style={{color:`${themeMode === "true" ? "#90d9ff" : ""}`}}> Thème</strong></span>
                            </div>:
                            <div onClick={lightMode}>
                            <span style={{color:`${themeMode === "true" ? "#90d9ff" : "#0a146e"}`}}></span> <BedtimeIcon className='pointer'  style={{color:`${themeMode === "true" ? "#90d9ff" : "#0a146e"}`}} /> <span><strong style={{color:`${themeMode === "true" ? "#90d9ff" : "#0a146e"}`}}> Thème</strong></span>
                            </div>
                        }
                        </Button>
                    </Box>

                    <Box sx={{ flexGrow: 0 }}>
                        <Tooltip title="Open settings">
                            {
                            Logged === 'Logged' ?<>
                                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                                <Avatar sx={{ width: 32, height: 32 }}>
                                    <img src="../../images/nkab-avatar.png" width="30" alt="nkab avatar" />
                                </Avatar>
                                </IconButton>
                            </>:null
                            }
                        </Tooltip>
                        <Menu
                            sx={{ mt: '45px' }}
                            id="menu-appbar"
                            anchorEl={anchorElUser}
                            anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        keepMounted
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        open={Boolean(anchorElUser)}
                        onClose={handleCloseUserMenu}
                        >
                        <MenuItem className={`${themeMode === "true" ? "nav-t" : "nav-l"}`}>
                            <Typography style={{color:`${themeMode === "true" ? "#90d9ff" : "#0a146e"}`}} textAlign="center"> 
                            <span className='nkab-premium'>Premium</span> 
                            </Typography>
                        </MenuItem>
                        <MenuItem className={`${themeMode === "true" ? "nav-t" : "nav-l"}`}>
                            <Typography style={{color:`${themeMode === "true" ? "#90d9ff" : "#0a146e"}`}} textAlign="center" onClick={ChoixOption4}> 
                                <FontAwesomeIcon icon={faUserAlt} /> Profil 
                            </Typography>
                        </MenuItem>
                        <MenuItem className={`${themeMode === "true" ? "nav-t" : "nav-l"}`}>
                            <Typography style={{color:`${themeMode === "true" ? "#90d9ff" : "#0a146e"}`}} textAlign="center" onClick={opListeHandler}> 
                                <FontAwesomeIcon icon={faListAlt} /> Historique 
                            </Typography>
                        </MenuItem>
                        <MenuItem className={`${themeMode === "true" ? "nav-t" : "nav-l"}`}>
                            <Typography style={{color:`${themeMode === "true" ? "#90d9ff" : "#0a146e"}`}} textAlign="center"> 
                                <ReactSwitch className='react-switch-handle' checked={checked} onChange={toogleHandleChange} /> Lite 
                            </Typography>
                        </MenuItem>
                        <MenuItem className={`${themeMode === "true" ? "nav-t" : "nav-l"}`}>
                            <Typography style={{color:`${themeMode === "true" ? "#90d9ff" : "#0a146e"}`}} textAlign="center" onClick={logoutHandler}> 
                                <FontAwesomeIcon icon={faSignOutAlt} /> Déconnexion 
                            </Typography>
                        </MenuItem>
                        </Menu>
                    </Box>
                </Toolbar>
            </Container>
        </AppBar>
        </div>



        <div>
            <div className='nkp_body'>
                <div style = {{ backgroundSize: 'cover', backgroundPosition: 'center center',backgroundRepeat: 'no-repeat'}}>
                    {
                        OpListe ? 
                        <div>
                            <div className="pr-4 pl-4 __pro-body-table">
                                <table className='__op-responsive-table'>
                                    <thead>
                                        <tr>
                                            <th scope="col">Id</th>
                                            <th scope="col">Email</th>
                                            <th scope="col">Option</th>
                                            <th scope="col">Par</th>
                                            <th scope="col">Montant</th>
                                            <th scope="col">Contact</th>
                                            <th scope="col">N°Compte</th>
                                            <th scope="col">Statu</th>
                                            <th scope="col">Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            RF.length > 0 && RF.map((items)=>
                                            <tr key={items.ID} style={{color:'#0e2a47'}}>
                                                <th scope="row"><span>{items.operationUId}</span></th>
                                                <td data-title="Email">{items.email}</td>
                                                <td data-title="Option">{items.options}</td>
                                                <td data-title="Par">{items.moneyName}</td>
                                                <td data-title="Montant"><strong>{items.montant}</strong></td>
                                                <td data-title="Contact">{items.phone}</td>
                                                <td data-title="N°Compte">{items.numcompte}</td>
                                                <td data-title="N°Compte">{items.status}</td>
                                                <td data-title="Date">{items.updatedAt.slice(0, 10)} à{' '} {Number(items.updatedAt.slice(11,13))}{items.updatedAt.slice(13, 19)}</td>
                                            </tr>)
                                        }
                                    </tbody>
                                </table>
                                <div>
                                    <div className='text-center p-2'><span className="stat-btn-see-more" onClick={seeMoreItemsHandler}>Voir plus <FontAwesomeIcon icon={faArrowRight} /></span></div>
                                </div>
                            </div>
                        </div>:
                        premium && Msg === "" ? 
                        <div className='container pb-5'>
                            <div className='text-center mt-5'><h1 className='color-b'> <strong>Plans Flexibles Pour Tous</strong> </h1></div>
                            <div className='text-center'><h5>Nos plans sont faits pour tous. Que vous débutiez sur notre plateforme ou que vous y soyez depuis longtemps, nous avons un plan qui vous convient.</h5></div>
                            <div className='text-center mt-5'>
                                <FormControl>
                                    <FormLabel id="demo-radio-buttons-group-label">Choix périodique</FormLabel>
                                    {
                                        (NkabPack1 || NkabPack2 || NkabPack3) && PremiumStatus === "" ? <Alert severity="error">Veuillez sélectionner une période avant de poursuivre!</Alert> : null 
                                    }
                                    <RadioGroup aria-labelledby="demo-radio-buttons-group-label" defaultValue="female" name="radio-buttons-group" >
                                        <div>
                                            <span><FormControlLabel className='color-black' value="mensuellement" control={<Radio />} label="Facturé mensuellement" onChange={radioHandler1} /></span>
                                            <span><FormControlLabel className='color-black' value="semestriellement" control={<Radio />} label="Facturé semestriellement" onChange={radioHandler2} /></span>
                                            <span><FormControlLabel className='color-black' value="annuellement" control={<Radio />} label="Facturé annuellement" onChange={radioHandler3} /></span>
                                        </div>
                                    </RadioGroup>
                                </FormControl>
                             </div>
                             {
                                NkabPack1 && PremiumStatus !== "" ? 
                                <div className='mt-4'>
                                    <div className='m-1'>
                                        <Card sx={{ minWidth: 275 }}>
                                            <CardContent>
                                                <div className='text-center'>
                                                    <h2 className='nkab-premium-period-title'>${NkabPackPrice1}<span className='nkab-premium-period-slash'>/</span><span className='nkab-premium-period'>mois</span></h2>
                                                </div>
                                                <div className='text-center'>
                                                    <span className='uppercase'>Facturé <strong className='text-success'>{PremiumStatus}</strong></span>
                                                </div>
                                                <div><hr/></div>
                                                <div>
                                                    <span className='mr-2 text-success'><CheckCircleIcon/></span>
                                                    <span className='color-grey'>Taux actuel <strong>675 XOF</strong></span>
                                                </div>
                                                <div>
                                                    <span className='mr-2 text-success'><CheckCircleIcon/></span>
                                                    <span className='color-grey'>Avantage : <strong>de 675 XOF à 670 XOF</strong></span>
                                                </div>
                                                <div>
                                                    <span className='mr-2 text-success'><CheckCircleIcon/></span>
                                                    <span className='color-grey'>Réduction de <strong>5 XOF</strong></span>
                                                </div>
                                                <div>
                                                    <span className='mr-2 text-success'><CheckCircleIcon/></span>
                                                    <span className='color-grey'>Achetez aux taux de <strong>670 XOF</strong></span>
                                                </div>
                                            </CardContent>
                                            <div className='text-center'><Alert severity="warning">Une fois votre souscription terminée vous ne pourez plus la modifier avant la date d'expiration!</Alert></div>
                                            <CardActions>
                                                <Button fullWidth variant="contained" sx={{ mt: 3, mb: 2, bgcolor: '#c21515' }} onClick={finalNkabPackBack}> Annuler </Button>
                                                <Button fullWidth variant="contained" sx={{ mt: 3, mb: 2, bgcolor: '#c7b301' }} onClick={finalNkabPack}> { !NkabSpinner?"Finaliser la souscription":<div className="nkab-spinner"></div> } </Button>
                                            </CardActions>
                                        </Card>
                                    </div>
                                </div>:null
                             }
                             {
                                NkabPack2 && PremiumStatus !== "" ? 
                                <div className='mt-4'>
                                    <div className='m-1'>
                                        <Card sx={{ minWidth: 275 }}>
                                            <CardContent>
                                                <div className='text-center'>
                                                    <h2 className='nkab-premium-period-title'>${NkabPackPrice2}<span className='nkab-premium-period-slash'>/</span><span className='nkab-premium-period'>semestre</span></h2>
                                                </div>
                                                <div className='text-center'>
                                                    <span className='uppercase'>Facturé <strong className='text-success'>{PremiumStatus}</strong></span>
                                                </div>
                                                    <div><hr/></div>
                                                <div>
                                                    <span className='mr-2 text-success'><CheckCircleIcon/></span>
                                                    <span className='color-grey'>Taux actuel <strong>675 XOF</strong></span>
                                                </div>
                                                <div>
                                                    <span className='mr-2 text-success'><CheckCircleIcon/></span>
                                                    <span className='color-grey'>Avantage : <strong>de 675 XOF à 665 XOF</strong></span>
                                                </div>
                                                <div>
                                                    <span className='mr-2 text-success'><CheckCircleIcon/></span>
                                                    <span className='color-grey'>Réduction de <strong>10 XOF</strong></span>
                                                </div>
                                                <div>
                                                    <span className='mr-2 text-success'><CheckCircleIcon/></span>
                                                    <span className='color-grey'>Achetez aux taux de <strong>665 XOF</strong></span>
                                                </div>
                                            </CardContent>
                                            <div className='text-center'><Alert severity="warning">Une fois votre souscription terminée vous pourez plus la modifier avant la date d'expiration!</Alert></div>
                                            <CardActions>
                                                <Button fullWidth variant="contained" sx={{ mt: 3, mb: 2, bgcolor: '#c21515' }} onClick={finalNkabPackBack}> Annuler </Button>
                                                <Button fullWidth variant="contained" sx={{ mt: 3, mb: 2, bgcolor: '#c7b301' }} onClick={finalNkabPack}> { !NkabSpinner?"Finaliser la souscription":<div className="nkab-spinner"></div> }  </Button>
                                            </CardActions>
                                        </Card>
                                    </div>
                                </div>:null
                             }
                             {
                                NkabPack3 && PremiumStatus !== "" ? 
                                <div className='mt-4'>
                                    <div className='m-1'>
                                        <Card sx={{ minWidth: 275 }}>
                                            <CardContent>
                                                <div className='text-center'>
                                                    <h2 className='nkab-premium-period-title'>${NkabPackPrice3}<span className='nkab-premium-period-slash'>/</span><span className='nkab-premium-period'>an</span></h2>
                                                </div>
                                                <div className='text-center'>
                                                    <span className='uppercase'>Facturé <strong className='text-success'>{PremiumStatus}</strong></span>
                                                </div>
                                                <div><hr/></div>
                                                <div>
                                                    <span className='mr-2 text-success'><CheckCircleIcon/></span>
                                                    <span className='color-grey'>Taux actuel <strong>675 XOF</strong></span>
                                                </div>
                                                <div>
                                                    <span className='mr-2 text-success'><CheckCircleIcon/></span>
                                                    <span className='color-grey'>Avantage : <strong>de 675 XOF à 660 XOF</strong></span>
                                                </div>
                                                <div>
                                                    <span className='mr-2 text-success'><CheckCircleIcon/></span>
                                                    <span className='color-grey'>Réduction de <strong>15 XOF</strong></span>
                                                </div>
                                                <div>
                                                    <span className='mr-2 text-success'><CheckCircleIcon/></span>
                                                    <span className='color-grey'>Achetez aux taux de <strong>660 XOF</strong></span>
                                                </div>
                                            </CardContent>
                                            <div className='text-center'><Alert severity="warning">Une fois votre souscription terminée vous pourez plus la modifier avant la date d'expiration!</Alert></div>
                                            <CardActions>
                                                <Button fullWidth variant="contained" sx={{ mt: 3, mb: 2, bgcolor: '#c21515' }} onClick={finalNkabPackBack}> Annuler </Button>
                                                <Button fullWidth variant="contained" sx={{ mt: 3, mb: 2, bgcolor: '#c7b301' }} onClick={finalNkabPack}> { !NkabSpinner?"Finaliser la souscription":<div className="nkab-spinner"></div> }  </Button>
                                            </CardActions>
                                        </Card>
                                    </div>
                                </div>:null
                             }
                             <div className='nkab-subscribe-cards mt-4'>
                                 <div className='m-1'>
                                     <Card sx={{ minWidth: 275 }}>
                                         <CardContent>
                                             <div className='text-center'>
                                                 <h2 className='nkab-premium-period-title'>${NkabPackPrice1}<span className='nkab-premium-period-slash'>/</span><span className='nkab-premium-period'>mois</span></h2>
                                             </div>
                                             <div className='text-center'>
                                                 <span>Plan parfect si tu débutes maintenant.</span>
                                             </div>
                                             <div><hr/></div>
                                             <div>
                                                 <span className='mr-2 text-success'><CheckCircleIcon/></span>
                                                 <span className='color-grey'>Taux actuel <strong>675 XOF</strong></span>
                                             </div>
                                             <div>
                                                 <span className='mr-2 text-success'><CheckCircleIcon/></span>
                                                 <span className='color-grey'>Avantage : <strong>de 675 XOF à 670 XOF</strong></span>
                                             </div>
                                             <div>
                                                 <span className='mr-2 text-success'><CheckCircleIcon/></span>
                                                 <span className='color-grey'>Réduction de <strong>5 XOF</strong></span>
                                             </div>
                                             <div>
                                                 <span className='mr-2 text-success'><CheckCircleIcon/></span>
                                                 <span className='color-grey'>Achetez aux taux de <strong>670 XOF</strong></span>
                                             </div>
             
                                         </CardContent>
                                         {
                                            NkabPack1 ? null:
                                            <CardActions>
                                                {
                                                    PremiumStatus === "mensuellement" ? 
                                                    <Button fullWidth variant="contained" sx={{ mt: 3, mb: 2, bgcolor: '#c7b301' }} onClick={firstNkabPack}> Souscire Maintenant </Button>:
                                                    <Button fullWidth variant="contained" sx={{ mt: 3, mb: 2, bgcolor: '#5e5c5c' }}> Souscire Maintenant </Button>
                                                }
                                            </CardActions>
                                         }
                                     </Card>
                                 </div>
                                 <div className='m-1'>
                                     <Card sx={{ minWidth: 275 }}>
                                         <CardContent>
                                             <div className='text-center'>
                                                 <h2 className='nkab-premium-period-title'>${NkabPackPrice2}<span className='nkab-premium-period-slash'>/</span><span className='nkab-premium-period'>semestre</span></h2>
                                             </div>
                                             <div className='text-center'>
                                                 <span>Plan parfect et encore mieux.</span>
                                             </div>
                                             <div><hr/></div>
                                             <div>
                                                 <span className='mr-2 text-success'><CheckCircleIcon/></span>
                                                 <span className='color-grey'>Taux actuel <strong>675 XOF</strong></span>
                                             </div>
                                             <div>
                                                 <span className='mr-2 text-success'><CheckCircleIcon/></span>
                                                 <span className='color-grey'>Avantage : <strong>de 675 XOF à 665 XOF</strong></span>
                                             </div>
                                             <div>
                                                 <span className='mr-2 text-success'><CheckCircleIcon/></span>
                                                 <span className='color-grey'>Réduction de <strong>10 XOF</strong></span>
                                             </div>
                                             <div>
                                                 <span className='mr-2 text-success'><CheckCircleIcon/></span>
                                                 <span className='color-grey'>Achetez aux taux de <strong>665 XOF</strong></span>
                                             </div>
             
                                         </CardContent>
                                         {
                                            NkabPack2 ? null:
                                            <CardActions>
                                                {
                                                    PremiumStatus === "semestriellement" ? 
                                                    <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2, bgcolor: '#c7b301' }} onClick={secondNkabPack}> Souscire Maintenant </Button>:
                                                    <Button fullWidth variant="contained" sx={{ mt: 3, mb: 2, bgcolor: '#5e5c5c' }}> Souscire Maintenant </Button>
                                                }
                                            </CardActions>
                                         }
                                     </Card>
                                 </div>
                                 <div className='m-1'>
                                     <Card sx={{ minWidth: 275 }}>
                                         <CardContent>
                                             <div className='text-center'>
                                                 <h2 className='nkab-premium-period-title'>${NkabPackPrice3}<span className='nkab-premium-period-slash'>/</span><span className='nkab-premium-period'>an</span></h2>
                                             </div>
                                             <div className='text-center'>
                                                 <span>Plan parfect beaucoup plus confortable.</span>
                                             </div>
                                             <div><hr/></div>
                                             <div>
                                                 <span className='mr-2 text-success'><CheckCircleIcon/></span>
                                                 <span className='color-grey'>Taux actuel <strong>675 XOF</strong></span>
                                             </div>
                                             <div>
                                                 <span className='mr-2 text-success'><CheckCircleIcon/></span>
                                                 <span className='color-grey'>Avantage : <strong>de 675 XOF à 660 XOF</strong></span>
                                             </div>
                                             <div>
                                                 <span className='mr-2 text-success'><CheckCircleIcon/></span>
                                                 <span className='color-grey'>Réduction de <strong>15 XOF</strong></span>
                                             </div>
                                             <div>
                                                 <span className='mr-2 text-success'><CheckCircleIcon/></span>
                                                 <span className='color-grey'>Achetez aux taux de <strong>660 XOF</strong></span>
                                             </div>
             
                                         </CardContent>
                                         {
                                            NkabPack3 ? null:
                                            <CardActions>
                                                {
                                                    PremiumStatus === "annuellement" ? 
                                                    <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2, bgcolor: '#c7b301' }} onClick={firsdNkabPack} > Souscire Maintenant </Button>:
                                                    <Button fullWidth variant="contained" sx={{ mt: 3, mb: 2, bgcolor: '#5e5c5c' }}> Souscire Maintenant </Button>
                                                }
                                            </CardActions>
                                         }
                                     </Card>
                                 </div>
                             </div>
                        </div>:
                        premium && Msg !== "" ? 
                        <div className='container pb-5'>
                            <div className='text-center mt-5'><h1 className='text-success uppercase'> <strong>Félicitation!</strong> </h1></div>
                            <div className='mt-3 text-center'><Alert severity="success">{Msg}<span className='ml-4 nkab-lite-start pointer' onClick={premiumPack2}>OK</span></Alert></div>
                        </div>:
                        <div>
                            <div></div>
                            {/* <div>
                                <div>
                                    <div className='text-center'>
                                        <p className='nkp_main_title'>Achat sécurisé avec E-NKAB.</p>
                                    </div>
                                </div>
                            </div> */}
                            <div className='d-flex justify-content-around op-pro-section'>
                                {Options === "PROFIL"?null:<div className='pt-4 phone-item'><img className='mr-2' src="../../images/home-phone2.png" width="500" alt="" /></div>}
                                <div>
                                    {Options === "PROFIL" ? 
                                    <div className="nkp_profil_center mt-3 mb-3">
                                        <div className="nkp_profil_card">
                                            <div className="nkp_profil_profile-container">
                                                <img src={`${avatar}`} alt="#" />
                                            </div>
                                            
                                            <div className="nkp_profil_name-container">
                                                <h2>{userLastName} {userName}</h2>
                                                <p><span className='nkp_profil_btn'>Modifier le profil <FontAwesomeIcon icon={faUserEdit} /></span></p>
                                            </div>
                                            
                                            <div className="row">
                                                <div className="nkp_profil_posts-container col-md-4">
                                                    <h4>{!BuyData?null:BuyData.length}</h4>
                                                    <p className='text-success d-flex pointer' onClick={detailBying}><span>Achat</span><span className='nkp-eyes-see-more'><FontAwesomeIcon icon={faEye} /></span></p>
                                                </div>
                                            
                                                <div className="nkp_profil_follower-container col-md-4">
                                                    <h4>{!RechargeData?null:RechargeData.length}</h4>
                                                    <p className='text-success d-flex pointer' onClick={detailCharging}><span>Recharge</span><span className='nkp-eyes-see-more'><FontAwesomeIcon icon={faEye} /></span></p>
                                                </div>
                                            
                                                <div className="nkp_profil_following-container col-md-4">
                                                    <h4>{!TransData?null:TransData.length}</h4>
                                                    <p className='text-danger d-flex pointer' onClick={detailSending}><span>Transfert</span><span className='nkp-eyes-see-more'><FontAwesomeIcon icon={faEye} /></span></p>
                                                </div>
                                            </div>
                                            
                                            <div className="nkp_profil_cta">
                                                <h1><strong className='color-b'>({(Wallets*1).toFixed(2)} XOF)</strong></h1>
                                            </div>
                                        </div>
                                    </div> :
                                    Options === "NEWCODE" ? 
                                    <div>
                                        <div id="closed"></div>
                                        <div className="nkp_pin_popup-wrapper" id="nkp_pin_popup2">
                                            <div className="nkp_pin_popup-container2 text-center">
                                                <center>
                                                    {
                                                        passwordInput !== "" && passwordConfirmInput !== "" && (passwordInput.length === passwordConfirmInput.length && passwordInput !== passwordConfirmInput) ? 
                                                        <div className={`ml-4 mr-1 alert alert-danger`} role="alert"> Mots de passe non conformes ! </div>: null
                                                    }
                                                    {
                                                        PassCodeConfirmed === "Code Pin correct ! Félicitation :)" ?
                                                        <div className={`ml-4 mr-1 alert alert-success`} role="alert"> {NewCodeConfirmed} </div>:
                                                        PassCodeConfirmed === "Code Pin incorrect !" ? 
                                                        <div className={`ml-4 mr-1 alert alert-danger`} role="alert"> {PassCodeConfirmed} </div>: null
                                                    }
                                                    {
                                                        PassCodeConfirmed === "Code Pin correct ! Félicitation :)" ? null :
                                                        <>
                                                            <OutlinedInput
                                                                value={passwordInput}
                                                                sx={{width:"100%", mt:"2px"}}
                                                                onChange={handlePasswordChange}
                                                                placeholder="Nouveau code pin"
                                                                id="outlined-adornment-password"
                                                                type={showPassword ? "text" : "password"}
                                                                endAdornment={
                                                                    <InputAdornment position="end">
                                                                    <IconButton
                                                                        aria-label="toggle password visibility"
                                                                        onClick={handleClickShowPassword}
                                                                        onMouseDown={handleMouseDownPassword}
                                                                        edge="end"
                                                                    >
                                                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                                                    </IconButton>
                                                                    </InputAdornment>
                                                                }
                                                                label="Password"
                                                                />
                                                            <OutlinedInput
                                                                value={passwordConfirmInput}
                                                                name="passwordconfirm"
                                                                sx={{width:"100%", mt:"2px"}}
                                                                onChange={handlePasswordConfirmChange}
                                                                placeholder="Repéter le nouveau code pin"
                                                                id="outlined-adornment-password"
                                                                type={showPassword ? "text" : "password"}
                                                                endAdornment={
                                                                    <InputAdornment position="end">
                                                                    <IconButton
                                                                        aria-label="toggle password visibility"
                                                                        onClick={handleClickShowPassword}
                                                                        onMouseDown={handleMouseDownPassword}
                                                                        edge="end"
                                                                    >
                                                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                                                    </IconButton>
                                                                    </InputAdornment>
                                                                }
                                                                label="Password"
                                                                />
                                                        </>
                                                    }

                                                </center>
                                                <a className="nkp_pin_popup-close" href="#/" onClick={ChoixOption1}>X</a>
                                                
                                                {
                                                    PassCodeConfirmed === "Code Pin correct ! Félicitation :)" ? null : 
                                                    <div className='mt-4'>
                                                        {
                                                            passwordInput !== "" && passwordConfirmInput !== ""&& (passwordInput === passwordConfirmInput) && MyCodePinID.length === 0 ?
                                                            <span className='nkp_popup_btn' onClick={NewCodeHandler}>Générer</span> :
                                                            passwordInput !== "" && passwordConfirmInput !== "" && MyCodePinID.length > 0 ?
                                                            <span className={`${Loader ? "" :"nkp_popup_btn"}`} onClick={codeUpdatingHandler}>
                                                            {
                                                                Loader ? 
                                                                <div className='d-flex justify-content-center'><div className="nkab-spinner"></div></div>: "Initialisez le code"
                                                            }
                                                            </span> :
                                                            passwordInput !== "" && passwordConfirmInput !== "" && PassCodeConfirmed === "Code Pin correct ! Félicitation :)" ?
                                                            <div className="d-flex justify-content-center"> <div className="nkab-spinner"></div> </div>: 
                                                            (passwordInput !== "" && passwordConfirmInput !== "") && (passwordInput === passwordConfirmInput) ?
                                                            <span className='nkp_popup_btn' onClick={NewCodeHandler}>Valider</span>:null
                                                        }
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div> : 
                                    Options === "ACHAT"?
                                    <div className="nkp_center">
                                    {
                                        b_opsd === "true" && t_opsd === "false" && r_opsd === "false" ? 
                                        <>
                                            <div className="nkp_container1">
                                                <form>
                                                    <div className=' pt-3 text-center'>
                                                        <div className='nkp__version-modal'>
                                                            <div className=' d-flex justify-content-between pr-4 pl-4'>
                                                                <div></div>
                                                                <div className='mr-4 color-or'>
                                                                    Lite <ReactSwitch className='react-switch-handle' checked={checked} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <h1 style={{fontSize:"30px"}}>
                                                            <strong className='color-grey'>E-</strong>
                                                            <strong className='color-or'>NKAB</strong>
                                                        </h1><br/>
                                                            <br/>
                                                            
                                                            {
                                                                BuySuccess ?<>
                                                                    <div className='d-flex justify-content-center'>
                                                                        <div className="svg-container">    
                                                                            <svg className="ft-green-tick" xmlns="http://www.w3.org/2000/svg" height="100" width="100" viewBox="0 0 48 48" aria-hidden="true">
                                                                                <circle className="circle" fill="#5bb543" cx="24" cy="24" r="22"/>
                                                                                <path className="tick" fill="none" stroke="#FFF" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M14 27l5.917 4.917L34 17"/>
                                                                            </svg>
                                                                        </div>
                                                                    </div>
                                                                    <div className='mt-3'><span className='text-success'>Achat effectué avec succès !</span></div>
                                                                </>:
                                                                BuyFailed ?<>
                                                                    <div className='d-flex justify-content-center'>
                                                                        <div className="svg-container">    
                                                                            <svg className="ft-red-tick" xmlns="http://www.w3.org/2000/svg" height="100" width="100" viewBox="0 0 48 48" aria-hidden="true">
                                                                                <SmsFailedIcon className="text-danger"/>
                                                                            </svg>
                                                                        </div>
                                                                    </div>
                                                                    <div className='mt-3'><span className='text-danger'>Achat échoué !</span></div>
                                                                </>:
                                                                <>
                                                                    <div className='d-flex justify-content-center'>
                                                                        <div><div className="nkab-spinner"></div></div>
                                                                    </div>
                                                                    <div className='mt-3'>
                                                                        <span className='text-success'>Achat en cours de traitement... Merci de patienter!</span>
                                                                    </div>
                                                                </>
                                                            }
                                                        <br/>
                                                    </div>
                                                    {isActive ?<div className='d-flex justify-content-center text-center mb-3'>
                                                        <p><button type="button" className="btn btn-outline-warning" onClick={handleCloser}>Revenir à la page</button></p>
                                                    </div>:null}
                                                    {
                                                        isRActive === "false" ? null :
                                                        <div className="nkp-alert-warning ml-3 mr-3 mt-4 mb-2 d-flex justify-content-between p-2">
                                                            <div className='mt-2'>
                                                                <strong>Délai de traitement entre 2mn à 9mn :</strong> 
                                                                <span> {Number(twoDigits(minutesRemaining))} {'mn'}{' '} </span>
                                                                <span>{' : '}</span>
                                                                <span> {Number(twoDigits(secondsToDisplay))} {'s'}{' '} </span>
                                                            </div>
                                                            <div>
                                                                <span style={{fontSize:"25px"}} className='ml-4 bolder pointer' onClick={handleCloser2}>&times;</span>
                                                            </div>
                                                        </div>
                                                    }
                                                </form>
                                            </div>
                                        </>
                                        :
                                        <div className="nkp_container1" onClick={CurrencyStatus ? ChoixCurrency1b : null}>
                                            <form>
                                                <div className=' pt-3 text-center'>
                                                    <div className='nkp__version-modal'>
                                                        <div className=' d-flex justify-content-between pr-4 pl-4'>
                                                            <div className='uppercase bolder'>Achat <span className='text-danger'>{PremiumLength > 0 && PremiumsData.premiumActive === "true" ? `Exp:${PremiumsData.premiumLastDate} à ${PremiumsData.premiumLastMinutes}`: ""}</span></div>
                                                            <div className='mr-4'>
                                                                Lite <ReactSwitch className='react-switch-handle' checked={checked} onChange={toogleHandleChange} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='nkp__version-modal2'>
                                                        <div className=' d-flex justify-content-between pr-4 pl-4'>
                                                            <div className='uppercase bolder'>Achat <span className='text-danger'>{PremiumLength > 0  && PremiumsData.premiumActive === "true"? `Premium exp le ${PremiumsData.premiumLastDate} à ${PremiumsData.premiumLastMinutes}`: ""}</span></div>
                                                            <div></div>
                                                        </div>
                                                    </div>
                                                    <br/>
                                                    <p><span className='nkp_status'>Solde disponible</span></p>
                                                    {
                                                        !SeePrice ?
                                                        <div onClick={seePriceHandler} className='d-flex justify-content-center mb-4'>
                                                            <div className='uppercase' style={{fontSize:"30px", color:"#c7b301"}}>********</div>
                                                            <div className='nkp_eye ml-2 pointer'><img style={{color:"#c7b301"}} width="23" height="23" src="https://img.icons8.com/ios/50/c7b301/visible--v1.png" alt="visible--v1"/></div>
                                                        </div>:
                                                        <div onClick={unSeePriceHandler} className='d-flex justify-content-center mb-4'>
                                                            <div className='uppercase bolder' style={{fontSize:"25px", color:"#c7b301"}}>{(Wallets*1).toFixed(2)} XOF</div>
                                                            <div className='nkp_eye ml-2 pt-2 pointer'><img style={{color:"#c7b301"}} width="23" height="23" src="https://img.icons8.com/ios/50/c7b301/closed-eye.png" alt="closed-eye"/></div>
                                                        </div>
                                                    }
                                                    {
                                                        (exchange.cfa) > Wallets ? 
                                                        <div className="nkp-alert-danger ml-3 mr-3 p-3 mb-2"> Solde insufisant ! </div> : null
                                                    }
                                                    {
                                                        BuyItemAlert !== "" ? 
                                                        <div className="nkp-alert-danger ml-3 mr-3 p-3"> {BuyItemAlert} </div> : null
                                                    }
                                                    {!moneyName?``:<h4> <span className='ml-2 nkp_price bolder'>TAUX D'ACHAT : {taux} XOF</span> </h4>}
                                                </div>
                                                {isActive ?<div className='d-flex justify-content-center text-center mb-3'>
                                                    <p><button type="button" className="btn btn-outline-warning" onClick={handleCloser}>Je comprends</button></p>
                                                </div>:null}

                                                <div className='d-flex pl-2 pr-2 pt-3'>
                                                    <div id="main-widget-crypto-selector" className="mb-1 nkp_items">
                                                        <div>
                                                            <span className="d-flex align-items-center btn-square btn btn-light btn-lg nkp_items_square" onClick={CurrencyStatus ? ChoixCurrency1b : ChoixCurrency1}>
                                                                <img src={!moneyImage?`${"../../images/question.png"}`:moneyImage} width="20" alt="nkab drapeau" className="dark-theme-icon-disable mr-2 icon-16" />
                                                                <span className="d-block text-left w-100 text-truncate font-weight-normal">{!moneyName?`${"Choisissez"}`:moneyName}</span>
                                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" className="text-gray-500 flex-shrink-0">
                                                                    <path fillRule="evenodd" d="M2.707 4.293L8 9.585l5.293-5.292a1 1 0 111.414 1.414l-6 6a.996.996 0 01-.53.277l-.118.014h-.118a.997.997 0 01-.648-.29l-6-6a1 1 0 011.414-1.415z" clipRule="evenodd"></path>
                                                                </svg>
                                                            </span>
                                                            {
                                                                CurrencyStatus?
                                                                <div className="position-relative nkp_items_list">
                                                                    <div className="ml-0 mt-2 w-100 text-left position-absolute nkp_position-absolute">
                                                                        <div className="_3rpmn">
                                                                            <div className="_65T61 css-2b097c-container">
                                                                                <div className="p4Aly mt-2 pb-2 css-0">
                                                                                    <div className="px-2 _5HQUI select-scroll-container css-0">
                                                                                        <div className="mt-1 css-0" id="react-select-2-option-0" tabIndex="-1">
                                                                                            <span className="d-flex justify-content-between border-0 font-weight-normal p-2 mb-0_5 btn-light btn-lg btn-block nkp_item-position" onClick={ChoixCurrency2a}>
                                                                                                <div className="d-flex flex-row">
                                                                                                    <img src="../../images/btc.png" width="20" alt="nkab drapeau" className="dark-theme-icon-disable mr-2 icon-24"/><span className='nkp_buy_title'>Bitcoin</span>
                                                                                                </div>
                                                                                                <span className="tag tag--md tag-transparent border-gray-400 nkp_buy_title">BTC</span>
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="mt-1 css-0" id="react-select-2-option-1" tabIndex="-1">
                                                                                            <span className="d-flex justify-content-between border-0 font-weight-normal p-2 mb-0_5 btn-light btn-lg btn-block nkp_item-position" onClick={ChoixCurrency2b}>
                                                                                                <div className="d-flex flex-row">
                                                                                                    <img src="../../images/usdt.png" width="20" alt="nkab drapeau" className="dark-theme-icon-disable mr-2 icon-24"/><span className='nkp_buy_title'>Tether</span>
                                                                                                </div>
                                                                                                <span className="tag tag--md tag-transparent border-gray-400 nkp_buy_title">USDT</span>
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="mt-1 css-0" id="react-select-2-option-2" tabIndex="-1">
                                                                                            <span className="d-flex justify-content-between border-0 font-weight-normal p-2 mb-0_5 btn-light btn-lg btn-block nkp_item-position" onClick={ChoixCurrency2c}>
                                                                                                <div className="d-flex flex-row">
                                                                                                    <img src="../../images/busd.png" width="20" alt="nkab drapeau" className="dark-theme-icon-disable mr-2 icon-24"/><span className='nkp_buy_title'>Binance</span>
                                                                                                </div>
                                                                                                <span className="tag tag--md tag-transparent border-gray-400 nkp_buy_title">BUSD</span>
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="mt-1 css-0" id="react-select-2-option-2" tabIndex="-1">
                                                                                            <span className="d-flex justify-content-between border-0 font-weight-normal p-2 mb-0_5 btn-light btn-lg btn-block nkp_item-position" onClick={ChoixCurrency2d}>
                                                                                                <div className="d-flex flex-row">
                                                                                                    <img src="../../images/pm.png" width="20" alt="nkab drapeau" className="dark-theme-icon-disable mr-2 icon-24"/><span className='nkp_buy_title'>Perfect</span>
                                                                                                </div>
                                                                                                <span className="tag tag--md tag-transparent border-gray-400 nkp_buy_title">PM</span>
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="mt-1 css-0" id="react-select-2-option-2" tabIndex="-1">
                                                                                            <span className="d-flex justify-content-between border-0 font-weight-normal p-2 mb-0_5 btn-light btn-lg btn-block nkp_item-position" onClick={ChoixCurrency2e}>
                                                                                                <div className="d-flex flex-row">
                                                                                                    <img src="../../images/ltc.png" width="20" alt="nkab drapeau" className="dark-theme-icon-disable mr-2 icon-24"/><span className='nkp_buy_title'>Litecoin</span>
                                                                                                </div>
                                                                                                <span className="tag tag--md tag-transparent border-gray-400 nkp_buy_title">LTC</span>
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="mt-1 css-0" id="react-select-2-option-2" tabIndex="-1">
                                                                                            <span className="d-flex justify-content-between border-0 font-weight-normal p-2 mb-0_5 btn-light btn-lg btn-block nkp_item-position" onClick={ChoixCurrency2f}>
                                                                                                <div className="d-flex flex-row">
                                                                                                    <img src="../../images/bnb.png" width="20" alt="nkab drapeau" className="dark-theme-icon-disable mr-2 icon-24"/><span className='nkp_buy_title'>Binance</span>
                                                                                                </div>
                                                                                                <span className="tag tag--md tag-transparent border-gray-400 nkp_buy_title">BNB</span>
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="mt-1 css-0" id="react-select-2-option-2" tabIndex="-1">
                                                                                            <span className="d-flex justify-content-between border-0 font-weight-normal p-2 mb-0_5 btn-light btn-lg btn-block nkp_item-position" onClick={ChoixCurrency2g}>
                                                                                                <div className="d-flex flex-row">
                                                                                                    <img src="../../images/cardano.png" width="20" alt="nkab drapeau" className="dark-theme-icon-disable mr-2 icon-24"/><span className='nkp_buy_title'>Cardano</span>
                                                                                                </div>
                                                                                                <span className="tag tag--md tag-transparent border-gray-400 nkp_buy_title">ADA</span>
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="mt-1 css-0" id="react-select-2-option-2" tabIndex="-1">
                                                                                            <span className="d-flex justify-content-between border-0 font-weight-normal p-2 mb-0_5 btn-light btn-lg btn-block nkp_item-position" onClick={ChoixCurrency2h}>
                                                                                                <div className="d-flex flex-row">
                                                                                                    <img src="../../images/pokadot.png" width="20" alt="nkab drapeau" className="dark-theme-icon-disable mr-2 icon-24"/><span className='nkp_buy_title'>Polkadot</span>
                                                                                                </div>
                                                                                                <span className="tag tag--md tag-transparent border-gray-400 nkp_buy_title">DOT</span>
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="mt-1 css-0" id="react-select-2-option-2" tabIndex="-1">
                                                                                            <span className="d-flex justify-content-between border-0 font-weight-normal p-2 mb-0_5 btn-light btn-lg btn-block nkp_item-position" onClick={ChoixCurrency2i}>
                                                                                                <div className="d-flex flex-row">
                                                                                                    <img src="../../images/polygonmatic.png" width="20" alt="nkab drapeau" className="dark-theme-icon-disable mr-2 icon-24"/><span className='nkp_buy_title'>Polygon</span>
                                                                                                </div>
                                                                                                <span className="tag tag--md tag-transparent border-gray-400 nkp_buy_title">MATIC</span>
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="mt-1 css-0" id="react-select-2-option-2" tabIndex="-1">
                                                                                            <span className="d-flex justify-content-between border-0 font-weight-normal p-2 mb-0_5 btn-light btn-lg btn-block nkp_item-position" onClick={ChoixCurrency2j}>
                                                                                                <div className="d-flex flex-row">
                                                                                                    <img src="../../images/shiba.png" width="20" alt="nkab drapeau" className="dark-theme-icon-disable mr-2 icon-24"/><span className='nkp_buy_title'>Shiba</span>
                                                                                                </div>
                                                                                                <span className="tag tag--md tag-transparent border-gray-400 nkp_buy_title">SHIB</span>
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="mt-1 css-0" id="react-select-2-option-2" tabIndex="-1">
                                                                                            <span className="d-flex justify-content-between border-0 font-weight-normal p-2 mb-0_5 btn-light btn-lg btn-block nkp_item-position" onClick={ChoixCurrency2k}>
                                                                                                <div className="d-flex flex-row">
                                                                                                    <img src="../../images/solana.png" width="20" alt="nkab drapeau" className="dark-theme-icon-disable mr-2 icon-24"/><span className='nkp_buy_title'>Solana</span>
                                                                                                </div>
                                                                                                <span className="tag tag--md tag-transparent border-gray-400 nkp_buy_title">SOL</span>
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="mt-1 css-0" id="react-select-2-option-2" tabIndex="-1">
                                                                                            <span className="d-flex justify-content-between border-0 font-weight-normal p-2 mb-0_5 btn-light btn-lg btn-block nkp_item-position" onClick={ChoixCurrency2l}>
                                                                                                <div className="d-flex flex-row">
                                                                                                    <img src="../../images/tron.png" width="20" alt="nkab drapeau" className="dark-theme-icon-disable mr-2 icon-24"/><span className='nkp_buy_title'>Tron</span>
                                                                                                </div>
                                                                                                <span className="tag tag--md tag-transparent border-gray-400 nkp_buy_title">TRON</span>
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="mt-1 css-0" id="react-select-2-option-2" tabIndex="-1">
                                                                                            <span className="d-flex justify-content-between border-0 font-weight-normal p-2 mb-0_5 btn-light btn-lg btn-block nkp_item-position" onClick={ChoixCurrency2m}>
                                                                                                <div className="d-flex flex-row">
                                                                                                    <img src="../../images/chainlink.png" width="20" alt="nkab drapeau" className="dark-theme-icon-disable mr-2 icon-24"/><span className='nkp_buy_title'>Chain</span>
                                                                                                </div>
                                                                                                <span className="tag tag--md tag-transparent border-gray-400 nkp_buy_title">LINK</span>
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="mt-1 css-0" id="react-select-2-option-2" tabIndex="-1">
                                                                                            <span className="d-flex justify-content-between border-0 font-weight-normal p-2 mb-0_5 btn-light btn-lg btn-block nkp_item-position" onClick={ChoixCurrency2n}>
                                                                                                <div className="d-flex flex-row">
                                                                                                    <img src="../../images/doge.png" width="20" alt="nkab drapeau" className="dark-theme-icon-disable mr-2 icon-24"/><span className='nkp_buy_title'>Dogecoin</span>
                                                                                                </div>
                                                                                                <span className="tag tag--md tag-transparent border-gray-400 nkp_buy_title">DOGE</span>
                                                                                            </span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>:null
                                                            }
                                                        </div>
                                                    </div>
                                                    
                                                    <div className={`nkp_price_input ml-1 mb-2 ${Number(exchange.cfa) > 1 && ((Number(exchange.cfa) < buyMin) || Wallets < 0) ? "controler_danger" : Number(exchange.cfa) > 50 && (Number(exchange.cfa) > buyMin) ? "controler_success" : null}`}>
                                                        <TextField 
                                                            sx={{width:"100%"}} 
                                                            className="bolder" 
                                                            id="outlined-basic" 
                                                            label={`${NKABCONVERTED > 0 ? (NKABCONVERTED*1).toFixed(5) : "Quantité"}`} 
                                                            variant="outlined" 
                                                            placeholder="Quantité"
                                                            onChange={handleCurrency} 
                                                        />
                                                    </div>

                                                </div>

                                                <div className='d-flex pl-2 pr-2'>
                                                    <div className='nkp_radio_input mr-2'>
                                                        {
                                                        moneyName === "Tether" || moneyName === "Shiba" || moneyName === "Chain link"? 
                                                        <div className='nkp_network_radio'>
                                                            <input type="radio" name="topping" value="Trc20" id="trc20" className='pointer' onClick={trc20CheckHandler} />
                                                            <label htmlFor="trc20" className='ml-2 pointer' onClick={trc20CheckHandler}>TRC20</label>

                                                            <input type="radio" name="topping" value="Bep20" id="bep20" className='ml-2 pointer' onClick={bep20CheckHandler}/>
                                                            <label htmlFor="bep20" className='ml-2 pointer' onClick={bep20CheckHandler}>BEP20</label>
                                                        </div>:
                                                        moneyName === "Binance USD"? 
                                                        <div className='nkp_network_radio'>
                                                            <input type="radio" name="topping" value="Bep20" id="bep20" className='ml-2 pointer' onClick={bep20CheckHandler}/>
                                                            <label htmlFor="bep20" className='ml-2 pointer' onClick={bep20CheckHandler}>BEP20</label>
                                                        </div>:
                                                        moneyName === "Polkadot"? 
                                                        <div className='nkp_network_radio'>
                                                            <input type="radio" name="topping" value="Polkadot" id="polkadot" className='pointer' onClick={polkadotCheckHandler} />
                                                            <label htmlFor="polkadot" className='ml-2 pointer' onClick={polkadotCheckHandler}>POLKADOT</label>

                                                            <input type="radio" name="topping" value="Bep20" id="bep20" className='ml-2 pointer' onClick={bep20CheckHandler}/>
                                                            <label htmlFor="bep20" className='ml-2 pointer' onClick={bep20CheckHandler}>BEP20</label>
                                                        </div>:
                                                        moneyName === "Polygon"? 
                                                        <div className='nkp_network_radio'>
                                                            <input type="radio" name="topping" value="Matic" id="matic" className='pointer' onClick={maticCheckHandler} />
                                                            <label htmlFor="matic" className='ml-2 pointer' onClick={maticCheckHandler}>MATIC</label>

                                                            <input type="radio" name="topping" value="Bep20" id="bep20" className='ml-2 pointer' onClick={bep20CheckHandler}/>
                                                            <label htmlFor="bep20" className='ml-2 pointer' onClick={bep20CheckHandler}>BEP20</label>
                                                        </div>:
                                                        moneyName === "Cardano"? 
                                                        <div className='nkp_network_radio'>
                                                            <input type="radio" name="topping" value="Cardano" id="cardano" className='pointer' onClick={cardanoCheckHandler} />
                                                            <label htmlFor="cardano" className='ml-2 pointer' onClick={cardanoCheckHandler}>CARDANO</label>

                                                            <input type="radio" name="topping" value="Bep20" id="bep20" className='ml-2 pointer' onClick={bep20CheckHandler}/>
                                                            <label htmlFor="bep20" className='ml-2 pointer' onClick={bep20CheckHandler}>BEP20</label>
                                                        </div>:
                                                        moneyName === "Solana"? 
                                                        <div className='nkp_network_radio'>
                                                            <input type="radio" name="topping" value="Solana" id="solana" className='pointer' onClick={solanaCheckHandler} />
                                                            <label htmlFor="solana" className='ml-2 pointer' onClick={solanaCheckHandler}>SOLANA</label>

                                                            <input type="radio" name="topping" value="Bep20" id="bep20" className='ml-2 pointer' onClick={bep20CheckHandler}/>
                                                            <label htmlFor="bep20" className='ml-2 pointer' onClick={bep20CheckHandler}>BEP20</label>
                                                        </div>:
                                                        <div>
                                                            <div className='nkp_adress_input mr-3'>
                                                                <TextField sx={{width:"100%", mr:"2px"}} id="outlined-basic" label="Adresse" variant="outlined" placeholder={`Entrez votre adresse ${!NetAddress?"...":NetAddress}`} onChange={handleAdress} />
                                                            </div>
                                                        </div>
                                                        }
                                                    </div>

                                                    <div className={`nkp_price_input ${Number(exchange.cfa) > 1 && ((Number(exchange.cfa) < buyMin) || Wallets < 0) ? "controler_danger" : Number(exchange.cfa) > 50 && (Number(exchange.cfa) > buyMin) ? "controler_success" : null}`}>
                                                        <TextField 
                                                            sx={{width:"100%"}} 
                                                            className="bolder" 
                                                            id="outlined-basic" 
                                                            name='montant2' 
                                                            label={`${NKABCFA > 0 ? (NKABCFA*1).toFixed(2) : "Montant"}`} 
                                                            variant="outlined" 
                                                            placeholder="Montant (XOF)"
                                                            onChange={handleMontant} 
                                                        />
                                                    </div>
                                                </div>
                                                {
                                                    AddressCkecked ?
                                                    <div className='mt-3'>
                                                        <div className='nkp_adress_input mr-3'>
                                                            <TextField sx={{width:"100%"}} id="outlined-basic" label="Entrez votre adresse" variant="outlined" placeholder={`Entrez votre adresse ${!NetAddress?"...":NetAddress}`} onChange={handleAdress} />
                                                        </div>
                                                    </div>:null
                                                }

                                                <div className='d-flex pr-3 pl-3 mt-2 color-black'>
                                                    <div style={{width:"50%"}}>
                                                        <span className={`${Number(exchange.cfa) > 1 && ((Number(exchange.cfa) < buyMin) || Wallets < 0) ? "text-danger" :     Number(exchange.cfa) > 50 && (Number(exchange.cfa) > buyMin) ? "text-success" : "nkp_price"}`}>
                                                        {moneyName === "Binance USD" ? <strong>{`${((exchange.converted)*1).toFixed(5)} BUSD`}</strong> : 
                                                        moneyName === "Bitcoin" ? <strong>{`${((exchange.converted)*1).toFixed(5)} BTC`}</strong> : moneyName === "Tether" ? <strong>{`${((exchange.converted)*1).toFixed(2)} USDT USDT`}</strong> : 
                                                        moneyName === "Perfect Money" ? <strong>{`${(exchange.converted).toFixed(2)} PM`}</strong> :
                                                        moneyName === "Dogecoin" ? <strong>{`${(exchange.converted).toFixed(2)} DOGE ≈ ${(dollar*1).toFixed(5)} $`}</strong> :
                                                        moneyName === "Litecoin" ? <strong>{`${((exchange.converted)*1).toFixed(5)} LTC`}</strong> : 
                                                        moneyName === "Binance" ? <strong>{`${((exchange.converted)*1).toFixed(5)} BNB`}</strong> :
                                                        moneyName === "Cardano" ? <strong>{`${((exchange.converted)*1).toFixed(2)} ADA`}</strong> :
                                                        moneyName === "Polkadot" ? <strong>{`${((exchange.converted)*1).toFixed(2)} DOT`}</strong> :
                                                        moneyName === "Polygon" ? <strong>{`${((exchange.converted)*1).toFixed(2)} MATIC`}</strong> :
                                                        moneyName === "Shiba" ? <strong>{`${((exchange.converted)*1).toFixed(2)} SHIB`}</strong> :
                                                        moneyName === "Solana" ? <strong>{`${((exchange.converted)*1).toFixed(2)} SOL`}</strong> :
                                                        moneyName === "Tron" ? <strong>{`${((exchange.converted)*1).toFixed(2)} TRON`}</strong> :
                                                        moneyName === "Chain link" ? <strong>{`${((exchange.converted)*1).toFixed(2)} LINK`}
                                                        </strong> :
                                                        "0 $" }</span>
                                                    </div>
                                                    <div style={{width:"50%"}}>
                                                        <span className='nkp_price'><strong>minimum : $400</strong></span>
                                                    </div>
                                                </div>
                                                    
                                                <div className='d-flex justify-content-center mb-3'>
                                                    {
                                                        BuyItemAlert === "" ? 
                                                        <>
                                                            {
                                                                (Number(exchange.cfa) < (buylimit*taux) || (exchange.cfa) > Wallets) ? 
                                                                <span style={{textDecoration:"none"}} className='nkp_popup_link-2'>Continuer</span>:
                                                                <a href="#nkp_pin_popup" style={{textDecoration:"none"}} className='nkp_input nkp_popup_link-1'>Continuer</a>
                                                            }
                                                        </> :
                                                        <span style={{textDecoration:"none"}} className='nkp_popup_link-2'>Continuer</span>
                                                    }
                                                </div>
                                            </form>
                                        </div>
                                        }
                                    </div>:
                                    Options === "RECHARGE" ?
                                    <div className="nkp_center">
                                    {
                                        r_opsd === "true" && b_opsd === "false" && t_opsd === "false" ? 
                                        <div className="nkp_container2">
                                            <form >
                                                <div className='mt-2'>
                                                    <div className='nkp__version-modal'>
                                                        <div className=' d-flex justify-content-between pr-4 pl-4'>
                                                            <div></div>
                                                            <div className='mr-4'>
                                                                Lite <ReactSwitch className='react-switch-handle' checked={checked} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <h1 style={{fontSize:"30px"}}>
                                                        <strong className='color-grey'>E-</strong>
                                                        <strong className='color-grey'>NKAB</strong>
                                                    </h1><br/>
                                                        <br/>
                                                            
                                                            {
                                                                PaymentSuccess ?<>
                                                                    <div className='d-flex justify-content-center'>
                                                                        <div className="svg-container">    
                                                                            <svg className="ft-green-tick" xmlns="http://www.w3.org/2000/svg" height="100" width="100" viewBox="0 0 48 48" aria-hidden="true">
                                                                                <circle className="circle" fill="#5bb543" cx="24" cy="24" r="22"/>
                                                                                <path className="tick" fill="none" stroke="#FFF" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M14 27l5.917 4.917L34 17"/>
                                                                            </svg>
                                                                        </div>
                                                                    </div>
                                                                    <div className='mt-3'><span className='text-success'>Rechargement effectué avec succès !</span></div>
                                                                </>:
                                                                PaymentFailed ?<>
                                                                    <div className='d-flex justify-content-center'>
                                                                        <div className="svg-container">    
                                                                            <svg className="ft-red-tick" xmlns="http://www.w3.org/2000/svg" height="100" width="100" viewBox="0 0 48 48" aria-hidden="true">
                                                                                <SmsFailedIcon className="text-danger"/>
                                                                            </svg>
                                                                        </div>
                                                                    </div>
                                                                    <div className='mt-3'><span className='text-danger'>Rechargement échoué !</span></div>
                                                                </>:
                                                                <>
                                                                    <div className='d-flex justify-content-center'>
                                                                        <div><div className="nkab-spinner"></div></div>
                                                                    </div>
                                                                    <br/>
                                                                    <div className='mt-3'><span className='text-success'>
                                                                        Rechargement en cours de traitement... <br/>Merci de patienter un moment pour suivre l'état final de l'opération! Ou revenir à la page d'accueil et vérifier après traitement l'état de celle-ci.<br/>
                                                                        <strong>NKAB Exchange vous remercie de votre fidélité!</strong></span></div>
                                                                </>
                                                            }
                                                        <br/>
                                                </div>
                                                {isActive ?<div className='d-flex justify-content-center text-center mb-3'>
                                                    <p><button type="button" className="btn btn-outline-warning" onClick={handleCloser}>Revenir à la page</button></p>
                                                </div>:null}
                                            </form>
                                        </div>
                                        :
                                        <div className={`${banqueName === "Wave" ? "nkp_container2_wave" : banqueName === "Virement bancaire" ? "nkp_container2_vb" :  banqueName === "Dépôt bancaire" ? "nkp_container2_db" : banqueName === "Cash" ? "nkp_container2_cash" :"nkp_container2"}`} onClick={BanqueStatus ? ChoixBanque1b : null}>
                                        <form>
                                            {
                                                !SeeDoc ? <>
                                                <div className='mt-2'>
                                                    <div className='nkp__version-modal'>
                                                        <div className=' d-flex justify-content-between pr-4 pl-4'>
                                                            <div className='uppercase bolder'>Rechargement</div>
                                                            <div className='mr-4'>
                                                                Lite <ReactSwitch className='react-switch-handle' checked={checked} onChange={toogleHandleChange} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='nkp__version-modal2'>
                                                        <div className=' d-flex justify-content-between pr-4 pl-4'>
                                                            <div className='uppercase bolder'>Rechargement</div>
                                                            <div></div>
                                                        </div>
                                                    </div>
                                                    <br/>
                                                    <p><span className='nkp_status'>Solde disponible</span></p>
                                                    {
                                                        !SeePrice ?
                                                        <div onClick={seePriceHandler} className='d-flex justify-content-center mb-4'>
                                                            <div className='uppercase' style={{fontSize:"30px", color:"#c7b301"}}>********</div>
                                                            <div className='nkp_eye ml-2 pointer'><img style={{color:"#c7b301"}} width="23" height="23" src="https://img.icons8.com/ios/50/c7b301/visible--v1.png" alt="visible--v1"/></div>
                                                        </div>:
                                                        <div onClick={unSeePriceHandler} className='d-flex justify-content-center mb-4'>
                                                            <div className='uppercase bolder' style={{fontSize:"25px", color:"#c7b301"}}>{(Wallets*1).toFixed(2)} XOF</div>
                                                            <div className='nkp_eye ml-2 pt-2 pointer'><img style={{color:"#c7b301"}} width="23" height="23" src="https://img.icons8.com/ios/50/c7b301/closed-eye.png" alt="closed-eye"/></div>
                                                        </div>
                                                    }
                                                    {
                                                        RechargeItemAlert !== "" ? 
                                                        <div className="nkp-alert-danger ml-3 mr-3 mb-2 p-3"> {RechargeItemAlert} </div> : null
                                                    }
                                                </div>
                                                {isActive ?<div className='d-flex justify-content-center text-center mb-3'>
                                                    <p><button type="button" className="btn btn-outline-warning" onClick={handleCloser}>Cliquez ici pour une nouvelle opération</button></p>
                                                </div>:null}

                                                {banqueName !== null ? <div className="nkp_caption uppercase">{`par ${banqueName}`}</div>:null}

                                                <div className='d-flex pl-2 pr-2'>
                                                    <div id="main-widget-crypto-selector" className="mb-1 nkp_items">
                                                        <div>
                                                            <span className="d-flex align-items-center btn-square btn btn-light btn-lg nkp_items_square" onClick={BanqueStatus ? ChoixBanque1b : ChoixBanque1}>
                                                                <img src={!banqueImage?`${"../../images/question.png"}`:banqueImage} width="20" alt="nkab drapeau" className="dark-theme-icon-disable mr-2 icon-16" />
                                                                <span className="d-block text-left w-100 text-truncate font-weight-normal">{!banqueName?`${"Choisissez"}`:banqueName}</span>
                                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" className="text-gray-500 flex-shrink-0">
                                                                    <path fillRule="evenodd" d="M2.707 4.293L8 9.585l5.293-5.292a1 1 0 111.414 1.414l-6 6a.996.996 0 01-.53.277l-.118.014h-.118a.997.997 0 01-.648-.29l-6-6a1 1 0 011.414-1.415z" clipRule="evenodd"></path>
                                                                </svg>
                                                            </span>
                                                            {
                                                                BanqueStatus?
                                                                <div className="position-relative nkp_items_list">
                                                                    <div className="ml-0 mt-2 w-100 text-left position-absolute nkp_position-absolute">
                                                                        <div className="_3rpmn">
                                                                            <div className="_65T61 css-2b097c-container">
                                                                                <div className="p4Aly mt-2 pb-2 css-0">
                                                                                    <div className="px-2 _5HQUI select-scroll-container css-0">
                                                                                        {
                                                                                            SenderCountry === ci || SenderCountry === sen ? 
                                                                                            <div className="mt-1 css-0" id="react-select-2-option-0" tabIndex="-1">
                                                                                                <span className="d-flex justify-content-between border-0 font-weight-normal p-2 mb-0_5 btn-light btn-lg btn-block nkp_item-position" onClick={ChoixBanque2a}>
                                                                                                    <div className="d-flex flex-row">
                                                                                                        <img src="../../images/wave.png" width="25" alt="nkab drapeau" className="dark-theme-icon-disable mr-2 icon-24"/>
                                                                                                    </div>
                                                                                                    <span className="tag tag--md tag-transparent border-gray-400 nkp_buy_title uppercase">Dépôt Wave</span>
                                                                                                </span>
                                                                                            </div> : null
                                                                                        }
                                                                                        <div className="mt-1 css-0" id="react-select-2-option-1" tabIndex="-1">
                                                                                            <span className="d-flex justify-content-between border-0 font-weight-normal p-2 mb-0_5 btn-light btn-lg btn-block nkp_item-position" onClick={ChoixBanque2b}>
                                                                                                <div className="d-flex flex-row">
                                                                                                    <img src="../../images/vbancaire.png" width="25" alt="nkab drapeau" className="dark-theme-icon-disable mr-2 icon-24"/>
                                                                                                </div>
                                                                                                <span className="tag tag--md tag-transparent border-gray-400 nkp_buy_title uppercase">Virement bancaire</span>
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="mt-1 css-0" id="react-select-2-option-2" tabIndex="-1">
                                                                                            <span className="d-flex justify-content-between border-0 font-weight-normal p-2 mb-0_5 btn-light btn-lg btn-block nkp_item-position" onClick={ChoixBanque2c}>
                                                                                                <div className="d-flex flex-row">
                                                                                                    <img src="../../images/dbancaire.png" width="25" alt="nkab drapeau" className="dark-theme-icon-disable mr-2 icon-24"/>
                                                                                                </div>
                                                                                                <span className="tag tag--md tag-transparent border-gray-400 nkp_buy_title uppercase">Dépôt bancaire</span>
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="mt-1 css-0" id="react-select-2-option-2" tabIndex="-1">
                                                                                            <span className="d-flex justify-content-between border-0 font-weight-normal p-2 mb-0_5 btn-light btn-lg btn-block nkp_item-position" onClick={ChoixBanque2d}>
                                                                                                <div className="d-flex flex-row">
                                                                                                    <img src="../../images/cash.png" width="25" alt="nkab drapeau" className="dark-theme-icon-disable mr-2 icon-24"/>
                                                                                                </div>
                                                                                                <span className="tag tag--md tag-transparent border-gray-400 nkp_buy_title uppercase">Cash</span>
                                                                                            </span>
                                                                                        </div>
                                                                                        { SenderCountry === burk || SenderCountry === sen || SenderCountry === mali || SenderCountry === guinee ? <>
                                                                                            <div className="mt-1 css-0" id="react-select-2-option-2" tabIndex="-1">
                                                                                                <span className="d-flex justify-content-between border-0 font-weight-normal p-2 mb-0_5 btn-light btn-lg btn-block nkp_item-position" onClick={ChoixBanque2e}>
                                                                                                    <div className="d-flex flex-row">
                                                                                                        <img src="../../images/om.png" width="25" alt="nkab drapeau" className="dark-theme-icon-disable mr-2 icon-24"/>
                                                                                                    </div>
                                                                                                    <span className="tag tag--md tag-transparent border-gray-400 nkp_buy_title uppercase">Orange</span>
                                                                                                </span>
                                                                                            </div>
                                                                                            </> : SenderCountry === benin ? <>
                                                                                            <div className="mt-1 css-0" id="react-select-2-option-2" tabIndex="-1">
                                                                                                <span className="d-flex justify-content-between border-0 font-weight-normal p-2 mb-0_5 btn-light btn-lg btn-block nkp_item-position" onClick={ChoixBanque2f}>
                                                                                                    <div className="d-flex flex-row">
                                                                                                        <img src="../../images/momo.png" width="25" alt="nkab drapeau" className="dark-theme-icon-disable mr-2 icon-24"/>
                                                                                                    </div>
                                                                                                    <span className="tag tag--md tag-transparent border-gray-400 nkp_buy_title uppercase">mtn</span>
                                                                                                </span>
                                                                                            </div>
                                                                                            </> : SenderCountry === cam ? <>
                                                                                            <div className="mt-1 css-0" id="react-select-2-option-2" tabIndex="-1">
                                                                                                <span className="d-flex justify-content-between border-0 font-weight-normal p-2 mb-0_5 btn-light btn-lg btn-block nkp_item-position" onClick={ChoixBanque2e}>
                                                                                                    <div className="d-flex flex-row">
                                                                                                        <img src="../../images/om.png" width="25" alt="nkab drapeau" className="dark-theme-icon-disable mr-2 icon-24"/>
                                                                                                    </div>
                                                                                                    <span className="tag tag--md tag-transparent border-gray-400 nkp_buy_title uppercase">Orange</span>
                                                                                                </span>
                                                                                            </div>
                                                                                            <div className="mt-1 css-0" id="react-select-2-option-2" tabIndex="-1">
                                                                                                <span className="d-flex justify-content-between border-0 font-weight-normal p-2 mb-0_5 btn-light btn-lg btn-block nkp_item-position" onClick={ChoixBanque2f}>
                                                                                                    <div className="d-flex flex-row">
                                                                                                        <img src="../../images/momo.png" width="25" alt="nkab drapeau" className="dark-theme-icon-disable mr-2 icon-24"/>
                                                                                                    </div>
                                                                                                    <span className="tag tag--md tag-transparent border-gray-400 nkp_buy_title uppercase">mtn</span>
                                                                                                </span>
                                                                                            </div>
                                                                                            </> : SenderCountry === togo ? <>
                                                                                            <div className="mt-1 css-0" id="react-select-2-option-2" tabIndex="-1">
                                                                                                <span className="d-flex justify-content-between border-0 font-weight-normal p-2 mb-0_5 btn-light btn-lg btn-block nkp_item-position" onClick={ChoixBanque2g}>
                                                                                                    <div className="d-flex flex-row">
                                                                                                        <img src="../../images/flooz.png" width="25" alt="nkab drapeau" className="dark-theme-icon-disable mr-2 icon-24"/>
                                                                                                    </div>
                                                                                                    <span className="tag tag--md tag-transparent border-gray-400 nkp_buy_title uppercase">Moov</span>
                                                                                                </span>
                                                                                            </div>
                                                                                            </> : SenderCountry === ci ? <>
                                                                                            <div className="mt-1 css-0" id="react-select-2-option-2" tabIndex="-1">
                                                                                                <span className="d-flex justify-content-between border-0 font-weight-normal p-2 mb-0_5 btn-light btn-lg btn-block nkp_item-position" onClick={ChoixBanque2e}>
                                                                                                    <div className="d-flex flex-row">
                                                                                                        <img src="../../images/om.png" width="25" alt="nkab drapeau" className="dark-theme-icon-disable mr-2 icon-24"/>
                                                                                                    </div>
                                                                                                    <span className="tag tag--md tag-transparent border-gray-400 nkp_buy_title uppercase">Orange</span>
                                                                                                </span>
                                                                                            </div>
                                                                                            <div className="mt-1 css-0" id="react-select-2-option-2" tabIndex="-1">
                                                                                                <span className="d-flex justify-content-between border-0 font-weight-normal p-2 mb-0_5 btn-light btn-lg btn-block nkp_item-position" onClick={ChoixBanque2f}>
                                                                                                    <div className="d-flex flex-row">
                                                                                                        <img src="../../images/momo.png" width="25" alt="nkab drapeau" className="dark-theme-icon-disable mr-2 icon-24"/>
                                                                                                    </div>
                                                                                                    <span className="tag tag--md tag-transparent border-gray-400 nkp_buy_title uppercase">mtn</span>
                                                                                                </span>
                                                                                            </div>
                                                                                            <div className="mt-1 css-0" id="react-select-2-option-2" tabIndex="-1">
                                                                                                <span className="d-flex justify-content-between border-0 font-weight-normal p-2 mb-0_5 btn-light btn-lg btn-block nkp_item-position" onClick={ChoixBanque2g}>
                                                                                                    <div className="d-flex flex-row">
                                                                                                        <img src="../../images/flooz.png" width="25" alt="nkab drapeau" className="dark-theme-icon-disable mr-2 icon-24"/>
                                                                                                    </div>
                                                                                                    <span className="tag tag--md tag-transparent border-gray-400 nkp_buy_title uppercase">Moov</span>
                                                                                                </span>
                                                                                            </div>
                                                                                        </>:null
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>:null
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className={`nkp_price_input d-flex justify-content-around ml-1 ${Montant > 5 && Montant < (charginglimit*taux) ? "controler_danger": Montant > 5 && Montant > (charginglimit*taux) ? "controler_success" : null}`}>
                                                        <TextField 
                                                            sx={{width:"100%", borderRadius: '16px'}} 
                                                            id="outlined-basic" 
                                                            name='montant2' 
                                                            label={`${NKABCFA > 0 ? (NKABCFA*1).toFixed(2) : "Montant"}`} 
                                                            variant="outlined" 
                                                            placeholder="Montant (XOF)" 
                                                            onChange={handleMontant} 
                                                        />
                                                    </div>

                                                </div>
                                                <div className='d-flex pr-3 pl-3 mt-1 color-black'>
                                                    <div style={{width:"50%"}}>
                                                        <span className={`${Montant > 5 && Montant < (charginglimit*taux) ? "text-danger": Montant > 5 && Montant > (charginglimit*taux) ? "text-success" : "nkp_price"}`}>
                                                            Payez exactement :
                                                            <strong>
                                                                {
                                                                    banqueName === "Orange" || banqueName === "mtn" || banqueName === "Moov" || banqueName === "Wave" ? Number(Montant)+(Number(Montant)*PayInRate) :
                                                                    banqueName === "Virement bancaire" || banqueName === "Dépôt bancaire" ?Number(Montant)+100:0
                                                                } XOF</strong></span>
                                                    </div>
                                                    <div style={{width:"50%"}}>
                                                        {/* <span className='nkp_price'><strong>min :</strong> {((limit*taux))} XOF ≈ 500.00 $</span> */}
                                                        <span className='nkp_price'><strong>minimum : {((charginglimit*taux))} XOF</strong> </span>
                                                    </div>
                                                </div>
                                                {
                                                    banqueName  === "Virement bancaire" || banqueName === "Dépôt bancaire" ?
                                                    <div className="alert alert-info nkp_alert-info mr-2 ml-2 mt-4" role="alert"> Veuillez sélectionner une banque! </div>:
                                                    banqueName === "Cash" ?
                                                    <div className="alert alert-info mr-2 ml-2 mt-4" role="alert"> <strong>Où nous sommes situés :</strong> <br/><FontAwesomeIcon icon={faMapMarkedAlt} /> Hotel Belle Côte, Rue Jacynthes, Cocody, Angré, Abidjan<br/><FontAwesomeIcon icon={faPhoneAlt} /> +225 27 22 40 79 27</div>:null
                                                }
                                                {
                                                    banqueName === "Cash" ? 
                                                    <div style={{width:"100%"}}>
                                                        <iframe src="https://www.google.com/maps/embed/v1/place?q=Rue+Jacynthes,+Cocody,+Abidjan,+Côte+d'Ivoire&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8" width="100%" height="300" title='nkab exchange map'>
                                                            <a href="https://www.maps.ie/distance-area-calculator.html">measure acres/hectares on map</a>
                                                        </iframe>
                                                    </div>:null
                                                }
                                                
                                                {
                                                    banqueName === "Dépôt bancaire" || banqueName === "Virement bancaire"?
                                                    <div className='d-flex justify-content-center uppercase mt-4'>
                                                        <span className={`m-2 pointer nkp_bank_option ${BankOptionClicked1 || banqueClickedName === "BNI" ? "nkp_bank_option_clicked" : null}`} onClick={bniClicked}><img src="../../images/bni.png" width="50" alt="nkab drapeau" /></span>
                                                        <span className={`m-2 pointer nkp_bank_option ${BankOptionClicked2 || banqueClickedName === "BICICI" ? "nkp_bank_option_clicked" : null}`} onClick={biciciClicked}><img src="../../images/bicici.png" width="50" alt="nkab drapeau" /></span>
                                                        <span className={`m-2 pointer nkp_bank_option ${BankOptionClicked3 || banqueClickedName === "ECOBANK" ? "nkp_bank_option_clicked" : null}`} onClick={ecobClicked}><img src="../../images/ecob.png" width="50" alt="nkab drapeau" /></span>
                                                        <span className={`m-2 pointer nkp_bank_option ${BankOptionClicked4 || banqueClickedName === "UBA" ? "nkp_bank_option_clicked" : null}`} onClick={ubaClicked}><img src="../../images/uba.png" width="50" alt="nkab drapeau" /></span>
                                                    </div>:null
                                                }
                                                {
                                                    banqueName === "Cash" ? 
                                                    <div >
                                                        <div className="alert alert-danger color-r" role="alert">Veuillez nous préciser une date de rendez-vous!</div>
                                                        <div className='d-flex mt-3'>
                                                            <input className='nkp_bq_input ml-2 mr-2' type="date" placeholder="Date du rendez-vous..." onChange={handleRDV}/>
                                                            <input className='nkp_bq_input ml-2 mr-2' type="time" min="09:00" max="18:00" placeholder="Heure de rendez-vous..." onChange={handleTime}/>
                                                        </div>
                                                        <div className='d-flex mt-3 pl-2 pr-2'>
                                                            <TextField sx={{width:"100%", ml:"2px"}} id="outlined-basic" label="Numéro créditeur" variant="outlined" placeholder={banqueName === "Wave"?"N° créditeur...":"Téléphone..."} onChange={handlePhone} />
                                                        </div>
                                                    </div>:
                                                    banqueName === "Moov" ? 
                                                    <div className='d-flex justify-content-between mt-3 pl-2 pr-2'>
                                                        <TextField sx={{width:"100%", mr:"2px"}} id="outlined-basic"  label="Numéro créditeur" variant="outlined" placeholder="Téléphone..." onChange={handlePhone} />
                                                        <OutlinedInput
                                                            sx={{width:"100%", ml:"2px"}}
                                                            onChange={handleCodeSecret}
                                                            placeholder="Code secret moov money..."
                                                            id="outlined-adornment-password"
                                                            type={showPassword ? "text" : "password"}
                                                            endAdornment={
                                                                <InputAdornment position="end">
                                                                <IconButton
                                                                    aria-label="toggle password visibility"
                                                                    onClick={handleClickShowPassword}
                                                                    onMouseDown={handleMouseDownPassword}
                                                                    edge="end"
                                                                >
                                                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                                                </IconButton>
                                                                </InputAdornment>
                                                            }
                                                            label="Password"
                                                            />
                                                    </div>:
                                                    banqueName  === "Orange" ? 
                                                    <div>
                                                        <div className='d-flex mt-3 pl-2 pr-2'>
                                                            <TextField id="outlined-basic" sx={{width:"100%", mr:"2px"}} label="Numéro créditeur" variant="outlined" placeholder="Téléphone..." onChange={handlePhone} />
                                                            <OutlinedInput
                                                                sx={{width:"100%", ml:"2px"}}
                                                                onChange={handleCodeSecret}
                                                                placeholder="Code OTP..."
                                                                id="outlined-adornment-password"
                                                                type={showPassword ? "text" : "password"}
                                                                endAdornment={
                                                                    <InputAdornment position="end">
                                                                    <IconButton
                                                                        aria-label="toggle password visibility"
                                                                        onClick={handleClickShowPassword}
                                                                        onMouseDown={handleMouseDownPassword}
                                                                        edge="end"
                                                                    >
                                                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                                                    </IconButton>
                                                                    </InputAdornment>
                                                                }
                                                                label="Password"
                                                                />
                                                        </div>
                                                    </div>:
                                                    banqueName  === "mtn" ? 
                                                    <div >
                                                        <div className='d-flex mt-3 pl-2 pr-2'>
                                                            <TextField id="outlined-basic" sx={{width:"100%", mr:"2px"}} label="Numéro créditeur" variant="outlined" placeholder="Téléphone..." onChange={handlePhone} />
                                                            <OutlinedInput
                                                                sx={{width:"100%", ml:"2px"}}
                                                                onChange={handleCodeSecret}
                                                                placeholder="Code secret mtn money..."
                                                                id="outlined-adornment-password"
                                                                type={showPassword ? "text" : "password"}
                                                                endAdornment={
                                                                    <InputAdornment position="end">
                                                                    <IconButton
                                                                        aria-label="toggle password visibility"
                                                                        onClick={handleClickShowPassword}
                                                                        onMouseDown={handleMouseDownPassword}
                                                                        edge="end"
                                                                    >
                                                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                                                    </IconButton>
                                                                    </InputAdornment>
                                                                }
                                                                label="Password"
                                                                />
                                                        </div>
                                                    </div>:
                                                    banqueName === "Virement bancaire"?
                                                    <div>
                                                        <div className='d-flex mt-3 pl-2 pr-2'>
                                                            <TextField id="outlined-basic" sx={{width:"100%", marginRight:"2px"}} label="N° Tél créditeur" variant="outlined" placeHolder={banqueName === "Wave"?"N° Créditeur...":"Téléphone..."} onChange={handlePhone} />
                                                            <TextField id="outlined-basic" sx={{width:"100%", marginLeft:"2px"}} label="Nom du compte créditeur" variant="outlined" placeHolder={banqueName === "Wave"?"N° Créditeur...":"Téléphone..."} onChange={handleAountName} />
                                                        </div>
                                                        <div className='d-flex mt-3 pl-2 pr-2'>
                                                            <TextField id="outlined-basic" sx={{width:"100%", marginRight:"2px"}} label="N° de compte créditeur" variant="outlined" placeHolder={banqueName === "Wave"?"N° Créditeur...":"Téléphone..."} onChange={handleAcountCredName} />
                                                            <TextField id="outlined-basic" sx={{width:"100%", marginLeft:"2px"}} label="Nom de la banque" variant="outlined" placeHolder={banqueName === "Wave"?"N° Créditeur...":"Téléphone..."} onChange={handleServiceBankName} />
                                                        </div>
                                                    </div>:
                                                    banqueName === "Dépôt bancaire"?
                                                    <div>
                                                        <div className='d-flex mt-3 pl-2 pr-2'>
                                                            <TextField id="outlined-basic" sx={{width:"100%", marginRight:"2px"}} label="N° Tél du déposant" variant="outlined" placeHolder={banqueName === "Wave"?"N° Créditeur...":"Téléphone..."} onChange={handlePhone} />
                                                            <TextField id="outlined-basic" sx={{width:"100%", marginLeft:"2px"}} label="Nom du déposant" variant="outlined" placeHolder={banqueName === "Wave"?"N° Créditeur...":"Téléphone..."} onChange={handleAountName} />
                                                        </div>
                                                    </div>:
                                                    <div className='d-flex mt-3 pl-2 pr-2'>
                                                        <TextField id="outlined-basic" sx={{width:"100%", marginRight:"2px"}} label="Numéro créditeur" variant="outlined" placeHolder={banqueName === "Wave"?"N° Créditeur...":"Téléphone..."} onChange={handlePhone} />
                                                    </div>
                                                    
                                                    
                                                }
                                                {
                                                    banqueName  === "Wave" ? <div>
                                                        <div>
                                                            <div className={`ml-4 mr-4 mt-4 alert alert-danger`} role="alert">Téléphone obligatoire !</div>
                                                        </div>
                                                    {
                                                        Montant > (charginglimit*taux) ? 
                                                        <div className='mr-4 ml-1 mt-4'>
                                                            <div className={`ml-4 mr-1 alert alert-info`} role="alert">Vous serez redirigé sur votre application <strong>WAVE Money</strong> pour finaliser le paiement de <strong>{!Montant?"...?":<>{banqueName === "Wave" ? Number(Montant)+(Number(Montant)*PayInRate):banqueName === "Orange" || banqueName === "mtn" || banqueName === "Moov" ? Number(Montant)+(Number(Montant)*PayOutRate) :banqueName === "Virement bancaire" || banqueName === "Dépôt bancaire" ?Number(Montant)+100:Number(Montant)}</>} XOF</strong> après avoir cliqué sur "<strong>Continuer</strong>"!</div>
                                                        </div>:null
                                                    }</div>:
                                                    banqueName  === "Moov" ? <div>
                                                    {
                                                        Montant > (charginglimit*taux) ? 
                                                        <div className='mr-4 ml-1 mt-4'>
                                                            <div className={`ml-4 mr-1 alert alert-info`} role="alert">Vous allez recevoir <strong>une notification</strong> de débit sur votre téléphone pour confirmer votre paiement après avoir cliqué sur "<strong>Continuer</strong>"!</div>
                                                        </div>:null
                                                    }</div>:
                                                    banqueName  === "Orange" ? <div>
                                                    {
                                                        Montant > (charginglimit*taux) ? 
                                                        <div className='mr-4 ml-1 mt-4'>
                                                            {
                                                                SenderCountry === ci ? <div className={`ml-4 mr-1 alert alert-info`} role="alert">Composer le <strong>#144*82#</strong> puis votre <strong>code secret</strong> et entrer le <strong>code OTP</strong> ci-dessus ensuite cliquer sur "<strong>Continuer</strong>"!</div>: 
                                                                SenderCountry === sen ?
                                                                <div className={`ml-4 mr-1 alert alert-info`} role="alert">Vous allez recevoir une notification pour générer un code à sens unique via le <strong>#144*391#</strong> </div>:
                                                                SenderCountry === burk ?
                                                                <div className={`ml-4 mr-1 alert alert-info`} role="alert">Composer le <strong>*144*4*6*100#</strong> puis votre <strong>code secret</strong> et entrer le <strong>code OTP</strong> ci-dessus ensuite cliquer sur "<strong>Continuer</strong>"!</div>:
                                                                SenderCountry === mali ?
                                                                <div className={`ml-4 mr-1 alert alert-info`} role="alert">Composer le <strong>#144*77#</strong> puis votre <strong>code secret</strong> et entrer le <strong>code OTP</strong> ci-dessus ensuite cliquer sur "<strong>Continuer</strong>"!</div>:
                                                                SenderCountry === guinee ?
                                                                <div className={`ml-4 mr-1 alert alert-info`} role="alert">Composer le <strong>#144#</strong> l'option 4 puis l'option 2 votre <strong>code secret</strong> et entrer le <strong>code OTP</strong> ci-dessus ensuite cliquer sur "<strong>Continuer</strong>"!</div>:
                                                                SenderCountry === cam ?
                                                                <div className={`ml-4 mr-1 alert alert-info`} role="alert">Vous allez recevoir un message puis composer le <strong>#150*50#</strong> puis votre <strong>code secret</strong> et entrer le <strong>code OTP</strong> ci-dessus ensuite cliquer sur "<strong>Continuer</strong>"!</div>:null
                                                            }
                                                            
                                                        </div>:null
                                                    }</div>:
                                                    banqueName  === "mtn" ? <div>
                                                    {
                                                        Montant > (charginglimit*taux) ? 
                                                        <>
                                                        {
                                                            SenderCountry === ci ? 
                                                            <div className='mr-4 ml-1 mt-4'>
                                                                <div className={`ml-4 mr-1 alert alert-info`} role="alert">Composez <strong>*133#</strong> apres reception du SMS de debit sur votre téléphone ensuite cliquer sur "<strong>Continuer</strong>" pour terminer!</div>
                                                            </div>:
                                                            SenderCountry === benin ? 
                                                            <div className='mr-4 ml-1 mt-4'>
                                                                <div className={`ml-4 mr-1 alert alert-info`} role="alert">Entrez votre <strong>code secret MTN</strong> via le SMS reçu sur votre téléphone ensuite cliquer sur "<strong>Continuer</strong>" pour terminer!</div>
                                                            </div>:
                                                            SenderCountry === cam ? 
                                                            <div className='mr-4 ml-1 mt-4'>
                                                                <div className={`ml-4 mr-1 alert alert-info`} role="alert">Entrez votre <strong>code secret MTN</strong> via le SMS reçu sur votre téléphone ensuite cliquer sur "<strong>Continuer</strong>" pour terminer!</div>
                                                            </div>:
                                                            SenderCountry === guinee ? 
                                                            <div className='mr-4 ml-1 mt-4'>
                                                                <div className={`ml-4 mr-1 alert alert-info`} role="alert">Entrez votre <strong>code secret MTN</strong> via le SMS reçu sur votre téléphone ensuite cliquer sur "<strong>Continuer</strong>" pour terminer!</div>
                                                            </div>:null
                                                        }
                                                        </>:null
                                                    }</div>:
                                                    banqueName  === "Moov" ? <div>
                                                    {
                                                        Montant > (charginglimit*taux) ? 
                                                        <>
                                                        {
                                                            SenderCountry === ci ?  
                                                            <div className='mr-4 ml-1 mt-4'>
                                                                <div className={`ml-4 mr-1 alert alert-info`} role="alert">Entrez votre <strong>code secret Moov Money</strong> via le SMS reçu sur votre téléphone ensuite cliquer sur "<strong>Continuer</strong>" pour terminer!</div>
                                                            </div>:
                                                            SenderCountry === mali ? 
                                                            <div className='mr-4 ml-1 mt-4'>
                                                                <div className={`ml-4 mr-1 alert alert-info`} role="alert">Entrez votre <strong>code secret Moov Money</strong> via le SMS reçu sur votre téléphone ensuite cliquer sur "<strong>Continuer</strong>" pour terminer!</div>
                                                            </div>:
                                                            SenderCountry === togo ? 
                                                            <div className='mr-4 ml-1 mt-4'>
                                                                <div className={`ml-4 mr-1 alert alert-info`} role="alert">Entrez votre <strong>code secret Flooz</strong> via le SMS reçu sur votre téléphone ensuite cliquer sur "<strong>Continuer</strong>" pour terminer!</div>
                                                            </div>:
                                                            SenderCountry === benin ? 
                                                            <div className='mr-4 ml-1 mt-4'>
                                                                <div className={`ml-4 mr-1 alert alert-info`} role="alert">Composez le <strong>*855*7*8#</strong>puis entrez votre <strong>code secret Moov</strong> via le SMS reçu sur votre téléphone ensuite cliquer sur "<strong>Continuer</strong>" pour terminer!</div>
                                                            </div>:
                                                            SenderCountry === burk ? 
                                                            <div className='mr-4 ml-1 mt-4'>
                                                                <div className={`ml-4 mr-1 alert alert-info`} role="alert">Composez le <strong>*555*6#</strong>puis entrez votre <strong>code secret Moov</strong> via le SMS reçu sur votre téléphone ensuite cliquer sur "<strong>Continuer</strong>" pour terminer!</div>
                                                            </div>:null
                                                        }
                                                        </>:null
                                                    }</div>:null
                                                }
                                                    
                                                <div className='d-flex justify-content-center mb-3'>
                                                    {
                                                        PhoneAlert !== "ok" ? <span style={{textDecoration:"none"}} className='nkp_popup_link-2'>Continuer</span> :
                                                        <>
                                                        {
                                                            banqueName  === "Virement bancaire" || banqueName === "Dépôt bancaire" ? <>
                                                                {
                                                                    Montant < (charginglimit*taux) ? 
                                                                    <span style={{textDecoration:"none"}} className='nkp_popup_link-2'>Continuer</span>:
                                                                    <span style={{textDecoration:"none"}} className='nkp_input nkp_popup_link-1 pointer' onClick={seeDocHandler}>Continuer</span>
                                                                }
                                                            </>:
                                                            banqueName  === "Wave" || banqueName === "Cash" ? <>
                                                                {
                                                                    Montant < (charginglimit*taux)  && !Loader ? 
                                                                    <span style={{textDecoration:"none"}} className='nkp_popup_link-2'>Continuer</span>:
                                                                    (Montant > (charginglimit*taux)) && Loader ?
                                                                    <a href="#/" style={{textDecoration:"none"}} className='nkp_input nkp_loader pt-3'>
                                                                        <div className="bouncing-loader">
                                                                            <div></div>
                                                                            <div></div>
                                                                            <div></div>
                                                                        </div>
                                                                    </a> :
                                                                    (Montant > (charginglimit*taux)) && !Loader?
                                                                    <a href="#/" style={{textDecoration:"none"}} className='nkp_input nkp_popup_link-1' onClick={RechargeHandler}>Continuer</a>:null
                                                                }
                                                            </>:
                                                            banqueName  === "Orange" || banqueName === "mtn" || banqueName === "Moov" ? <>
                                                                {
                                                                    Montant < (charginglimit*taux)  && !Loader ? 
                                                                    <span style={{textDecoration:"none"}} className='nkp_popup_link-2'>Continuer</span>:
                                                                    (Montant > (charginglimit*taux)) && Loader ?
                                                                    <a href="#/" style={{textDecoration:"none"}} className='nkp_input nkp_loader pt-3'>
                                                                        <div className="bouncing-loader">
                                                                            <div></div>
                                                                            <div></div>
                                                                            <div></div>
                                                                        </div>
                                                                    </a> :
                                                                    (Montant > (charginglimit*taux)) && !Loader?
                                                                    <a href="#/" style={{textDecoration:"none"}} className='nkp_input nkp_popup_link-1' onClick={RechargePaymentHandler}>Continuer</a>:null
                                                                }
                                                            </>:
                                                            <span style={{textDecoration:"none"}} className='nkp_popup_link-2'>Continuer</span>
                                                        }
                                                        </>
                                                    }
                                                </div>
                                                </> : 
                                                <div>
                                                    {
                                                        banqueClickedName === "ECOBANK" ? <>
                                                            <div className='p-2 text-center'>
                                                                <h3 className='nkp_price'>Relevé d'Identité Bancaire (RIB)</h3>
                                                            </div>
                                                            <div>
                                                                <table className="table table-bordered nkp_price">
                                                                    <thead>
                                                                        <tr>
                                                                            <th scope="col">Code Banque</th>
                                                                            <th scope="col">Code Guichet</th>
                                                                            <th scope="col">Numéro Compte</th>
                                                                            <th scope="col">Clé Rib</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td>CI059</td>
                                                                            <td>01044</td>
                                                                            <td>121540971001</td>
                                                                            <td>05</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th scope="col">Nom & Prénoms</th>
                                                                            <td colSpan="3">NK GROUP TECHNOLOGY</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th scope="col">IBAN</th>
                                                                            <td colSpan="3">CI93 CI05 9010 4412 1540 9710 0105</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th scope="col" colSpan="4">DOMICILIATION</th>
                                                                        </tr>
                                                                        <tr>
                                                                            <th rowSpan="4"><img src="../../images/ekob_large.png" width="200" alt="nkab drapeau" /></th>
                                                                            <td colSpan="3"><strong>ECOBANK CÔTE D'IVOIRE</strong></td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td colSpan="3">01 BP 4107 Abidjan 01</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td colSpan="3">Tél : 20 31 92 00</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td colSpan="3">Code Swift : ECOCCIAB</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>

                                                            {
                                                                Montant > (charginglimit*taux) ? 
                                                                <div className='mr-4 ml-1 mt-4'>
                                                                    <div className={`ml-4 mr-1 alert alert-info`} role="alert">Rassurez-vous d'avoir effectuer le <strong>{banqueName}</strong> de <strong>{!Montant?"...?":Montant} XOF</strong> en vous servant de ces informations ci-dessus avant de cliquer sur "<strong>Valider</strong>" pour terminer!</div>
                                                                </div>:null
                                                            }

                                                            <div className='d-flex justify-content-center mb-3'>
                                                                {
                                                                    Loader ? 
                                                                    <a href="#/" style={{textDecoration:"none"}} className='nkp_input nkp_loader'>
                                                                        <div className="bouncing-loader">
                                                                            <div></div>
                                                                            <div></div>
                                                                            <div></div>
                                                                        </div>
                                                                    </a>:
                                                                    <a href="#/" style={{textDecoration:"none"}} className='nkp_input nkp_popup_link-1' onClick={RechargeHandler}>Valider</a>
                                                                }
                                                            </div>
                                                        </>:
                                                        banqueClickedName === "UBA" ? <>
                                                            <div className='p-2 text-center'>
                                                                <h3 className='nkp_price'>Relevé d'Identité Bancaire (RIB)</h3>
                                                            </div>
                                                            <div>
                                                                <table className="table table-bordered nkp_price">
                                                                    <thead>
                                                                        <tr>
                                                                            <th scope="col">Code Banque</th>
                                                                            <th scope="col">Code Guichet</th>
                                                                            <th scope="col">Numéro Compte</th>
                                                                            <th scope="col">Clé Rib</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td>CI150</td>
                                                                            <td>01008</td>
                                                                            <td>108580002659</td>
                                                                            <td>74</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th scope="col">Nom & Prénoms</th>
                                                                            <td colSpan="3">NK GROUP TECHNOLOGY</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th scope="col">IBAN</th>
                                                                            <td colSpan="3">CI93 CI15 0010 0810 8580 0026 5974</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th scope="col" colSpan="4">DOMICILIATION</th>
                                                                        </tr>
                                                                        <tr>
                                                                            <th rowSpan="4"><img src="../../images/uba_large.png" width="200" alt="nkab drapeau" /></th>
                                                                            <td colSpan="3"><strong>UBA CÔTE D'IVOIRE</strong></td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td colSpan="3">17 BP 808 Abidjan 17</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td colSpan="3">Tél : 22 50 77 14</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td colSpan="3">Code Swift : UNAFCIAB</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>

                                                            {
                                                                Montant > (charginglimit*taux) ? 
                                                                <div className='mr-4 ml-1 mt-4'>
                                                                    <div className={`ml-4 mr-1 alert alert-info`} role="alert">Rassurez-vous d'avoir effectuer le <strong>{banqueName}</strong> de <strong>{!Montant?"...?":Montant} XOF</strong> en vous servant de ces informations ci-dessus avant de cliquer sur "<strong>Valider</strong>" pour terminer!</div>
                                                                </div>:null
                                                            }
                                                            
                                                            <div className='d-flex justify-content-center mb-3'>
                                                                {
                                                                    Loader?
                                                                    <a href="#/" style={{textDecoration:"none"}} className='nkp_input nkp_loader'>
                                                                        <div className="bouncing-loader">
                                                                            <div></div>
                                                                            <div></div>
                                                                            <div></div>
                                                                        </div>
                                                                    </a>:
                                                                    <a href="#/" style={{textDecoration:"none"}} className='nkp_input nkp_popup_link-1' onClick={RechargeHandler}>Valider</a>
                                                                }
                                                            </div>
                                                        </>:
                                                        banqueClickedName === "BNI" ? <>
                                                        <div className='p-2 text-center'>
                                                            <h3 className='nkp_price'>Relevé d'Identité Bancaire (RIB)</h3>
                                                        </div>
                                                        <div>
                                                            <table className="table table-bordered nkp_price">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col">Code Banque</th>
                                                                        <th scope="col">Code Guichet</th>
                                                                        <th scope="col">Numéro Compte</th>
                                                                        <th scope="col">Clé Rib</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr>
                                                                        <td>CI092</td>
                                                                        <td>01018</td>
                                                                        <td>009498720006</td>
                                                                        <td>05</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th scope="col">Nom & Prénoms</th>
                                                                        <td colSpan="3">NK GROUP TECHNOLOGY</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th scope="col">IBAN</th>
                                                                        <td colSpan="3">CI93 CI09 2010 1800 9498 7200 0605</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th scope="col" colSpan="4">DOMICILIATION</th>
                                                                    </tr>
                                                                    <tr>
                                                                        <th rowSpan="4"><img src="../../images/bni_large.png" width="200" alt="nkab drapeau" /></th>
                                                                        <td colSpan="3"><strong>BNI CÔTE D'IVOIRE</strong></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td colSpan="3">? BP ? Abidjan ?</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td colSpan="3">Tél : XX XX XX XX</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td colSpan="3">Code Swift : CSSSCIAB</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>

                                                        {
                                                            Montant > (charginglimit*taux) ? 
                                                            <div className='mr-4 ml-1 mt-4'>
                                                                <div className={`ml-4 mr-1 alert alert-info`} role="alert">Rassurez-vous d'avoir effectuer le <strong>{banqueName}</strong> de <strong>{!Montant?"...?":Montant} XOF</strong> en vous servant de ces informations ci-dessus avant de cliquer sur "<strong>Valider</strong>" pour terminer!</div>
                                                            </div>:null
                                                        }

                                                        <div className='d-flex justify-content-center mb-3'>
                                                            {
                                                                Loader?
                                                                <a href="#/" style={{textDecoration:"none"}} className='nkp_input nkp_loader'>
                                                                    <div className="bouncing-loader">
                                                                        <div></div>
                                                                        <div></div>
                                                                        <div></div>
                                                                    </div>
                                                                </a>:
                                                                <a href="#/" style={{textDecoration:"none"}} className='nkp_input nkp_popup_link-1' onClick={RechargeHandler}>Valider</a>
                                                            }
                                                            {/* {
                                                                image ?
                                                                <>
                                                                    {
                                                                        Loader ? 
                                                                        <a href="#/" style={{textDecoration:"none"}} className='nkp_input nkp_loader'>
                                                                            <div className="bouncing-loader">
                                                                                <div></div>
                                                                                <div></div>
                                                                                <div></div>
                                                                            </div>
                                                                        </a>:
                                                                        <div>
                                                                            <div>
                                                                                {image && ( <div> <img src={image} alt="Uploaded" width="200" /> </div> )}
                                                                            </div>
                                                                            <div>
                                                                                <Grid container>
                                                                                    <Grid item xs sx={{ mr: 1}}>
                                                                                        <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2, bgcolor: '#010a13', fontWeight:'bolder'}} onClick={RechargeHandler}>Valider</Button>
                                                                                    </Grid>
                                                                                </Grid>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                </>:
                                                                <div> <input type="file" accept="image/*" onChange={handleImageUpload} /> </div>
                                                            } */}
                                                        </div>
                                                        </>:
                                                        banqueClickedName === "BICICI" ? <>
                                                            <div className='p-2 text-center'>
                                                                <h3 className='nkp_price'>Relevé d'Identité Bancaire (RIB)</h3>
                                                            </div>
                                                            <div>
                                                                <table className="table table-bordered nkp_price">
                                                                    <thead>
                                                                        <tr>
                                                                            <th scope="col">Code Banque</th>
                                                                            <th scope="col">Code Guichet</th>
                                                                            <th scope="col">Numéro Compte</th>
                                                                            <th scope="col">Clé Rib</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td>CI006</td>
                                                                            <td>01693</td>
                                                                            <td>010663800053</td>
                                                                            <td>77</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th scope="col">Nom & Prénoms</th>
                                                                            <td colSpan="3">KOUASSI N'GUESSAN NOEL</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th scope="col">IBAN</th>
                                                                            <td colSpan="3">CI93 CI00 6016 9301 0663 8000 5377</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th scope="col" colSpan="4">DOMICILIATION</th>
                                                                        </tr>
                                                                        <tr>
                                                                            <th rowSpan="4"><img src="../../images/bicici_large.png" width="200" alt="nkab drapeau" /></th>
                                                                            <td colSpan="3"><strong>BICICI CÔTE D'IVOIRE</strong></td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td colSpan="3">? BP ? Abidjan ?</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td colSpan="3">Tél : XX XX XX XX</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td colSpan="3">Code Swift : BICICIAB</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>

                                                            {
                                                                Montant > (charginglimit*taux) ? 
                                                                <div className='mr-4 ml-1 mt-4'>
                                                                    <div className={`ml-4 mr-1 alert alert-info`} role="alert">Rassurez-vous d'avoir effectuer le <strong>{banqueName}</strong> de <strong>{!Montant?"...?":Montant} XOF</strong> en vous servant de ces informations ci-dessus avant de cliquer sur "<strong>Valider</strong>" pour terminer!</div>
                                                                </div>:null
                                                            }

                                                            <div className='d-flex justify-content-center mb-3'>
                                                                {
                                                                    Loader?
                                                                    <a href="#/" style={{textDecoration:"none"}} className='nkp_input nkp_loader'>
                                                                        <div className="bouncing-loader">
                                                                            <div></div>
                                                                            <div></div>
                                                                            <div></div>
                                                                        </div>
                                                                    </a>:
                                                                    <a href="#/" style={{textDecoration:"none"}} className='nkp_input nkp_popup_link-1' onClick={RechargeHandler}>Valider</a>
                                                                }
                                                            </div>
                                                        </>:null
                                                    }
                                                </div>
                                            }

                                        </form>
                                    </div>
                                    }
                                    </div>:
                                    Options === "TRANSFERT" ?
                                    <div className="nkp_center">
                                    {
                                        t_opsd === "true" && r_opsd === "false" && b_opsd === "false" ? 
                                        <>
                                            <div className="nkp_container3">
                                                <form>
                                                    <div className='mt-2'>
                                                        <div className='nkp__version-modal'>
                                                            <div className='d-flex justify-content-between pr-4 pl-4'>
                                                                <div></div>
                                                                <div className='mr-4'>
                                                                    Lite <ReactSwitch className='react-switch-handle' checked={checked}/>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <h1 style={{fontSize:"30px"}}>
                                                            <strong className='color-grey'>E-</strong>
                                                            <strong className='color-grey'>NKAB</strong>
                                                        </h1><br/>
                                                            <br/>
                                                            
                                                                {
                                                                    TransSuccess ?<>
                                                                        <div className='d-flex justify-content-center'>
                                                                            <div className="svg-container">    
                                                                                <svg className="ft-green-tick" xmlns="http://www.w3.org/2000/svg" height="100" width="100" viewBox="0 0 48 48" aria-hidden="true">
                                                                                    <circle className="circle" fill="#5bb543" cx="24" cy="24" r="22"/>
                                                                                    <path className="tick" fill="none" stroke="#FFF" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M14 27l5.917 4.917L34 17"/>
                                                                                </svg>
                                                                            </div>
                                                                        </div>
                                                                        <div className='mt-3'><span className='text-success'>Transaction effectuée avec succès !</span></div>
                                                                    </>:
                                                                    TransFailed ?<>
                                                                        <div className='d-flex justify-content-center'>
                                                                            <div className="svg-container">    
                                                                                <svg className="ft-red-tick" xmlns="http://www.w3.org/2000/svg" height="100" width="100" viewBox="0 0 48 48" aria-hidden="true">
                                                                                    <SmsFailedIcon className="text-danger"/>
                                                                                </svg>
                                                                            </div>
                                                                        </div>
                                                                        <div className='mt-3'><span className='text-danger'>Transaction échouée !</span></div>
                                                                    </>:
                                                                    <div className='d-flex justify-content-center'>
                                                                        <div><div className="nkab-spinner"></div></div>
                                                                    </div>
                                                                }
                                                            <br/>
                                                    </div>
                                                    {isActive ?<div className='d-flex justify-content-center text-center mb-3'>
                                                        <p><button type="button" className="btn btn-outline-warning" onClick={handleCloser}>Revenir à la page</button></p>
                                                    </div>:null}
                                                </form>
                                            </div>
                                        </>
                                        :
                                        <div className="nkp_container3" onClick={ChangeStatus ? ChoixChange1b : null}>
                                            <form>
                                                <div className='mt-2'>
                                                    <div className='nkp__version-modal'>
                                                        <div className=' d-flex justify-content-between pr-4 pl-4'>
                                                            <div className='uppercase bolder'>Transfert</div>
                                                            <div className='mr-4'>
                                                                Lite <ReactSwitch className='react-switch-handle' checked={checked} onChange={toogleHandleChange} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='nkp__version-modal2'>
                                                        <div className=' d-flex justify-content-between pr-4 pl-4'>
                                                            <div className='uppercase bolder'>Transfert</div>
                                                            <div></div>
                                                        </div>
                                                    </div>
                                                    <br/>
                                                    <p><span className='nkp_status'>Solde disponible</span></p>
                                                    {
                                                        !SeePrice ?
                                                        <div onClick={seePriceHandler} className='d-flex justify-content-center'>
                                                            <div className='uppercase' style={{fontSize:"30px", color:"#c7b301"}}>********</div>
                                                            <div className='nkp_eye ml-2 pointer'><img style={{color:"#c7b301"}} width="23" height="23" src="https://img.icons8.com/ios/50/c7b301/visible--v1.png" alt="visible--v1"/></div>
                                                        </div>:
                                                        <div onClick={unSeePriceHandler} className='d-flex justify-content-center'>
                                                            <div className='uppercase bolder' style={{fontSize:"25px", color:"#c7b301"}}>{(Wallets*1).toFixed(2)} XOF</div>
                                                            <div className='nkp_eye ml-2 pt-2 pointer'><img style={{color:"#c7b301"}} width="23" height="23" src="https://img.icons8.com/ios/50/c7b301/closed-eye.png" alt="closed-eye"/></div>
                                                        </div>
                                                    }
                                                    {
                                                        (exchange.cfa) > Wallets ? 
                                                        <div className="nkp-alert-danger ml-3 mr-3 p-3 mb-2"> Solde insufisant ! </div> : null
                                                    }
                                                    {
                                                        TransItemAlert !== "" ? 
                                                        <div className="nkp-alert-danger ml-3 mr-3 p-3"> {TransItemAlert}</div> : null
                                                    }
                                                </div>
                                                <div>
                                                    <div className="nkp_caption">
                                                        <span>
                                                            {
                                                                changeName === "Orange" ? 
                                                                <img className='m-1 image_selected' src="../../images/om.png" width="20" alt="nkab drapeau" />:
                                                                changeName === "mtn" ? 
                                                                <img className='m-1 image_selected' src="../../images/momo.png" width="20" alt="nkab drapeau" />:
                                                                changeName === "Moov" ? 
                                                                <img className='m-1 image_selected' src="../../images/flooz.png" width="20" alt="nkab drapeau" />:
                                                                changeName === "Wave" ? 
                                                                <img className='m-1 image_selected' src="../../images/wave.png" width="20" alt="nkab drapeau" />:null
                                                            }
                                                        </span>
                                                        <span>
                                                            {
                                                                changeName === "Orange" ? 
                                                                <h5>Orange Money</h5>:
                                                                changeName === "mtn" ? 
                                                                <h5>Mobile Money</h5>:
                                                                changeName === "Moov" ? 
                                                                <h5>Moov Money</h5>:
                                                                changeName === "Wave" ? 
                                                                <h5>Wave</h5>:null
                                                            }
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className='mb-4'>
                                                    <img className='m-1' src="../../images/wave.png" width="20" alt="nkab drapeau" />
                                                    <img className='m-1' src="../../images/om.png" width="20" alt="nkab drapeau" />
                                                    <img className='m-1' src="../../images/flooz.png" width="20" alt="nkab drapeau" />
                                                    <img className='m-1' src="../../images/momo.png" width="20" alt="nkab drapeau" />
                                                </div>

                                                <div className='d-flex pl-2 pr-2'>
                                                    <div id="main-widget-crypto-selector" className="mb-1 nkp_items">
                                                        <div>
                                                            <span className="d-flex align-items-center btn-square btn btn-light btn-lg nkp_items_square" onClick={ChangeStatus ? ChoixChange1b : ChoixChange1}>
                                                                <img src={!changeImage?`${"../../images/question.png"}`:changeImage} width="20" alt="nkab drapeau" className="dark-theme-icon-disable mr-2 icon-16" />
                                                                <span className="d-block text-left w-100 text-truncate font-weight-normal">{!changeName?`${"Choisissez"}`:changeName}</span>
                                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" className="text-gray-500 flex-shrink-0">
                                                                    <path fillRule="evenodd" d="M2.707 4.293L8 9.585l5.293-5.292a1 1 0 111.414 1.414l-6 6a.996.996 0 01-.53.277l-.118.014h-.118a.997.997 0 01-.648-.29l-6-6a1 1 0 011.414-1.415z" clipRule="evenodd"></path>
                                                                </svg>
                                                            </span>
                                                            {
                                                                ChangeStatus?
                                                                <div className="position-relative nkp_items_list">
                                                                    <div className="ml-0 mt-2 w-100 text-left position-absolute nkp_position-absolute">
                                                                        <div className="_3rpmn">
                                                                            <div className="_65T61 css-2b097c-container">
                                                                                <div className="p4Aly mt-2 pb-2 css-0">
                                                                                    <div className="px-2 _5HQUI select-scroll-container css-0">
                                                                                        <div className="mt-1 css-0" id="react-select-2-option-0" tabIndex="-1">
                                                                                            <span className="d-flex justify-content-between border-0 font-weight-normal p-2 mb-0_5 btn-light btn-lg btn-block nkp_item-position" onClick={ChoixChange2a}>
                                                                                                <div className="d-flex flex-row">
                                                                                                    <img src="../../images/wave.png" width="20" alt="nkab drapeau" className="dark-theme-icon-disable mr-2 icon-24"/><span className='nkp_buy_title'>Wave</span>
                                                                                                </div>
                                                                                                <span className="tag tag--md tag-transparent border-gray-400 nkp_buy_title">WAVE</span>
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="mt-1 css-0" id="react-select-2-option-1" tabIndex="-1">
                                                                                            <span className="d-flex justify-content-between border-0 font-weight-normal p-2 mb-0_5 btn-light btn-lg btn-block nkp_item-position" onClick={ChoixChange2b}>
                                                                                                <div className="d-flex flex-row">
                                                                                                    <img src="../../images/om.png" width="20" alt="nkab drapeau" className="dark-theme-icon-disable mr-2 icon-24"/><span className='nkp_buy_title'>Orange</span>
                                                                                                </div>
                                                                                                <span className="tag tag--md tag-transparent border-gray-400 nkp_buy_title">OM</span>
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="mt-1 css-0" id="react-select-2-option-2" tabIndex="-1">
                                                                                            <span className="d-flex justify-content-between border-0 font-weight-normal p-2 mb-0_5 btn-light btn-lg btn-block nkp_item-position" onClick={ChoixChange2c}>
                                                                                                <div className="d-flex flex-row">
                                                                                                    <img src="../../images/flooz.png" width="20" alt="nkab drapeau" className="dark-theme-icon-disable mr-2 icon-24"/><span className='nkp_buy_title'>Moov</span>
                                                                                                </div>
                                                                                                <span className="tag tag--md tag-transparent border-gray-400 nkp_buy_title">FLOOZ</span>
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="mt-1 css-0" id="react-select-2-option-2" tabIndex="-1">
                                                                                            <span className="d-flex justify-content-between border-0 font-weight-normal p-2 mb-0_5 btn-light btn-lg btn-block nkp_item-position" onClick={ChoixChange2d}>
                                                                                                <div className="d-flex flex-row">
                                                                                                    <img src="../../images/momo.png" width="20" alt="nkab drapeau" className="dark-theme-icon-disable mr-2 icon-24"/><span className='nkp_buy_title'>Mobile</span>
                                                                                                </div>
                                                                                                <span className="tag tag--md tag-transparent border-gray-400 nkp_buy_title">MOMO</span>
                                                                                            </span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>:null
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className={`nkp_price_input d-flex justify-content-around ml-1 ${Number(Montant) < 0 || Number(Montant) > 0 ? Wallets < 500 || Montant < 1500 ? "controler_danger" : "controler_success":""}`}>
                                                        <TextField 
                                                            id="outlined-basic" 
                                                            sx={{width:"100%"}} 
                                                            className='bolder' 
                                                            name='montant2' 
                                                            label={`${NKABCFA > 0 ? (NKABCFA*1).toFixed(2) : "Montant"}`} 
                                                            variant="outlined" 
                                                            placeHolder="Montant (XOF)" 
                                                            onChange={handleMontant} 
                                                        />
                                                    </div>
                                                </div>

                                                <div className='d-flex mt-3 pl-2 pr-2'>
                                                    <TextField id="outlined-basic" sx={{width:"100%"}} label="Téléphone" variant="outlined" placeHolder="Numéro bénéficiaire..." onChange={handlePhone} />
                                                </div>
                                                
                                                <div className='d-flex justify-content-between pr-3 pl-3 mt-1 color-black'>
                                                    <span className='nkp_price'>Le numéro bénéficiaire recevra : </span>
                                                    <span className={`${Number(Montant) < 0 || Number(Montant) > 0 ? Wallets < 500 || Montant < 1500 ? "text-danger" : "text-success":"nkp_price"}`}><strong>{exchange.cfa-(exchange.cfa*PayOutRate)} XOF</strong></span>
                                                </div>
                                                
                                                <div className='d-flex justify-content-between pr-3 pl-3 mt-1 color-black'>    
                                                    <span className='nkp_price'> </span> 
                                                    <label className='pointer'>
                                                        <input type="checkbox"
                                                        checked={Accepter}
                                                        onChange={Accepter?handleUnAccepter:handleAccepter}
                                                        />
                                                        <span className="pt-2 color-or">
                                                            {' '}Je suis d'accord
                                                        </span>
                                                    </label>
                                                </div>
                                                    
                                                <div className='d-flex justify-content-center mb-3'>
                                                    {
                                                        Accepter  && TransItemAlert !== "" && Phone === "" ?
                                                            <span style={{textDecoration:"none"}} className='nkp_popup_link-2'>Continuer</span>:
                                                        Accepter  && TransItemAlert === "" && Phone !== "" ? <>
                                                        {
                                                            (Number(Montant) < 1500 || Wallets < 500) ? 
                                                            <span style={{textDecoration:"none"}} className='nkp_popup_link-2'>Continuer</span>:
                                                            <a href="#nkp_pin_popup" style={{textDecoration:"none"}} className='nkp_input nkp_popup_link-1'>Continuer</a>
                                                        }
                                                        </>:<span style={{textDecoration:"none"}} className='nkp_popup_link-2'>Continuer</span>
                                                    }
                                                </div>
                                            </form>
                                        </div>
                                    }
                                    </div>:
                                    <div className="nkp_center" onClick={CurrencyStatus ? ChoixCurrency1b : null}>
                                        <div className="nkp_container1">
                                            <form>
                                                <div className=' pt-3 text-center'>
                                                    <div className='nkp__version-modal'>
                                                        <div className=' d-flex justify-content-between pr-4 pl-4'>
                                                            <div></div>
                                                            <div className='mr-4'>
                                                                Lite <ReactSwitch className='react-switch-handle' checked={checked} onChange={toogleHandleChange} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <p><span className='nkp_status'>Solde disponible</span></p>
                                                    {
                                                        !SeePrice ?
                                                        <h2 style={{fontSize:"30px"}} onClick={seePriceHandler}>
                                                            <strong className='ml-2 nkp_price uppercase pointer'><FontAwesomeIcon icon={faEye} />********</strong>
                                                        </h2>:
                                                        <h2 style={{fontSize:"30px"}}><strong className='ml-2 nkp_price uppercase'><FontAwesomeIcon icon={faEyeSlash} onClick={unSeePriceHandler} className='pointer' />({(Wallets*1).toFixed(2)} XOF)</strong></h2>
                                                    }
                                                    {
                                                        Wallets < 0 ? 
                                                        <div className="nkp-alert-danger ml-3 mr-3 p-3"> Solde insufisant ! </div> : null
                                                    }
                                                    {
                                                        BuyItemAlert !== "" ? 
                                                        <div className="nkp-alert-danger ml-3 mr-3 p-4"> {BuyItemAlert} </div> : null
                                                    }
                                                    {!moneyName?``:<h4> <span className='ml-2 nkp_price bolder'>TAUX D'ACHAT : {taux} XOF</span> </h4>}
                                                </div>

                                                <div className='d-flex pl-2 pr-2 pt-3'>
                                                    <div id="main-widget-crypto-selector" className="mb-1 nkp_items">
                                                        <div>
                                                            <span className="d-flex align-items-center btn-square btn btn-light btn-lg nkp_items_square" onClick={CurrencyStatus ? ChoixCurrency1b : ChoixCurrency1}>
                                                                <img src={!moneyImage?`${"../../images/question.png"}`:moneyImage} width="20" alt="nkab drapeau" className="dark-theme-icon-disable mr-2 icon-16" />
                                                                <span className="d-block text-left w-100 text-truncate font-weight-normal">{!moneyName?`${"Choisissez"}`:moneyName}</span>
                                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" className="text-gray-500 flex-shrink-0">
                                                                    <path fillRule="evenodd" d="M2.707 4.293L8 9.585l5.293-5.292a1 1 0 111.414 1.414l-6 6a.996.996 0 01-.53.277l-.118.014h-.118a.997.997 0 01-.648-.29l-6-6a1 1 0 011.414-1.415z" clipRule="evenodd"></path>
                                                                </svg>
                                                            </span>
                                                            {
                                                                CurrencyStatus?
                                                                <div className="position-relative nkp_items_list">
                                                                    <div className="ml-0 mt-2 w-100 text-left position-absolute nkp_position-absolute">
                                                                        <div className="_3rpmn">
                                                                            <div className="_65T61 css-2b097c-container">
                                                                                <div className="p4Aly mt-2 pb-2 css-0">
                                                                                    <div className="px-2 _5HQUI select-scroll-container css-0">
                                                                                        <div className="mt-1 css-0" id="react-select-2-option-0" tabIndex="-1">
                                                                                            <span className="d-flex justify-content-between border-0 font-weight-normal p-2 mb-0_5 btn-light btn-lg btn-block nkp_item-position" onClick={ChoixCurrency2a}>
                                                                                                <div className="d-flex flex-row">
                                                                                                    <img src="../../images/btc.png" width="20" alt="nkab drapeau" className="dark-theme-icon-disable mr-2 icon-24"/><span className='nkp_buy_title'>Bitcoin</span>
                                                                                                </div>
                                                                                                <span className="tag tag--md tag-transparent border-gray-400 nkp_buy_title">BTC</span>
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="mt-1 css-0" id="react-select-2-option-1" tabIndex="-1">
                                                                                            <span className="d-flex justify-content-between border-0 font-weight-normal p-2 mb-0_5 btn-light btn-lg btn-block nkp_item-position" onClick={ChoixCurrency2b}>
                                                                                                <div className="d-flex flex-row">
                                                                                                    <img src="../../images/usdt.png" width="20" alt="nkab drapeau" className="dark-theme-icon-disable mr-2 icon-24"/><span className='nkp_buy_title'>Tether</span>
                                                                                                </div>
                                                                                                <span className="tag tag--md tag-transparent border-gray-400 nkp_buy_title">USDT</span>
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="mt-1 css-0" id="react-select-2-option-2" tabIndex="-1">
                                                                                            <span className="d-flex justify-content-between border-0 font-weight-normal p-2 mb-0_5 btn-light btn-lg btn-block nkp_item-position" onClick={ChoixCurrency2c}>
                                                                                                <div className="d-flex flex-row">
                                                                                                    <img src="../../images/busd.png" width="20" alt="nkab drapeau" className="dark-theme-icon-disable mr-2 icon-24"/><span className='nkp_buy_title'>Binance USD</span>
                                                                                                </div>
                                                                                                <span className="tag tag--md tag-transparent border-gray-400 nkp_buy_title">BUSD</span>
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="mt-1 css-0" id="react-select-2-option-2" tabIndex="-1">
                                                                                            <span className="d-flex justify-content-between border-0 font-weight-normal p-2 mb-0_5 btn-light btn-lg btn-block nkp_item-position" onClick={ChoixCurrency2d}>
                                                                                                <div className="d-flex flex-row">
                                                                                                    <img src="../../images/pm.png" width="20" alt="nkab drapeau" className="dark-theme-icon-disable mr-2 icon-24"/><span className='nkp_buy_title'>Perfect Money</span>
                                                                                                </div>
                                                                                                <span className="tag tag--md tag-transparent border-gray-400 nkp_buy_title">PM</span>
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="mt-1 css-0" id="react-select-2-option-2" tabIndex="-1">
                                                                                            <span className="d-flex justify-content-between border-0 font-weight-normal p-2 mb-0_5 btn-light btn-lg btn-block nkp_item-position" onClick={ChoixCurrency2e}>
                                                                                                <div className="d-flex flex-row">
                                                                                                    <img src="../../images/ltc.png" width="20" alt="nkab drapeau" className="dark-theme-icon-disable mr-2 icon-24"/><span className='nkp_buy_title'>Litecoin</span>
                                                                                                </div>
                                                                                                <span className="tag tag--md tag-transparent border-gray-400 nkp_buy_title">LTC</span>
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="mt-1 css-0" id="react-select-2-option-2" tabIndex="-1">
                                                                                            <span className="d-flex justify-content-between border-0 font-weight-normal p-2 mb-0_5 btn-light btn-lg btn-block nkp_item-position" onClick={ChoixCurrency2f}>
                                                                                                <div className="d-flex flex-row">
                                                                                                    <img src="../../images/bnb.png" width="20" alt="nkab drapeau" className="dark-theme-icon-disable mr-2 icon-24"/><span className='nkp_buy_title'>Binance SC</span>
                                                                                                </div>
                                                                                                <span className="tag tag--md tag-transparent border-gray-400 nkp_buy_title">BNB</span>
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="mt-1 css-0" id="react-select-2-option-2" tabIndex="-1">
                                                                                            <span className="d-flex justify-content-between border-0 font-weight-normal p-2 mb-0_5 btn-light btn-lg btn-block nkp_item-position" onClick={ChoixCurrency2g}>
                                                                                                <div className="d-flex flex-row">
                                                                                                    <img src="../../images/cardano.png" width="20" alt="nkab drapeau" className="dark-theme-icon-disable mr-2 icon-24"/><span className='nkp_buy_title'>Cardano</span>
                                                                                                </div>
                                                                                                <span className="tag tag--md tag-transparent border-gray-400 nkp_buy_title">ADA</span>
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="mt-1 css-0" id="react-select-2-option-2" tabIndex="-1">
                                                                                            <span className="d-flex justify-content-between border-0 font-weight-normal p-2 mb-0_5 btn-light btn-lg btn-block nkp_item-position" onClick={ChoixCurrency2h}>
                                                                                                <div className="d-flex flex-row">
                                                                                                    <img src="../../images/pokadot.png" width="20" alt="nkab drapeau" className="dark-theme-icon-disable mr-2 icon-24"/><span className='nkp_buy_title'>Polkadot</span>
                                                                                                </div>
                                                                                                <span className="tag tag--md tag-transparent border-gray-400 nkp_buy_title">DOT</span>
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="mt-1 css-0" id="react-select-2-option-2" tabIndex="-1">
                                                                                            <span className="d-flex justify-content-between border-0 font-weight-normal p-2 mb-0_5 btn-light btn-lg btn-block nkp_item-position" onClick={ChoixCurrency2i}>
                                                                                                <div className="d-flex flex-row">
                                                                                                    <img src="../../images/polygonmatic.png" width="20" alt="nkab drapeau" className="dark-theme-icon-disable mr-2 icon-24"/><span className='nkp_buy_title'>Polygon</span>
                                                                                                </div>
                                                                                                <span className="tag tag--md tag-transparent border-gray-400 nkp_buy_title">MATIC</span>
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="mt-1 css-0" id="react-select-2-option-2" tabIndex="-1">
                                                                                            <span className="d-flex justify-content-between border-0 font-weight-normal p-2 mb-0_5 btn-light btn-lg btn-block nkp_item-position" onClick={ChoixCurrency2j}>
                                                                                                <div className="d-flex flex-row">
                                                                                                    <img src="../../images/shiba.png" width="20" alt="nkab drapeau" className="dark-theme-icon-disable mr-2 icon-24"/><span className='nkp_buy_title'>Shiba</span>
                                                                                                </div>
                                                                                                <span className="tag tag--md tag-transparent border-gray-400 nkp_buy_title">SHIB</span>
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="mt-1 css-0" id="react-select-2-option-2" tabIndex="-1">
                                                                                            <span className="d-flex justify-content-between border-0 font-weight-normal p-2 mb-0_5 btn-light btn-lg btn-block nkp_item-position" onClick={ChoixCurrency2k}>
                                                                                                <div className="d-flex flex-row">
                                                                                                    <img src="../../images/solana.png" width="20" alt="nkab drapeau" className="dark-theme-icon-disable mr-2 icon-24"/><span className='nkp_buy_title'>Solana</span>
                                                                                                </div>
                                                                                                <span className="tag tag--md tag-transparent border-gray-400 nkp_buy_title">SOL</span>
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="mt-1 css-0" id="react-select-2-option-2" tabIndex="-1">
                                                                                            <span className="d-flex justify-content-between border-0 font-weight-normal p-2 mb-0_5 btn-light btn-lg btn-block nkp_item-position" onClick={ChoixCurrency2l}>
                                                                                                <div className="d-flex flex-row">
                                                                                                    <img src="../../images/tron.png" width="20" alt="nkab drapeau" className="dark-theme-icon-disable mr-2 icon-24"/><span className='nkp_buy_title'>Tron</span>
                                                                                                </div>
                                                                                                <span className="tag tag--md tag-transparent border-gray-400 nkp_buy_title">TRON</span>
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="mt-1 css-0" id="react-select-2-option-2" tabIndex="-1">
                                                                                            <span className="d-flex justify-content-between border-0 font-weight-normal p-2 mb-0_5 btn-light btn-lg btn-block nkp_item-position" onClick={ChoixCurrency2m}>
                                                                                                <div className="d-flex flex-row">
                                                                                                    <img src="../../images/chainlink.png" width="20" alt="nkab drapeau" className="dark-theme-icon-disable mr-2 icon-24"/><span className='nkp_buy_title'>Chain link</span>
                                                                                                </div>
                                                                                                <span className="tag tag--md tag-transparent border-gray-400 nkp_buy_title">LINK</span>
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="mt-1 css-0" id="react-select-2-option-2" tabIndex="-1">
                                                                                            <span className="d-flex justify-content-between border-0 font-weight-normal p-2 mb-0_5 btn-light btn-lg btn-block nkp_item-position" onClick={ChoixCurrency2n}>
                                                                                                <div className="d-flex flex-row">
                                                                                                    <img src="../../images/doge.png" width="20" alt="nkab drapeau" className="dark-theme-icon-disable mr-2 icon-24"/><span className='nkp_buy_title'>Dogecoin</span>
                                                                                                </div>
                                                                                                <span className="tag tag--md tag-transparent border-gray-400 nkp_buy_title">DOGE</span>
                                                                                            </span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>:null
                                                            }
                                                        </div>
                                                    </div>
                                                    
                                                    <div className={`nkp_price_input ml-1 mb-2 ${Number(exchange.cfa) > 1 && ((Number(exchange.cfa) < transMin) || Wallets < 0) ? "controler_danger" : Number(exchange.cfa) > 50 && (Number(exchange.cfa) > transMin) ? "controler_success" : null}`}>
                                                        <TextField 
                                                            id="outlined-basic" 
                                                            label={`${NKABCONVERTED > 0 ? (NKABCONVERTED*1).toFixed(5) : "Quantité..."}`} 
                                                            variant="outlined" 
                                                            placeholder="Quantité" 
                                                            onChange={handleCurrency} 
                                                        />
                                                    </div>

                                                </div>

                                                <div className='d-flex pl-2 pr-2'>
                                                    <div className='nkp_radio_input mr-2'>
                                                        {
                                                        moneyName === "Tether" || moneyName === "Shiba" || moneyName === "Chain link"? 
                                                        <div className='nkp_network_radio'>
                                                            <input type="radio" name="topping" value="Trc20" id="trc20" className='pointer' onClick={trc20CheckHandler} />
                                                            <label htmlFor="trc20" className='ml-2 pointer' onClick={trc20CheckHandler}>TRC20</label>

                                                            <input type="radio" name="topping" value="Bep20" id="bep20" className='ml-2 pointer' onClick={bep20CheckHandler}/>
                                                            <label htmlFor="bep20" className='ml-2 pointer' onClick={bep20CheckHandler}>BEP20</label>
                                                        </div>:
                                                        moneyName === "Binance USD"? 
                                                        <div className='nkp_network_radio'>
                                                            <input type="radio" name="topping" value="Bep20" id="bep20" className='ml-2 pointer' onClick={bep20CheckHandler}/>
                                                            <label htmlFor="bep20" className='ml-2 pointer' onClick={bep20CheckHandler}>BEP20</label>
                                                        </div>:
                                                        moneyName === "Polkadot"? 
                                                        <div className='nkp_network_radio'>
                                                            <input type="radio" name="topping" value="Polkadot" id="polkadot" className='pointer' onClick={polkadotCheckHandler} />
                                                            <label htmlFor="polkadot" className='ml-2 pointer' onClick={polkadotCheckHandler}>POLKADOT</label>

                                                            <input type="radio" name="topping" value="Bep20" id="bep20" className='ml-2 pointer' onClick={bep20CheckHandler}/>
                                                            <label htmlFor="bep20" className='ml-2 pointer' onClick={bep20CheckHandler}>BEP20</label>
                                                        </div>:
                                                        moneyName === "Polygon"? 
                                                        <div className='nkp_network_radio'>
                                                            <input type="radio" name="topping" value="Matic" id="matic" className='pointer' onClick={maticCheckHandler} />
                                                            <label htmlFor="matic" className='ml-2 pointer' onClick={maticCheckHandler}>MATIC</label>

                                                            <input type="radio" name="topping" value="Bep20" id="bep20" className='ml-2 pointer' onClick={bep20CheckHandler}/>
                                                            <label htmlFor="bep20" className='ml-2 pointer' onClick={bep20CheckHandler}>BEP20</label>
                                                        </div>:
                                                        moneyName === "Cardano"? 
                                                        <div className='nkp_network_radio'>
                                                            <input type="radio" name="topping" value="Cardano" id="cardano" className='pointer' onClick={cardanoCheckHandler} />
                                                            <label htmlFor="cardano" className='ml-2 pointer' onClick={cardanoCheckHandler}>CARDANO</label>

                                                            <input type="radio" name="topping" value="Bep20" id="bep20" className='ml-2 pointer' onClick={bep20CheckHandler}/>
                                                            <label htmlFor="bep20" className='ml-2 pointer' onClick={bep20CheckHandler}>BEP20</label>
                                                        </div>:
                                                        moneyName === "Solana"? 
                                                        <div className='nkp_network_radio'>
                                                            <input type="radio" name="topping" value="Solana" id="solana" className='pointer' onClick={solanaCheckHandler} />
                                                            <label htmlFor="solana" className='ml-2 pointer' onClick={solanaCheckHandler}>SOLANA</label>

                                                            <input type="radio" name="topping" value="Bep20" id="bep20" className='ml-2 pointer' onClick={bep20CheckHandler}/>
                                                            <label htmlFor="bep20" className='ml-2 pointer' onClick={bep20CheckHandler}>BEP20</label>
                                                        </div>:
                                                        <div>
                                                            <div className='nkp_adress_input mr-3'>
                                                                <input className='nkp_input mr-2' type="text" placeholder={`Entrez votre adresse ${!NetAddress?"...":NetAddress}`} onChange={handleAdress} />
                                                            </div>
                                                        </div>
                                                        }
                                                    </div>

                                                    <div className={`nkp_price_input ${Number(exchange.cfa) > 1 && ((Number(exchange.cfa) < transMin) || Wallets < 0) ? "controler_danger" : Number(exchange.cfa) > 50 && (Number(exchange.cfa) > transMin) ? "controler_success" : null}`}>
                                                        <input 
                                                            className="nkp_input bolder" 
                                                            name='montant2' 
                                                            type="text" 
                                                            placeholder={`${Currency > 0 ? ((exchange.cfa)*1).toFixed(2) : "Montant (XOF)"}`} 
                                                            onChange={handleMontant} 
                                                        />
                                                    </div>

                                                </div>
                                                {
                                                    AddressCkecked ?
                                                    <div className='mt-3'>
                                                        <div className='nkp_adress_input mr-3'>
                                                            <input className='nkp_input mr-2' type="text" placeholder={`Entrez votre adresse ${!NetAddress?"...":NetAddress}`} onChange={handleAdress} />
                                                        </div>
                                                    </div>:null
                                                }

                                                <div className='d-flex pr-3 pl-3 mt-2 color-black'>
                                                    <div style={{width:"50%"}}>
                                                    <span className={`${Number(exchange.cfa) > 1 && ((Number(exchange.cfa) < transMin) || Wallets < 0) ? "text-danger" : Number(exchange.cfa) > 50 && (Number(exchange.cfa) > transMin) ? "text-success" : "nkp_price"}`}>
                                                        {moneyName === "Binance USD" ? <strong>{`${((exchange.converted)*1).toFixed(5)} BUSD`}</strong> : 
                                                        moneyName === "Bitcoin" ? <strong>{`${((exchange.converted)*1).toFixed(5)} BTC`}</strong> : moneyName === "Tether" ? <strong>{`${((exchange.converted)*1).toFixed(2)} USDT USDT`}</strong> : 
                                                        moneyName === "Perfect Money" ? <strong>{`${(exchange.converted).toFixed(2)} PM`}</strong> :
                                                        moneyName === "Dogecoin" ? <strong>{`${(exchange.converted).toFixed(2)} DOGE ≈ ${(dollar*1).toFixed(5)} $`}</strong> :
                                                        moneyName === "Litecoin" ? <strong>{`${((exchange.converted)*1).toFixed(5)} LTC`}</strong> : 
                                                        moneyName === "Binance" ? <strong>{`${((exchange.converted)*1).toFixed(5)} BNB`}</strong> :
                                                        moneyName === "Cardano" ? <strong>{`${((exchange.converted)*1).toFixed(2)} ADA`}</strong> :
                                                        moneyName === "Polkadot" ? <strong>{`${((exchange.converted)*1).toFixed(2)} DOT`}</strong> :
                                                        moneyName === "Polygon" ? <strong>{`${((exchange.converted)*1).toFixed(2)} MATIC`}</strong> :
                                                        moneyName === "Shiba" ? <strong>{`${((exchange.converted)*1).toFixed(2)} SHIB`}</strong> :
                                                        moneyName === "Solana" ? <strong>{`${((exchange.converted)*1).toFixed(2)} SOL`}</strong> :
                                                        moneyName === "Tron" ? <strong>{`${((exchange.converted)*1).toFixed(2)} TRON`}</strong> :
                                                        moneyName === "Chain link" ? <strong>{`${((exchange.converted)*1).toFixed(2)} LINK`}
                                                        </strong> :
                                                        "0 $" }</span>
                                                    </div>
                                                    <div style={{width:"50%"}}>
                                                        <span className='nkp_price'><strong>min : {translimit} XOF</strong></span>
                                                    </div>
                                                </div>
                                                    
                                                <div className='d-flex justify-content-center mb-3'>
                                                    {
                                                        (Number(exchange.cfa) < (translimit) || Wallets < 0) && BuyItemAlert !== "" ? 
                                                        <span style={{textDecoration:"none"}} className='nkp_popup_link-2'>Continuer</span>:
                                                        <a href="#nkp_pin_popup" style={{textDecoration:"none"}} className='nkp_input nkp_popup_link-1'>Continuer</a>
                                                    }
                                                </div>

                                            </form>
                                        </div>
                                    </div>
                                    }
                                </div>
                                {Options === "PROFIL"?null:<div className='pt-4 phone-item'><img className='mr-2' src="../../images/home-phone2.png" width="500" alt="" /></div>}
                            </div>
                            <div className='container'>
                                {
                                    BuyingListing ? 
                                    <div className='nkab-com mt-5 mb-5'>
                                        <div className='text-center p-3'>
                                            <Typography sx={{fontSize: "20px"}}> Opération d'achats </Typography>
                                        </div>
                                        <TableContainer component={Paper} style={{fontSize:"25px"}}>
                                            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell style={{fontSize:"17px", fontWeight:"600"}}>Ref</TableCell>
                                                        <TableCell style={{fontSize:"17px", fontWeight:"600"}} >E-Mail</TableCell>
                                                        <TableCell style={{fontSize:"17px", fontWeight:"600"}} >Action</TableCell>
                                                        <TableCell style={{fontSize:"17px", fontWeight:"600"}} >Item</TableCell>
                                                        <TableCell style={{fontSize:"17px", fontWeight:"600"}} >Réseau</TableCell>
                                                        <TableCell style={{fontSize:"17px", fontWeight:"600"}} >Qte</TableCell>
                                                        <TableCell style={{fontSize:"17px", fontWeight:"600"}} >Montant</TableCell>
                                                        <TableCell style={{fontSize:"17px", fontWeight:"600"}} >Adresse</TableCell>
                                                        <TableCell style={{fontSize:"17px", fontWeight:"600"}} >Statut</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                {DetailData.map((dd) => (
                                                    <TableRow key={dd.ID} sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                                                        <TableCell style={{fontSize:"17px"}} >{dd.operationUId}</TableCell>
                                                        <TableCell style={{fontSize:"17px"}} >{dd.email}</TableCell>
                                                        <TableCell style={{fontSize:"17px"}} >{dd.options}</TableCell>
                                                        <TableCell style={{fontSize:"17px"}}>
                                                            <span><img src={dd.moneyImage} width="20" height="20" alt="nkab item" /> <span className='ml-2'>{dd.moneyName}</span></span>
                                                        </TableCell>
                                                        <TableCell style={{fontSize:"17px"}} >{dd.netAddress}</TableCell>
                                                        <TableCell style={{fontSize:"17px"}} >{dd.converted}</TableCell>
                                                        <TableCell style={{fontSize:"17px"}} >{dd.montant} XOF</TableCell>
                                                        <TableCell style={{fontSize:"17px"}} >{dd.adress}</TableCell>
                                                        <TableCell style={{fontSize:"17px"}} >{dd.isValidated === 0 ? <span className="text-danger"> <SmsFailedIcon/> </span>  : <span className="text-success"> <CheckCircleIcon/> </span>}</TableCell>
                                                    </TableRow>
                                                ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div> :null
                                }
                                {
                                    ChargingListing ? 
                                    <div className='nkab-com mt-5 mb-5'>
                                        <div className='text-center p-3'>
                                            <Typography sx={{fontSize: "20px"}}> Opération de recharge </Typography>
                                        </div>
                                        <TableContainer component={Paper} style={{fontSize:"25px"}}>
                                            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell style={{fontSize:"17px", fontWeight:"600"}}>Ref</TableCell>
                                                        <TableCell style={{fontSize:"17px", fontWeight:"600"}} >E-Mail</TableCell>
                                                        <TableCell style={{fontSize:"17px", fontWeight:"600"}} >Action</TableCell>
                                                        <TableCell style={{fontSize:"17px", fontWeight:"600"}} >Item</TableCell>
                                                        <TableCell style={{fontSize:"17px", fontWeight:"600"}} >Cpte de recharge</TableCell>
                                                        <TableCell style={{fontSize:"17px", fontWeight:"600"}} >Montant</TableCell>
                                                        <TableCell style={{fontSize:"17px", fontWeight:"600"}} >Statut</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                {DetailData.map((dd) => (
                                                    <TableRow key={dd.ID} sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                                                        <TableCell style={{fontSize:"17px"}} >{dd.operationUId}</TableCell>
                                                        <TableCell style={{fontSize:"17px"}} >{dd.email}</TableCell>
                                                        <TableCell style={{fontSize:"17px"}} >{dd.options}</TableCell>
                                                        <TableCell style={{fontSize:"17px"}}>
                                                            <span>
                                                                {
                                                                    dd.banqueName === OM ? 
                                                                    <img className='images-drapeau mr-2' src={`../${om}`} alt="" />:
                                                                    dd.banqueName === MOMO ? 
                                                                    <img className='images-drapeau mr-2' src={`../${momo}`} alt="" />:
                                                                    dd.banqueName === MOOV ? 
                                                                    <img className='images-drapeau mr-2' src={`../${flooz}`} alt="" />:
                                                                    dd.banqueName === WAVE ? 
                                                                    <img className='images-drapeau mr-2' src={`../${wave}`} alt="" />:null
                                                                }
                                                                <span className='ml-2'>{dd.moneyName}</span>
                                                            </span>
                                                        </TableCell>
                                                        <TableCell style={{fontSize:"17px"}} >{dd.numcompte}</TableCell>
                                                        <TableCell style={{fontSize:"17px"}} >{dd.rbserved} XOF</TableCell>
                                                        <TableCell style={{fontSize:"17px"}} >{dd.isValidated === 0 ? <span className="text-danger"> <SmsFailedIcon/> </span>  : <span className="text-success"> <CheckCircleIcon/> </span>}</TableCell>
                                                    </TableRow>
                                                ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div> :null
                                }
                                {
                                    TransListing ? 
                                    <div className='nkab-com mt-5 mb-5'>
                                        <div className='text-center p-3'>
                                            <Typography sx={{fontSize: "20px"}}> Opération de transferts </Typography>
                                        </div>
                                        <TableContainer component={Paper} style={{fontSize:"25px"}}>
                                            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell style={{fontSize:"17px", fontWeight:"600"}}>Ref</TableCell>
                                                        <TableCell style={{fontSize:"17px", fontWeight:"600"}} >E-Mail</TableCell>
                                                        <TableCell style={{fontSize:"17px", fontWeight:"600"}} >Action</TableCell>
                                                        <TableCell style={{fontSize:"17px", fontWeight:"600"}} >Item</TableCell>
                                                        <TableCell style={{fontSize:"17px", fontWeight:"600"}} >N°Tel</TableCell>
                                                        <TableCell style={{fontSize:"17px", fontWeight:"600"}} >Montant</TableCell>
                                                        <TableCell style={{fontSize:"17px", fontWeight:"600"}} >Statut</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                {DetailData.map((dd) => (
                                                    <TableRow key={dd.ID} sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                                                        <TableCell style={{fontSize:"17px"}} >{dd.operationUId}</TableCell>
                                                        <TableCell style={{fontSize:"17px"}} >{dd.email}</TableCell>
                                                        <TableCell style={{fontSize:"17px"}} >{dd.options}</TableCell>
                                                        <TableCell style={{fontSize:"17px"}}>
                                                            <span>
                                                                {
                                                                    dd.changeName === OM ? 
                                                                    <img className='images-drapeau mr-2' src={`../${om}`} alt="" />:
                                                                    dd.changeName === MOMO ? 
                                                                    <img className='images-drapeau mr-2' src={`../${momo}`} alt="" />:
                                                                    dd.changeName === MOOV ? 
                                                                    <img className='images-drapeau mr-2' src={`../${flooz}`} alt="" />:
                                                                    dd.changeName === WAVE ? 
                                                                    <img className='images-drapeau mr-2' src={`../${wave}`} alt="" />:null
                                                                }
                                                                <span className='ml-2'>{dd.moneyName}</span>
                                                            </span>
                                                        </TableCell>
                                                        <TableCell style={{fontSize:"17px"}} >{dd.phone}</TableCell>
                                                        <TableCell style={{fontSize:"17px"}} >{dd.rbserved} XOF</TableCell>
                                                        <TableCell style={{fontSize:"17px"}} >{dd.status === "failed" ? <span className="text-danger"> <SmsFailedIcon/> </span>  : <span className="text-success"> <CheckCircleIcon/> </span>}</TableCell>
                                                    </TableRow>
                                                ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div> :null
                                }
                            </div>

                            <div className='nkp_main_info'>
                                <div className='p-5 d-flex justify-content-center'>
                                    <div className='pb-5'>
                                    <a href="https://play.google.com/store/apps/details?id=com.scdigital.nkabexchange&fbclid=IwAR2Jv1Yh" className="playstore nkab" title="Facebook">
                                        <img src="../../images/playstore.png" alt="" width="155" height="50" />
                                    </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
                {
                    Operations ?
                    <div>
                        <ul className="nkp_op_listing_conversion-rate-list">
                            <li className="nkp_op_listing_list-item">
                                <h2 className="nkp_op_listing_platform">Achat</h2>
                                <dl className="nkp_op_listing_ad">
                                <dt className="nkp_op_listing_name">Monnaie</dt>
                                <dd className="nkp_op_listing_value">100.00 $ usdt</dd>
                                <dt className="nkp_op_listing_name">Taux</dt>
                                <dd className="nkp_op_listing_value">665 XOF</dd>
                                <dt className="nkp_op_listing_name">Montant</dt>
                                <dd className="nkp_op_listing_value text-danger">-60000 XOF</dd>
                                </dl>
                            </li>
                            <li className="nkp_op_listing_list-item">
                                <h2 className="nkp_op_listing_platform">Transfert</h2>
                                <dl className="nkp_op_listing_ad">
                                <dt className="nkp_op_listing_name">Monnaie</dt>
                                <dd className="nkp_op_listing_value">(XOF)</dd>
                                <dt className="nkp_op_listing_name">Taux</dt>
                                <dd className="nkp_op_listing_value">{}</dd>
                                <dt className="nkp_op_listing_name">Montant</dt>
                                <dd className="nkp_op_listing_value text-danger">-15000 XOF</dd>
                                </dl>
                            </li>
                            <li className="nkp_op_listing_list-item">
                                <h2 className="nkp_op_listing_platform">Transfert</h2>
                                <dl className="nkp_op_listing_ad">
                                <dt className="nkp_op_listing_name">Monnaie</dt>
                                <dd className="nkp_op_listing_value">(XOF)</dd>
                                <dt className="nkp_op_listing_name">Taux</dt>
                                <dd className="nkp_op_listing_value">{}</dd>
                                <dt className="nkp_op_listing_name">Montant</dt>
                                <dd className="nkp_op_listing_value text-danger">-21000 XOF</dd>
                                </dl>
                            </li>
                            <li className="nkp_op_listing_list-item">
                                <h2 className="nkp_op_listing_platform">Transfert</h2>
                                <dl className="nkp_op_listing_ad">
                                <dt className="nkp_op_listing_name">Monnaie</dt>
                                <dd className="nkp_op_listing_value">(XOF)</dd>
                                <dt className="nkp_op_listing_name">Taux</dt>
                                <dd className="nkp_op_listing_value">{}</dd>
                                <dt className="nkp_op_listing_name">Montant</dt>
                                <dd className="nkp_op_listing_value text-danger">-25000 XOF</dd>
                                </dl>
                            </li>
                            <li className="nkp_op_listing_list-item">
                                <h2 className="nkp_op_listing_platform">Achat</h2>
                                <dl className="nkp_op_listing_ad">
                                <dt className="nkp_op_listing_name">Monnaie</dt>
                                <dd className="nkp_op_listing_value">100.00 $ usdt</dd>
                                <dt className="nkp_op_listing_name">Taux</dt>
                                <dd className="nkp_op_listing_value">665 XOF</dd>
                                <dt className="nkp_op_listing_name">Montant</dt>
                                <dd className="nkp_op_listing_value text-danger">-350000 XOF</dd>
                                </dl>
                            </li>
                            <li className="nkp_op_listing_list-item">
                                <h2 className="nkp_op_listing_platform">Recharge</h2>
                                <dl className="nkp_op_listing_ad">
                                <dt className="nkp_op_listing_name">Monnaie</dt>
                                <dd className="nkp_op_listing_value">(XOF)</dd>
                                <dt className="nkp_op_listing_name">Taux</dt>
                                <dd className="nkp_op_listing_value">{}</dd>
                                <dt className="nkp_op_listing_name">Montant</dt>
                                <dd className="nkp_op_listing_value text-success">+450000 XOF</dd>
                                </dl>
                            </li>
                            <li className="nkp_op_listing_list-item">
                                <h2 className="nkp_op_listing_platform">Transfert</h2>
                                <dl className="nkp_op_listing_ad">
                                <dt className="nkp_op_listing_name">Monnaie</dt>
                                <dd className="nkp_op_listing_value">(XOF)</dd>
                                <dt className="nkp_op_listing_name">Taux</dt>
                                <dd className="nkp_op_listing_value">{}</dd>
                                <dt className="nkp_op_listing_name">Montant</dt>
                                <dd className="nkp_op_listing_value text-danger">-5000 XOF</dd>
                                </dl>
                            </li>
                        </ul>

                        <div className="nkp_op_listing_wrap">
                            <table className="nkp_op_listing_conversion-rate-table">
                                <thead className="nkp_op_listing_table__head">
                                    <tr className="nkp_op_listing_table__headers text-center">
                                        <th className="nkp_op_listing_header" scope="col">Option</th>
                                        <th className="nkp_op_listing_header" scope="col">Devise</th>
                                        <th className="nkp_op_listing_header" scope="col">Taux</th>
                                        <th className="nkp_op_listing_header" scope="col">Montant</th>
                                    </tr>
                                </thead>

                                <tbody className="nkp_op_listing_table__content">
                                    <tr className="nkp_op_listing_table__row">
                                        {
                                            !RechargeListings ?
                                            <td className="nkp_op_listing_row__cell2 nkp_op_l_r_c2" onClick={RechargeListing}>Liste recharge</td> : 
                                            <td className="nkp_op_listing_row__cell2 nkp_op_l_r_c2" onClick={UnRechargeListing}>Liste recharge</td>
                                        }
                                        {
                                            !TransfertListings ?
                                            <td className="nkp_op_listing_row__cell2 nkp_op_l_r_c2" onClick={TransfertListing}>Liste transfert</td> : 
                                            <td className="nkp_op_listing_row__cell2 nkp_op_l_r_c2" onClick={UnTransfertListing}>Liste transfert</td>
                                        }
                                        {
                                            !BuyListings ?
                                            <td className="nkp_op_listing_row__cell2 nkp_op_l_r_c2" onClick={BuyListing}>Liste achat</td> : 
                                            <td className="nkp_op_listing_row__cell2 nkp_op_l_r_c2" onClick={UnBuyListing}>Liste achat</td>
                                        }
                                        <td className="nkp_op_listing_row__cell2 nkp_op_l_r_c2">...</td>
                                    </tr>
                                    {
                                        RechargeListings ? 
                                        <>
                                            {
                                                RechargeData.length === 0 ?
                                                <div className="bouncing-loader p-4">
                                                    <div></div>
                                                    <div></div>
                                                    <div></div>
                                                </div> :
                                                RechargeData.map((item) =>
                                                <tr key={item.ID} className="nkp_op_listing_table__row">
                                                    {
                                                        item.isValidated === 1 ? <>
                                                        <td className="nkp_op_listing_row__cell">{item.options}</td>
                                                        <td className="nkp_op_listing_row__cell">(XOF)</td>
                                                        <td className="nkp_op_listing_row__cell">{}</td>
                                                        <td className="nkp_op_listing_row__cell text-success">+{item.rbserved} XOF</td>
                                                        </>:null
                                                    }
                                                </tr>
                                            )}
                                        </> : null
                                    }
                                    {
                                        BuyListings ? 
                                        <>
                                            {
                                                BuyData.length === 0 ?
                                                <div className="bouncing-loader p-4">
                                                    <div></div>
                                                    <div></div>
                                                    <div></div>
                                                </div> :
                                                BuyData.map((item) =>
                                                <tr key={item.ID} className="nkp_op_listing_table__row">
                                                    {
                                                        item.isValidated === 1 ? <>
                                                        <td className="nkp_op_listing_row__cell">{item.options}</td>
                                                        <td className="nkp_op_listing_row__cell">{item.dollar} $ usdt</td>
                                                        <td className="nkp_op_listing_row__cell">{taux} XOF</td>
                                                        <td className="nkp_op_listing_row__cell text-danger">-{item.montant} XOF</td>
                                                        </>:null
                                                    }
                                                </tr>
                                            )}
                                        </> : null
                                    }
                                    {
                                        TransfertListings ? 
                                        <>
                                            {
                                                TransData.length === 0 ?
                                                <div className="bouncing-loader p-4">
                                                    <div></div>
                                                    <div></div>
                                                    <div></div>
                                                </div> :
                                                TransData.map((item) =>
                                                <tr key={item.ID} className="nkp_op_listing_table__row">
                                                    {
                                                        item.isValidated === 1 ? <>
                                                        <td className="nkp_op_listing_row__cell">{item.options}</td>
                                                        <td className="nkp_op_listing_row__cell">(XOF)</td>
                                                        <td className="nkp_op_listing_row__cell">{}</td>
                                                        <td className="nkp_op_listing_row__cell text-danger">-{item.montant} XOF</td>
                                                        </>:null
                                                    }
                                                </tr>
                                            )}
                                        </> : null
                                    }
                                </tbody>
                            </table>
                        </div>

                    </div>:null
                }

                <div>
                  <div className="row text-center animate__animated animate__backInLeft">
                    <div className="text-center">
                      <div className='container'>
                        <Banner/><br/>
                        <NumbersStatus />
                        <Variations />
      
                        <div className={`${themeMode === "true" ? "nkab-com-t" : "nkab-com"}`}>
                          <SupportCommunity />
                          <div className='pb-5'>
                            <a href="https://play.google.com/store/apps/details?id=com.scdigital.nkabexchange&fbclid=IwAR2Jv1Yh" className="playstore nkab" title="Facebook">
                              <img src="../../images/playstore.png" alt="" width="155" height="50" />
                            </a>
                          </div>
                        </div>
                      </div>
                      <br />
                    </div>
                  </div>
                </div>
                
                {/* {
                    premium ? null : 
                    <div className='nkp_currency mt-5'>
                        <div className="text-center">
                            <h4 className='color-grey nkp_title_h1'>Informations sur l'évolution de cryptomonnaie</h4>
                        </div>
                        <div className="d-flex justify-content-center flex-wrap mt-3">
                            {
                                coins.map((coin)=>(
                                    <div key={coin.id} className="change-items">
                                        <div className="change-titles">
                                            <div className="change-name" style={{fontSize:"15px"}}>
                                                <img src={coin.image} width="15" height="15" alt="logo nkab" /> <span className='color-grey'>{coin.symbol}</span></div>
                                            <span className={ coin.price_change_percentage_24h < 0 ? 'mr-2 text-danger' : 'mr-2 text-success'} >
                                            {coin.price_change_percentage_24h < 0 ? <i className="fa fa-sort-down mr-1 text-danger"></i> : <i className="fa fa-sort-up mr-1 text-success"></i>}
                                            {coin.price_change_percentage_24h.toFixed(2)}%
                                            </span>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                } */}
                {
                    premium ? null : 
                    <div className='nkp_currency2 mb-4'>
                        <div className="d-flex justify-content-center flex-wrap">
                            {
                                coins.map((coin)=>(
                                    <div key={coin.id} className="change-items">
                                        <div>
                                            <div className="change-titles">
                                                <div className="change-name uppercase bolder" style={{fontSize:"15px"}}>{coin.symbol} <span className='color-grey'>{(coin.current_price*1).toFixed(2)}$</span></div>
                                                <span className={ coin.price_change_percentage_24h < 0 ? 'mr-2 text-danger' : 'mr-2 text-success'} >
                                                {coin.price_change_percentage_24h < 0 ? <i className="fa fa-sort-down mr-1 text-danger"></i> : <i className="fa fa-sort-up mr-1 text-success"></i>}
                                                {coin.price_change_percentage_24h.toFixed(2)}%
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                }

                {
                    premium ? null : 
                    <section id='allservices' className='mt-4'>
                        <div className="_our-wrapper">
                            <div className="_our-header">
                                <h4 className="color-grey nkp_title_h1">Explorez des possibilités avec E-NKAB Exchange</h4>
                            </div>
    
                            <div className="_our-cards">
    
                                <div className="_our-card [ is-collapsed ]">
                                <div className={"card__inner [ js-expander ]"}>
                                    <div><p className='card_subtitle' ><strong>Envoyer de l'argent à vos proches</strong></p></div>
                                    <div style={{ paddingBottom: '5px' }}>
                                        <div data-bn-type="text" className='color-grey' style={{fontSize:"13px"}}>
                                            Vous avez la possibilité d'envoyer de l'argent à vos proches depuis votre E-NKAB vers différents opérateurs réseaux.
                                        </div>
                                        {/* <a href="#/"><div data-bn-type="text">En savoir plus</div></a> */}
                                    </div>
                                </div>
                                </div>
    
                                <div className=" _our-card [ is-collapsed ] ">
                                <div className={"card__inner [ js-expander ]"}>
                                    <div><p className='card_subtitle'><strong>Achetez à des taux plus abordables</strong></p></div>
                                    <div style={{ paddingBottom: '5px' }}>
                                        <div data-bn-type="text" className='color-grey' style={{fontSize:"13px"}}>
                                            Achetez en toute liberté des crypto monnaies à un taux plus abordable et adapté selon la monnaie de votre choix. 
                                        </div>
                                        {/* <a href="#/"><div data-bn-type="text">En savoir plus</div></a> */}
                                    </div>
                                </div>
                                </div>
    
                                <div className=" _our-card [ is-collapsed ] ">
                                <div className={"card__inner [ js-expander ]"}>
                                    <div><p className='card_subtitle'><strong>Rechargez votre portefeuille à tout moment</strong></p></div>
                                    <div style={{ paddingBottom: '5px' }}>
                                        <div data-bn-type="text" className='color-grey' style={{fontSize:"13px"}}>Plusieurs moyens de paiements et sécurisés sont mis à votre disposition pour vous permettre un rechargement simple et efficace.</div>
                                        {/* <a href="#/"> <div data-bn-type="text">En savoir plus</div> </a> */}
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                    </section>
                }
                
                {
                    premium ? null : 
                    <div>
                        <div id="closed"></div>
                        <div className="nkp_pin_popup-wrapper" id="nkp_pin_popup">
                            <div className="nkp_pin_popup-container text-center">
                                <center>
                                    <div className='pt-2 pb-2'>{MyCodePinID.length === 0 || PassConfirmed === "Code Pin correct ! Félicitation :)"?null:"Entrez votre code pin puis validez!"}</div>
                                    {
                                        MyCodePinID.length === 0?<div className={`ml-4 mr-1 alert alert-info`} role="alert"> Vous n'avez pas de code pin pour terminer votre achat. Vous devez en créer un nouveau! </div>:null
                                    }
                                    {
                                        PassConfirmed === ""?null:
                                        <div className={`ml-4 mr-1 alert alert-${PassConfirmed === "Code Pin correct ! Félicitation :)"?"success":"danger"}`} role="alert"> {PassConfirmed === "Code Pin correct ! Félicitation :)"? "Veuillez patienter svp!" : PassConfirmed} </div>
                                    }
                                    { MyCodePinID.length === 0? null :
                                        PassConfirmed === "Code Pin correct ! Félicitation :)" ? null : 
                                        <OutlinedInput
                                            sx={{width:"100%"}}
                                            onChange={handleChangeInput}
                                            placeholder="Code pin"
                                            id="outlined-adornment-password"
                                            type={showPassword ? "text" : "password"}
                                            endAdornment={
                                                <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={handleClickShowPassword}
                                                    onMouseDown={handleMouseDownPassword}
                                                    edge="end"
                                                >
                                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                                </InputAdornment>
                                            }
                                            label="Password"
                                            />
                                    }
                                </center>
                                <a className="nkp_pin_popup-close" href="#closed">X</a>
                                {
                                    MyCodePinID.length === 0 ? null : 
                                    <div className='mt-4'>
                                        {
                                            Loader ? 
                                            <div className='pt-4'>
                                                <div className="bouncing-loader">
                                                    <div></div>
                                                    <div></div>
                                                    <div></div>
                                                </div>
                                            </div> :
                                            <>
                                            {
                                                MySuccess === "" ?
                                                <>{
                                                    Options === "ACHAT" ? 
                                                        <span className='nkp_popup_btn' onClick={BuyHandler}>Valider</span>:
                                                    Options === "TRANSFERT" ?
                                                        <span className='nkp_popup_btn' onClick={TransferHandler}>Valider</span>: null
                                                }</>:null
                                            }
                                            </>
                                        }
                                    </div>
                                }
                                {
                                    PassConfirmed === "Code Pin correct ! Félicitation :)" ? null : 
                                    <div className='mt-5'> 
                                            <span className='nkp_profil_btn' onClick={ChoixOption5}>
                                            <a href="#closed">
                                                {MyCodePinID.length === 0 ? "Générer un nouveau code pin " : "J'ai oublié mon code ? "}
                                                <FontAwesomeIcon icon={faUserEdit} />
                                            </a>
                                        </span>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                }

                {/* {
                    premium ? null : 
                    <div className='nkp_diplay_container'>
                        <div className={"nkp_bottom_navbar" && isMenuVisible ? 'visible' : 'hidden'}>
                            <div className='nkab_ul'>
                                <div className={Options === "NEWCODE"?"nkab_li active":" nkab_li"}>
                                    <a href="#/" onClick={ChoixOption5Mobile}>
                                        <span className={Options === "NEWCODE"?"nkp_bottom_span active_color":"nkp_bottom_span"}><FontAwesomeIcon icon={faKey} /></span>
                                        <span className='nkp_bottom_navbar_title'>Code pin</span>
                                    </a>
                                </div>
                                <div className={Options === "RECHARGE"?"nkab_li active":" nkab_li"}>
                                    <a href="#/" onClick={ChoixOption3Mobile}>
                                        <span className={Options === "RECHARGE"?"nkp_bottom_span active_color":"nkp_bottom_span"}><FontAwesomeIcon icon={faPlusCircle} /></span> 
                                        <span className='nkp_bottom_navbar_title'>Recharge</span>
                                    </a>
                                </div>
                                <div className={Options === "ACHAT"?"nkab_li active":" nkab_li"}>
                                    <a href="#/" onClick={ChoixOption1Mobile}>
                                        <span className={Options === "ACHAT"?"nkp_bottom_span active_color":"nkp_bottom_span"}><FontAwesomeIcon icon={faMoneyBill} /></span>
                                        <span className='nkp_bottom_navbar_title'>Achat</span>
                                    </a>
                                </div>
                                <div className={Options === "TRANSFERT"?"nkab_li active":" nkab_li"}>
                                    <a href="#/" onClick={ChoixOption2Mobile}>
                                        <span className={Options === "TRANSFERT"?"nkp_bottom_span active_color":"nkp_bottom_span"}><FontAwesomeIcon icon={faExchangeAlt} /></span>
                                        <span className='nkp_bottom_navbar_title'>Transfert</span>
                                    </a>
                                </div>
                                <div className='indicator'></div>
                            </div>
                        </div>
                    </div>
                } */}

                {
                    premium ? null : 
                    <div className="nkp_diplay_container">
                        <div id="nkp_bottom_navbar" className={isMenuVisible ? 'visible' : 'hidden'}>
                            <div className='nkab_ul'>
                                <div className={Options === "NEWCODE"?"nkab_li active":" nkab_li"}>
                                    <a href="#/" onClick={ChoixOption5Mobile}>
                                        <span className="nkp_bottom_span">
                                            <img src="../../images/nkabico/t_ico_code_pin.png" width="25" className={Options === "NEWCODE"?"color-or-nkab":""}  alt="nkab ico" />
                                            {/* <FontAwesomeIcon className={Options === "NEWCODE"?"color-or-nkab":""} style={{fontSize:"20px"}} icon={faKey} /> */}
                                        </span>
                                        <span className='nkp_bottom_navbar_title'>Code pin</span>
                                    </a>
                                </div>
                                <div className={Options === "RECHARGE"?"nkab_li active":" nkab_li"}>
                                    <a href="#/" onClick={ChoixOption3Mobile}>
                                        <span className="nkp_bottom_span">
                                            <img src="../../images/nkabico/t_ico_recharge.png" width="25" className={Options === "NEWCODE"?"color-or-nkab":""}  alt="nkab ico" />
                                            {/* <FontAwesomeIcon className={Options === "RECHARGE"?"color-or-nkab":""} style={{fontSize:"20px"}} icon={faPlusCircle} /> */}
                                        </span> 
                                        <span className='nkp_bottom_navbar_title'>Recharge</span>
                                    </a>
                                </div>
                                <div className={Options === "ACHAT"?"nkab_li active":" nkab_li"}>
                                    <a href="#/" onClick={ChoixOption1Mobile}>
                                        <span className="nkp_bottom_span">
                                            <img src="../../images/nkabico/t_ico_achat.png" width="25" className={Options === "NEWCODE"?"color-or-nkab":""}  alt="nkab ico" />
                                            {/* <FontAwesomeIcon className={Options === "ACHAT"?"color-or-nkab":""} style={{fontSize:"20px"}} icon={faMoneyBill} /> */}
                                        </span> 
                                        <span className='nkp_bottom_navbar_title'>Achat</span>
                                    </a>
                                </div>
                                <div className={Options === "TRANSFERT"?"nkab_li active":" nkab_li"}>
                                    <a href="#/" onClick={ChoixOption2Mobile}>
                                        <span className="nkp_bottom_span">
                                            <img src="../../images/nkabico/t_ico_transfert.png" width="25" className={Options === "NEWCODE"?"color-or-nkab":""}  alt="nkab ico" />
                                            {/* <FontAwesomeIcon className={Options === "TRANSFERT"?"color-or-nkab":""} style={{fontSize:"20px"}} icon={faExchangeAlt} /> */}
                                        </span> 
                                        <span className='nkp_bottom_navbar_title'>Transfert</span>
                                    </a>
                                </div>
                                <div className="nkab_li">
                                    <a href="#logout" onClick={handleLogout}>
                                        <span className="nkp_bottom_span">
                                            <img src="../../images/nkabico/t_ico_connexion.png" width="25" className={Options === "NEWCODE"?"color-or-nkab":""}  alt="nkab ico" />
                                            {/* <FontAwesomeIcon style={{fontSize:"20px"}} icon={Logged === 'Logged'?faSignOutAlt:faSignInAlt} /> */}
                                        </span>
                                        <span className='nkp_bottom_navbar_title'>{Logged === 'Logged'?"Logout":"login"}</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                }

                {
                    premium ? null : 
                    <div className='p-5 text-center mt-5 color-grey nkp_title_h1'>
                        <h4 className='color-grey nkp_title_h1'>Obtenir des cryptos avec grâce à E-NKAB</h4>
                        <p>Achetez facilement des cryptomonnaies en vous servant simplement de votre E-NKAB.</p>
    
                        <div className='row nkp_calculator_main_card'>
                            <div className='col-md-2'></div>
                            <div className='col-md-4 text-center nkp_calculator_card'>
                                <div className='mb-3'><h4 className='color-grey nkp_title_h1'>Calculateur de cryptomonnaies</h4></div>
                                <div className='d-flex justify-content-between nkp_calculator mb-2'>
                                    <span>
                                        <input 
                                            className='nkp_input' 
                                            type='text' 
                                            placeholder={`${1}`} 
                                            onChange={handleCurrencyCount1}
                                        />
                                    </span>
                                    <span className='pt-3 pointer nkp_faq_title'><a href="#popup1"><img src={CurrencyChecked.length === 0?"../../images/btc.png":CurrencyChecked} width="20" height="20" alt="logo nkab" /> <FontAwesomeIcon icon={faChevronDown} /></a></span>
                                </div>
                                <div className='d-flex justify-content-between nkp_calculator'>
                                    <span>
                                        <input 
                                            className='nkp_input' 
                                            type='text' 
                                            placeholder={`${1}`} 
                                            onChange={handleCurrencyCount2}
                                        />
                                    </span>
                                    <span className='pt-3 pointer nkp_faq_title'><a href="#popup2"><img src={CurrencyChecked2.length === 0?"../../images/usdt.png":CurrencyChecked2} width="20" height="20" alt="logo nkab" /> <FontAwesomeIcon icon={faChevronDown} /></a></span>
                                </div>
                                <div className='color-grey mt-2'>
                                    {/* <span>Prix estimé : {Calculate===""?1:Calculate} {CurrencyCheckedSymbol===""?"BTC":CurrencyCheckedSymbol} ≈ {Calculate===""?1*btcPrice:Number(Calculate)*btcPrice} {CurrencyCheckedSymbol2===""?"USDT":CurrencyCheckedSymbol2}</span> */}
                                </div>
                                <div className="d-flex justify-content-center flex-wrap">
                                    {
                                        coins2.map((coin)=>(
                                            <div key={coin.id} className="change-items">
                                                <div className="change-titles">
                                                    <div className="change-name" style={{fontSize:"15px"}}>
                                                        <img src={coin.image} width="15" height="15" alt="logo nkab" /> <span className='color-grey'>{coin.symbol}</span></div>
                                                    <span className={ coin.price_change_percentage_24h < 0 ? 'mr-2 text-danger' : 'mr-2 text-success'} >
                                                    {coin.price_change_percentage_24h < 0 ? <i className="fa fa-sort-down mr-1 text-danger"></i> : <i className="fa fa-sort-up mr-1 text-success"></i>}
                                                    {coin.price_change_percentage_24h.toFixed(2)}%
                                                    </span>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                            <div className='col-md-4 text-center nkp_calculator_container'>
                                <div>
                                    <div>
                                        <div className='nkp_calculator_title'><h5>Dépôt sécurisé</h5></div>
                                        <div>
                                            <span className='mr-2'><img src="../../images/bni.png" width="20" height="20" alt="logo nkab" /></span>
                                            <span className='mr-2'><img src="../../images/bicici.png" width="20" height="20" alt="logo nkab" /></span>
                                            <span className='mr-2'><img src="../../images/ecob.png" width="20" height="20" alt="logo nkab" /></span>
                                            <span><img src="../../images/uba.png" width="20" height="20" alt="logo nkab" /></span>
                                        </div>
                                        <div className='d-flex justify-content-center p-2 nkp_calculator_animation'>
                                            <div className="waving">
                                                <span>e</span>
                                                <span>-</span>
                                            </div>
                                            <div className="waving">
                                                <span>n</span>
                                                <span>k</span>
                                                <span>a</span>
                                                <span>b</span>
                                            </div>
                                        </div>
                                        <p><span>Faites un dépôt par un mode de paiement</span></p>
                                        <div><button className='nkp_button' onClick={ChoixOption3}><a href="#recharge" className='uppercase'>Recharger <FontAwesomeIcon style={{fontSize:"20px"}} icon={faPlusCircle} /></a></button></div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-2'></div>
                        </div>
                    </div>
                }

                {
                    premium ? null : 
                    <div className='p-5 text-center mt-5'>
                        <div><h1 className='color-grey nkp_title_h1'><strong>FAQ<span className='nkp_faq_mobile_title'> (Frequently Asked Questions / Questions Fréquemment Posées)</span></strong></h1></div>
                        <div className='row'>
                            <div className='col-md-3'></div>
                            <div className='mt-3 pointer col-md-6' onClick={Faq0?faqHandler0b:faqHandler0}>
                                <div className={`d-flex justify-content-between nkp_faq_title ${Faq0?nkp_faq_title_hovered:''}`}>
                                    <span><strong className='nkp_faq_strong'>Qu’est-ce que NKAB Exchange ?</strong></span>
                                    <span className='ml-5'><FontAwesomeIcon icon={Faq0?faChevronUp:faChevronDown} /></span>
                                </div>
                                {
                                    Faq0?
                                    <p className='mt-3 nkp_p_content'>
                                        <strong>NKAB EXCHANGE</strong> est une plateforme d'échange de crypto-actifs et de transfert d'argent national et international basée en Afrique de l'Ouest développée par NK Group Technology dont Elle est une filiale.<br/><br/>
    
                                        Elle donne ainsi la possibilité à toute personne d'échanger de la cryptomonnaie contre du fiat et du fiat contre de la cryptomonnaie, d'effectuer leurs transactions de façon automatique et en toute sécurité.<br/><br/>
    
                                        Elle permet également de faire des transferts d'argent inter-opérateurs nationaux et internationaux sans se déplacer en respectant toutes les normes sécuritaires.<br/><br/>
    
                                        Nous avons choisi de faciliter la vie à nos utilisateurs tant dans l'acquisition de monnaies crypto-actifs et dans les transferts d'argent.<br/><br/>
    
                                        Nous mettons ainsi au devant une sécurité très optimale sécurisant tout cadre afin de garantir les transactions de nos différents utilisateurs.
                                    </p>:null
                                }
                                <hr/>
                            </div>
                            <div className='col-md-3'></div>
                        </div>
                        <div className='row'>
                            <div className='col-md-3'></div>
                            <div className='mt-3 pointer col-md-6' onClick={Faq1?faqHandler1b:faqHandler1}>
                                <div className={`d-flex justify-content-between nkp_faq_title ${Faq1?nkp_faq_title_hovered:''}`}>
                                    <span><strong className='nkp_faq_strong'>Qu’est-ce qu’une cryptomonnaie ?</strong></span>
                                    <span className='ml-5'><FontAwesomeIcon icon={Faq1?faChevronUp:faChevronDown} /></span>
                                </div>
                                {
                                    Faq1?
                                    <p className='mt-3 nkp_p_content'>
                                        La cryptomonnaie est une forme numérique de monnaie qui utilise la cryptographie comme moyen de sécurité et fonctionne indépendamment d’une banque centrale.<br/><br/>
                                        Les transactions en cryptomonnaies sont enregistrées sur un registre public distribué appelé blockchain, qui garantit que toutes les transactions sont sécurisées, transparentes et irréversibles.<br/><br/>
                                        Les cryptomonnaies sont décentralisées et offrent des avantages potentiels par rapport aux devises traditionnelles, tels que des transactions plus rapides et moins chères, une plus grande confidentialité et la possibilité de contourner les intermédiaires financiers.<br/><br/>
                                        Cependant, elles peuvent être très volatiles et sujettes à d’importantes fluctuations de prix, et l’environnement réglementaire entourant les cryptomonnaies est toujours en évolution, ce qui crée de l’incertitude et des risques pour les investisseurs.
                                    </p>:null
                                }
                                <hr/>
                            </div>
                            <div className='col-md-3'></div>
                        </div>
                        <div className='row'>
                            <div className='col-md-3'></div>
                            <div className='mt-3 pointer col-md-6' onClick={Faq2?faqHandler2b:faqHandler2}>
                                <div className={`d-flex justify-content-between nkp_faq_title ${Faq2?nkp_faq_title_hovered:''}`}>
                                    <span><strong className='nkp_faq_strong'>Comment acheter des cryptomonnaies ?</strong></span>
                                    <span className='ml-5'><FontAwesomeIcon icon={Faq2?faChevronUp:faChevronDown} /></span>
                                </div>
                                {
                                    Faq2?
                                    <p className='mt-3 nkp_p_content'>
                                        Vous pouvez acheter des cryptos instantanément via l’application ou le site Web en ligne de Binance, en suivant les étapes ci-dessous :<br/><br/>
    
                                        1. Créez un compte sur le site de nkab-exchange.<br/><br/>
                                        2. Effectuez les étapes de vérification nécessaires, telles que la vérification d’identité.<br/><br/>
                                        3. Choisissez la cryptomonnaie que vous souhaitez acheter, sélectionnez votre mode de paiement préféré puis indiquez le montant que vous souhaitez dépenser.<br/><br/>
                                        4. Vérifiez les détails de la transaction et confirmez l’achat.<br/><br/>
    
                                        La cryptomonnaie que vous venez d’acheter sera créditée sur votre compte e-nkab.
                                    </p>:null
                                }
                                <hr/>
                            </div>
                            <div className='col-md-3'></div>
                        </div>
                        <div className='row'>
                            <div className='col-md-3'></div>
                            <div className='mt-3 pointer col-md-6' onClick={Faq3?faqHandler3b:faqHandler3}>
                                <div className={`d-flex justify-content-between nkp_faq_title ${Faq3?nkp_faq_title_hovered:''}`}>
                                    <span><strong className='nkp_faq_strong'>Comment acheter des cryptomonnaies ?</strong></span>
                                    <span className='ml-5'><FontAwesomeIcon icon={Faq3?faChevronUp:faChevronDown} /></span>
                                </div>
                                {
                                    Faq3?
                                    <p className='mt-3 nkp_p_content'>
                                        Il existe plusieurs raisons pour lesquelles une personne peut envisager d’acheter des cryptomonnaies dans le but d’investir :<br/><br/>
    
                                        1. Potentiel de rendement élevé : les cryptomonnaies peuvent être très volatiles et subir d’importantes fluctuations de prix, ce qui signifie qu’elles offrent un potentiel de rendement élevé si vous achetez au bon moment et vendez lorsque le prix a augmenté.<br/><br/>
                                        2. Diversification : investir dans les cryptomonnaies peut être un moyen de diversifier votre portefeuille d’investissement et de répartir vos risques entre différents types d’actifs.<br/><br/>
                                        3. Décentralisées et sûres : les cryptomonnaies sont décentralisées et fonctionnent indépendamment des systèmes financiers traditionnels, ce qui signifie qu’elles offrent un niveau élevé de sécurité et de confidentialité.<br/><br/>
                                        4. Une adoption en augmentation : les cryptomonnaies sont de plus en plus largement adoptées comme moyen de paiement et comme réserve de valeur, ce qui laisse penser que leur valeur pourrait continuer à augmenter au fil du temps.
                                    </p>:null
                                }
                                <hr/>
                            </div>
                            <div className='col-md-3'></div>
                        </div>
                        <div className='row'>
                            <div className='col-md-3'></div>
                            <div className='mt-3 pointer col-md-6' onClick={Faq4?faqHandler4b:faqHandler4}>
                                <div className={`d-flex justify-content-between nkp_faq_title ${Faq4?nkp_faq_title_hovered:''}`}>
                                    <span><strong className='nkp_faq_strong'>Que faire avec les cryptomonnaies ?</strong></span>
                                    <span className='ml-5'><FontAwesomeIcon icon={Faq4?faChevronUp:faChevronDown} /></span>
                                </div>
                                {
                                    Faq4?
                                    <p className='mt-4 nkp_p_content'>
                                        Les cryptomonnaies peuvent être utilisées de différentes manières, notamment pour acheter des biens et des services, effectuer du trading sur des échanges, détenir des investissements, envoyer de l’argent à l’étranger et soutenir des organisations caritatives.<br/><br/>
                                        Il offre des avantages tels que la décentralisation, la sécurité et la protection de la vie privée, ainsi qu’un potentiel de rendement élevé et de diversification des portefeuilles d’investissement.<br/><br/>
                                        La disponibilité et l’acceptation des cryptomonnaies peuvent également varier d’un pays ou d’une région à l’autre, et leur utilisation et leur investissement nécessitent des recherches approfondies et une bonne compréhension des risques encourus.<br/><br/>
                                        Dans l’ensemble, les cryptomonnaies offrent de nouvelles possibilités et de nouveaux défis pour la finance et l’investissement à l’ère numérique.
                                    </p>:null
                                }
                                <hr/>
                            </div>
                            <div className='col-md-3'></div>
                        </div>
                        <div className='row'>
                            <div className='col-md-3'></div>
                            <div className='mt-3 pointer col-md-6' onClick={Faq5?faqHandler5b:faqHandler5}>
                                <div className={`d-flex justify-content-between nkp_faq_title ${Faq5?nkp_faq_title_hovered:''}`}>
                                    <span><strong className='nkp_faq_strong'>Quelle cryptomonnaie devrais-je acheter ?</strong></span>
                                    <span className='ml-5'><FontAwesomeIcon icon={Faq5?faChevronUp:faChevronDown} /></span>
                                </div>
                                {
                                    Faq5?
                                    <p className='mt-4 nkp_p_content'>
                                        La cryptomonnaie que vous choisissez d’acheter dépend de ce que vous comptez en faire. Le Bitcoin, le Litecoin ou le Bitcoin Cash sont souvent acceptés pour les dépenses en cryptomonnaies.<br/><br/>
                                        Ethereum et les tokens ERC-20 sont idéaux pour créer des smart contracts, acheter des NFT ou pour d’autres cas d’utilisation innovants.<br/><br/>
                                        Le Dogecoin et le Shiba Inu sont des cryptomonnaies populaires en raison de leurs fortes communautés, et elles sont souvent considérées comme des cryptos amusantes à acheter, à détenir et à échanger.<br/><br/>
                                        Les stablecoins comme l’USD Coin et le PAX Dollar sont adossés à la valeur du dollar américain, ce qui leur confère moins de volatilité que les autres cryptomonnaies.
                                    </p>:null
                                }
                                <hr/>
                            </div>
                            <div className='col-md-3'></div>
                        </div>
                    </div>
                }

                {
                    premium ? null : 
                    <div id="popup1" className="nkp__overlay">
                        <div className="nkp__popup">
                            <h5>Sélectionner une devise</h5>
                            <a className="nkp__close" href="#/">&times;</a>
                            <div className="text-center">
                                <div className="searchbar-box">
                                    <input type="text" className="nkp_input" name="searchbar" id="mySearchbar" placeholder="Search" onChange={handleSearchCurrency}/>
                                </div>
                                <div className='nkp__currency_list p-3'>
                                    {
                                        NkabSearchResult.length > 0 ? NkabSearchResult.map((currency)=>
                                            <a key={currency.id} href="#/" className='nkp_currency_item_container'>
                                                <div className='d-flex mb-3 nkp_currency_item' onClick={() => cureencyHandler(currency.id)}>
                                                    <div><img src={`${currency.image}`} width="50" alt="nkab drapeau" /></div>
                                                    <div className='ml-2 nkp_currency_items'>
                                                        <span><strong style={{color:"#777779"}}>{currency.title}</strong></span><br/>
                                                        <span className='color-grey'>{currency.content}</span>
                                                    </div>
                                                </div>
                                            </a>
                                        ): currencyData.map((currency)=>
                                            <a key={currency.id} href="#/" className='nkp_currency_item_container'>
                                                <div className='d-flex mb-3 nkp_currency_item' onClick={() => cureencyHandler(currency.id)}>
                                                    <div><img src={`${currency.image}`} width="50" alt="nkab drapeau" /></div>
                                                    <div className='ml-2 nkp_currency_items'>
                                                        <span><strong style={{color:"#777779"}}>{currency.title}</strong></span><br/>
                                                        <span className='color-grey'>{currency.content}</span>
                                                    </div>
                                                </div>
                                            </a>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                }

                {
                    premium ? null : 
                    <div id="popup2" className="nkp__overlay">
                        <div className="nkp__popup">
                            <h5>Sélectionner une devise</h5>
                            <a className="nkp__close" href="#/">&times;</a>
                            <div className="text-center">
                                <div className="searchbar-box">
                                    <input type="text" className="nkp_input" name="searchbar" id="mySearchbar" placeholder="Search" onChange={handleSearchCurrency}/>
                                </div>
                                <div className='nkp__currency_list p-3'>
                                    {
                                        NkabSearchResult.length > 0 ? NkabSearchResult.map((currency)=>
                                            <a key={currency.id} href="#/" className='nkp_currency_item_container'>
                                                <div className='d-flex mb-3 nkp_currency_item' onClick={() => cureencyHandler2(currency.id)}>
                                                    <div><img src={`${currency.image}`} width="50" alt="nkab drapeau" /></div>
                                                    <div className='ml-2 nkp_currency_items'>
                                                        <span><strong>{currency.title}</strong></span><br/>
                                                        <span className='color-grey'>{currency.content}</span>
                                                    </div>
                                                </div>
                                            </a>
                                        ): currencyData.map((currency)=>
                                            <a key={currency.id} href="#/" className='nkp_currency_item_container'>
                                                <div className='d-flex mb-3 nkp_currency_item' onClick={() => cureencyHandler2(currency.id)}>
                                                    <div><img src={`${currency.image}`} width="50" alt="nkab drapeau" /></div>
                                                    <div className='ml-2 nkp_currency_items'>
                                                        <span><strong>{currency.title}</strong></span><br/>
                                                        <span className='color-grey'>{currency.content}</span>
                                                    </div>
                                                </div>
                                            </a>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                }

            </div>
            <Footer/>
        </div>
    </div>
  )
}

export default NkabPro